/**
 * Produkt-Konfigurator für Shopify
 * Primo Vero / pCon.ui
 *
 * Zielarchitektur:
 * - Ein globales pCon-Modal mit einem zentralen iframe.
 * - Keine produktbezogenen iframe-Modals als Hauptlösung mehr.
 * - Buttons liefern nur noch data-* Werte.
 * - pCon-URL wird beim Klick frisch aus dem geklickten Button gebaut.
 * - Reopen/Replace-Logik bleibt wie in der bewährten Live-Version erhalten.
 * - Bestehende Cart-Line wird erst gelöscht, nachdem die neue Variante sicher im Warenkorb ist.
 * - Konfigurierte Warenkorbprodukte können erneut geöffnet und ersetzt werden.
 * - Iframe lädt erst beim Öffnen.
 * - Auf Produktseiten wird ein bereits geladener iframe wiederverwendet, wenn die URL gleich bleibt.
 * - Auf Listen-/Collection-Seiten wird der iframe nach dem Schliessen zurückgesetzt.
 * - Auf Produktseiten wird der pCon-iframe nach Page Load / Idle kontrolliert vorgewärmt.
 * - Der Warmup läuft nicht bei Reopen-/Replace-Kontext, nicht bei Save-Data und nicht während Warenkorbflüssen.
 * - Kein aggressiver Origin-Fetch. Nur preconnect/dns-prefetch + kontrollierter iframe-Warmup.
 * - pCon-Runtime-Origins werden dynamisch vorgewärmt: ui, api, s3, gatekeeper, login.
 * - Debug misst zusätzlich pCon-Resource-Quiet-Zeit, weil iframe.onload nicht "Konfigurator nutzbar" bedeutet.
 * - Timing-Logs sind standardmässig aus und nur via localStorage aktivierbar:
 *   localStorage.setItem('pv_configurator_debug', 'true')
 */

(function () {
  if (window.__pvConfiguratorInit) return;
  window.__pvConfiguratorInit = true;

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const PV_CONTACT_PHONE_LABEL = '+41 76 523 50 49';
  const PV_CONTACT_PHONE_HREF = 'tel:+41765235049';
  const PV_CONTACT_EMAIL_LABEL = 'info@primovero.ch';
  const PV_CONTACT_EMAIL_HREF = 'mailto:info@primovero.ch';

  const PCON_UI_ORIGIN = 'https://ui.pcon-solutions.com';
  const PCON_ASSET_ORIGIN = 'https://s3.eaiws.pcon-solutions.com';
  const PCON_GATEKEEPER_ORIGIN = 'https://gatekeeper.eaiws.pcon-solutions.com';
  const PCON_LOGIN_ORIGIN = 'https://login.pcon-solutions.com';

  const PV_API_ORIGIN = 'https://api.primovero.ch';
  const PV_API_HOOK_URL = `${PV_API_ORIGIN}/index.cfm`;
  const PV_BEACON_URL = `${PV_API_ORIGIN}/beacon.cfm`;

  const PCON_GATEKEEPER_ID = '620cc856b0fe7';

  const PCON_MODAL_SELECTOR = '.modal[id^="pconui-modal-"]';

  // --- PV-Eigenkonfigurator (Weiche) ---
  // Hersteller in PV_KFG_MOCS oeffnen den EIGENEN W-CF-Konfigurator (3d.primovero.ch)
  // im selben Modal und mit demselben Cart-Flow (postMessage-Format identisch:
  // add_product mit product_id = Varianten-ID). Alle anderen Hersteller sowie alle
  // Re-Edit-/Reopen-Faelle laufen unveraendert ueber pCon.ui. Identitaet kommt aus den
  // bestehenden Button-Daten (moc, ban=sku, ovc, pid, ptype); moc->catalogId loest der
  // Konfigurator selbst per EAIWS auf. Rollout je Hersteller = moc hier ergaenzen.
  const PV_KFG_ORIGIN = 'https://3d.primovero.ch';
  const PV_KFG_VERSION = "konfigurator/v/0.5.55";
  // Fuer Sections ausserhalb dieses Skripts (Demo-Seite /pages/3d-konfigurator):
  // der Versionszeiger bleibt die EINE Quelle, niemand hartkodiert eine zweite.
  // Bewusst NACH der const — davor waere Temporal Dead Zone (der fruehere try
  // schluckte genau diese ReferenceError und window blieb leer).
  window.PV_KFG_VERSION = PV_KFG_VERSION;
  const PV_KFG_MOCS = ['MDD', 'GS', 'SE', 'AM', 'FM', 'FUNCTIONALS', 'GOTTARDO', 'IMPACT', 'NARFC', 'ZIZI', 'PROST', 'EXTREMIS', 'ERKE', 'TON', 'LEKLINT', 'GLIMA', 'GANDIABLASCO', 'LOOPE', 'SANC'];
  // Draft-Testphase: Produkte OHNE Opt-in-Metafeld oeffnen den PV-Konfigurator trotzdem
  // (hersteller-weit testen). Beim Live-Gang auf false stellen -> es zaehlt NUR noch das
  // Produkt-Metafeld custom.pv_konfigurator (data-pv-kfg="true"), Rest bleibt pCon.ui.
  const PV_KFG_TESTMODE = false;
  // Permanente Beleg-URLs UNSERES Konfigurators (pfadfoermig, Hook-sicher).
  const PV_OBX_PREFIX = 'https://api.primovero.ch/konfigurator/api/obx.cfm/';
  // ALTE pCon.ui-Positionen (Beleg unter /obx-reopen/): oeffnen ebenfalls im PV-Konfigurator.
  // Der Fetch laeuft ueber den obx-alt-Proxy (CORS von /obx-reopen/ erlaubt nur pCon.ui);
  // schlaegt der Import fehl, schwenkt pv_fail das Modal wie gehabt auf pCon.ui um.
  const PV_OBX_ALT_PREFIX = 'https://api.primovero.ch/obx-reopen/';
  const PV_OBX_ALT_PROXY = 'https://api.primovero.ch/konfigurator/api/obx-alt.cfm?id=';
  // Kuratierte START-Belege (custom.obx_url, z.B. 12 narbutas-Produkte wie «ACTIVE»):
  // frueher fiel deren data-obx in den Reopen-Zweig und schickte das Produkt zu pCon.ui
  // (Beda-Befund 17.07.). Jetzt laden sie via Proxy als Startkonfiguration im PV-Konfigurator.
  const PV_OBX_START_PREFIX = 'https://api.primovero.ch/obx/';
  const PV_OBX_START_PROXY = 'https://api.primovero.ch/konfigurator/api/obx-alt.cfm?src=start&id=';
  const GLOBAL_MODAL_ID = 'pconui-modal-global';
  const GLOBAL_IFRAME_ID = 'pconui-global-iframe';

  const PCON_ORIGINS = [
    PCON_UI_ORIGIN,
    PV_API_ORIGIN,
    // PV-Konfigurator-Host: preconnect spart den TLS-Handshake beim iframe-Warmup/Klick
    PV_KFG_ORIGIN,
    PCON_ASSET_ORIGIN,
    PCON_GATEKEEPER_ORIGIN,
    PCON_LOGIN_ORIGIN
  ];

  const PCON_RESOURCE_HOSTS = [
    'ui.pcon-solutions.com',
    's3.eaiws.pcon-solutions.com',
    'gatekeeper.eaiws.pcon-solutions.com',
    'login.pcon-solutions.com',
    'api.primovero.ch'
  ];

  const scrollPositions = {};
  let stickyButtonController = null;

  let __pconWarmed = false;

  let __iframeWarmupArmed = false;
  let __iframeWarmupStarted = false;
  let __iframeWarmupCompleted = false;
  let __iframeWarmupUrl = '';
  let __iframeWarmupTimer = null;

  let __overlayCount = 0;
  let __cartFlowActive = false;
  // 07.5 (Beda 21.08.): Zeigt der Konfigurator gerade eine EIGENE Ebene (Material-
  // Grossansicht, Details, Teilen, AR), dann ist unser Modal-Kreuz das auffaelligste
  // Kreuz auf dem Schirm — der Kunde greift danach und verliert die ganze
  // Konfiguration. Solange die Flagge steht, schliesst der erste Klick (Kreuz,
  // Backdrop, ESC) nur die INNERE Ebene. Der iframe meldet den Stand per pv_overlay.
  let __pvOverlayOpen = false;

  let __replaceCartContext = null;
  let __reopenAutoTriggered = false;
  let __activeModalState = null;

  let __bodyLocked = false;
  let __lockedScrollY = 0;

  // Lab-Tests (Lighthouse/PSI) interagieren nie mit der Seite. Ein rein
  // timer-basierter Warmup kann in deren Mess-Fenster laufen; echte Nutzer
  // scrollen oder bewegen den Pointer dagegen praktisch immer frueh.
  let __userInteracted = false;
  const __afterInteractionQueue = [];

  function runAfterFirstUserInteraction(callback) {
    if (__userInteracted) {
      callback();
      return;
    }

    __afterInteractionQueue.push(callback);
  }

  (function () {
    const markInteracted = () => {
      if (__userInteracted) return;
      __userInteracted = true;

      __afterInteractionQueue.splice(0).forEach(cb => {
        try {
          cb();
        } catch (e) {}
      });
    };

    ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll', 'mousemove'].forEach(evt => {
      window.addEventListener(evt, markInteracted, { once: true, passive: true, capture: true });
    });
  })();

  const DEBUG_TIMING = (() => {
    try {
      return window.localStorage && window.localStorage.getItem('pv_configurator_debug') === 'true';
    } catch (e) {
      return false;
    }
  })();

  window.__pvConfiguratorTimingSummaries = window.__pvConfiguratorTimingSummaries || [];
  window.__pvConfiguratorTimingEvents = window.__pvConfiguratorTimingEvents || [];

  let __flowSeq = 0;
  let __activeFlow = null;

  function newFlow(action, extra = {}) {
    __flowSeq += 1;

    return {
      id: `pv-${Date.now()}-${__flowSeq}`,
      action,
      startedAt: performance.now(),
      marks: [],
      meta: extra || {}
    };
  }

  function flowElapsed(flow) {
    if (!flow || typeof flow.startedAt !== 'number') return 0;
    return Math.round(performance.now() - flow.startedAt);
  }

  function pushTimingEvent(flow, type, label, data = null) {
    if (!DEBUG_TIMING || !flow) return;

    try {
      window.__pvConfiguratorTimingEvents.push({
        id: flow.id,
        action: flow.action,
        type,
        label,
        t: flowElapsed(flow),
        data: data || null
      });

      if (window.__pvConfiguratorTimingEvents.length > 700) {
        window.__pvConfiguratorTimingEvents.splice(0, window.__pvConfiguratorTimingEvents.length - 700);
      }
    } catch (e) {}
  }

  function flowMark(flow, label, data = null) {
    if (!DEBUG_TIMING || !flow) return;

    const elapsed = flowElapsed(flow);
    const entry = { label, t: elapsed, ...(data ? { data } : {}) };
    flow.marks.push(entry);
    pushTimingEvent(flow, 'mark', label, data);

    if (data) {
      console.log(`[ConfiguratorTiming][${flow.id}] ${label} @ ${elapsed}ms`, data);
    } else {
      console.log(`[ConfiguratorTiming][${flow.id}] ${label} @ ${elapsed}ms`);
    }
  }

  function flowWarn(flow, label, data = null) {
    if (!DEBUG_TIMING || !flow) return;

    const elapsed = flowElapsed(flow);
    pushTimingEvent(flow, 'warn', label, data);

    if (data) {
      console.warn(`[ConfiguratorTiming][${flow.id}] ${label} @ ${elapsed}ms`, data);
    } else {
      console.warn(`[ConfiguratorTiming][${flow.id}] ${label} @ ${elapsed}ms`);
    }
  }

  function flowError(flow, label, data = null) {
    if (!DEBUG_TIMING || !flow) return;

    const elapsed = flowElapsed(flow);
    pushTimingEvent(flow, 'error', label, data);

    if (data) {
      console.error(`[ConfiguratorTiming][${flow.id}] ${label} @ ${elapsed}ms`, data);
    } else {
      console.error(`[ConfiguratorTiming][${flow.id}] ${label} @ ${elapsed}ms`);
    }
  }

  function flowSummary(flow, status, data = null) {
    if (!DEBUG_TIMING || !flow) return;

    const elapsed = flowElapsed(flow);
    const summary = {
      id: flow.id,
      action: flow.action,
      status,
      totalMs: elapsed,
      meta: flow.meta,
      marks: flow.marks
    };

    if (data) summary.data = data;

    window.__pvConfiguratorTimingSummaries.push(summary);

    if (window.__pvConfiguratorTimingSummaries.length > 100) {
      window.__pvConfiguratorTimingSummaries.splice(0, window.__pvConfiguratorTimingSummaries.length - 100);
    }

    pushTimingEvent(flow, 'summary', `SUMMARY ${status}`, data);

    console.log(`[ConfiguratorTiming][${flow.id}] SUMMARY ${status} total=${elapsed}ms`, summary);
  }

  function setActiveFlow(flow) {
    __activeFlow = flow;
    return flow;
  }

  function clearActiveFlow(flow = null) {
    if (!flow || __activeFlow === flow) __activeFlow = null;
  }

  function isPconResourceName(name) {
    const value = String(name || '');

    return PCON_RESOURCE_HOSTS.some(host => value.includes(host));
  }

  function getPconResourceSnapshot(startTime = 0) {
    if (!performance || !performance.getEntriesByType) return [];

    try {
      return (performance.getEntriesByType('resource') || [])
        .filter(entry => {
          return (
            isPconResourceName(entry.name) &&
            typeof entry.startTime === 'number' &&
            entry.startTime >= startTime
          );
        })
        .slice(-80)
        .map(entry => ({
          name: String(entry.name || '').slice(0, 220),
          initiatorType: entry.initiatorType || '',
          startTime: Math.round(entry.startTime || 0),
          duration: Math.round(entry.duration || 0),
          transferSize: entry.transferSize || 0,
          encodedBodySize: entry.encodedBodySize || 0,
          decodedBodySize: entry.decodedBodySize || 0
        }));
    } catch (e) {
      return [];
    }
  }

  function startPconNetworkQuietTracker(flow, label = 'pcon-network', options = {}) {
    if (!DEBUG_TIMING || !flow) return null;

    const startTime = performance.now();
    const quietMs = Number(options.quietMs || 1400);
    const maxMs = Number(options.maxMs || 30000);
    const minMs = Number(options.minMs || 1800);

    let lastRelevantEnd = startTime;
    let relevantCount = 0;
    let stopped = false;
    let observer = null;
    let interval = null;
    let timeout = null;

    const stop = status => {
      if (stopped) return;
      stopped = true;

      if (observer) {
        try {
          observer.disconnect();
        } catch (e) {}
      }

      if (interval) clearInterval(interval);
      if (timeout) clearTimeout(timeout);

      const elapsed = Math.round(performance.now() - startTime);
      const snapshot = getPconResourceSnapshot(startTime);

      flowMark(flow, `${label} ${status}`, {
        elapsedMs: elapsed,
        relevantCount,
        quietMs,
        resources: snapshot
      });
    };

    const considerEntry = entry => {
      if (!entry || !isPconResourceName(entry.name)) return;

      relevantCount += 1;

      const end =
        Number(entry.responseEnd || 0) ||
        Number(entry.startTime || 0) + Number(entry.duration || 0) ||
        performance.now();

      if (end > lastRelevantEnd) {
        lastRelevantEnd = end;
      }
    };

    try {
      const existing = performance.getEntriesByType('resource') || [];
      existing.forEach(considerEntry);
    } catch (e) {}

    try {
      if ('PerformanceObserver' in window) {
        observer = new PerformanceObserver(list => {
          list.getEntries().forEach(considerEntry);
        });

        observer.observe({
          type: 'resource',
          buffered: true
        });
      }
    } catch (e) {}

    interval = setInterval(() => {
      const now = performance.now();
      const elapsed = now - startTime;
      const quietFor = now - lastRelevantEnd;

      if (elapsed >= minMs && quietFor >= quietMs) {
        stop('quiet');
      }
    }, 350);

    timeout = setTimeout(() => {
      stop('timeout');
    }, maxMs);

    flowMark(flow, `${label} tracker-start`, {
      quietMs,
      maxMs,
      minMs
    });

    return {
      stop
    };
  }

  window.pvConfiguratorTimingDump = function () {
    const summaries = window.__pvConfiguratorTimingSummaries || [];
    const rows = summaries.map(summary => ({
      id: summary.id,
      action: summary.action,
      status: summary.status,
      totalMs: summary.totalMs,
      productId: summary.meta && summary.meta.productId ? summary.meta.productId : '',
      buttonId: summary.meta && summary.meta.buttonId ? summary.meta.buttonId : '',
      sku: summary.meta && summary.meta.sku ? summary.meta.sku : '',
      moc: summary.meta && summary.meta.moc ? summary.meta.moc : ''
    }));

    if (rows.length) {
      console.table(rows);
    } else {
      console.info('[ConfiguratorTiming] Noch keine Timing-Summaries vorhanden.');
    }

    return {
      summaries,
      events: window.__pvConfiguratorTimingEvents || [],
      warmup: window.pvConfiguratorWarmupState(),
      recentPconResources: getPconResourceSnapshot(0).slice(-80)
    };
  };

  window.pvConfiguratorTimingClear = function () {
    window.__pvConfiguratorTimingSummaries = [];
    window.__pvConfiguratorTimingEvents = [];
    console.info('[ConfiguratorTiming] Timing-Daten gelöscht.');
  };

  window.pvConfiguratorWarmupState = function () {
    return {
      armed: __iframeWarmupArmed,
      started: __iframeWarmupStarted,
      completed: __iframeWarmupCompleted,
      url: __iframeWarmupUrl,
      pconWarmed: __pconWarmed,
      listWarmupArmed: __listWarmupArmed,
      listWarmupStarted: __listWarmupStarted,
      listWarmupIframeAlive: !!__listWarmupIframe,
      connection: getConnectionInfo()
    };
  };

  function getShopifyRoot() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : `${root}/`;
  }

  function buildShopifyUrl(path) {
    const cleanPath = String(path || '').replace(/^\/+/, '');
    return getShopifyRoot() + cleanPath;
  }

  function isProductPageContext() {
    return (
      document.body.classList.contains('product-template') ||
      document.body.classList.contains('template-product') ||
      window.location.pathname.includes('/products/') ||
      $('[id^="ProductInfo-"]') !== null ||
      $('[data-product-form]') !== null
    );
  }

  function getMainProductContainer() {
    return document.querySelector('[id^="ProductInfo-"]');
  }

  function getMainProductButtons() {
    const container = getMainProductContainer();
    if (!container) return [];

    return [...container.querySelectorAll('.open-configuration')];
  }

  function getCartContextFromButton(btn) {
    if (!btn || !btn.closest) return null;

    const cartRow = btn.closest('.cart-item');
    if (!cartRow) return null;

    const lineKey = cartRow.getAttribute('data-line-key') || '';
    const quantityRaw = cartRow.getAttribute('data-line-quantity') || '1';
    const quantity = Math.max(1, parseInt(quantityRaw, 10) || 1);

    return {
      lineKey,
      quantity,
      variantId: cartRow.getAttribute('data-variant-id') || '',
      productId: cartRow.getAttribute('data-product-id') || ''
    };
  }

  function getCartContextFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const lineKey = params.get('line_key') || '';
      const quantityRaw = params.get('line_qty') || '1';
      const quantity = Math.max(1, parseInt(quantityRaw, 10) || 1);

      if (!lineKey) return null;

      return {
        lineKey,
        quantity,
        variantId: params.get('old_variant_id') || '',
        productId: params.get('old_product_id') || ''
      };
    } catch (e) {
      return null;
    }
  }

  function hydrateReplaceCartContext() {
    if (__replaceCartContext && __replaceCartContext.lineKey) return;

    const urlContext = getCartContextFromUrl();

    if (urlContext && urlContext.lineKey) {
      __replaceCartContext = urlContext;
    }
  }

  function clearReplaceCartContext() {
    __replaceCartContext = null;
  }

  function getEffectiveReplaceContext() {
    if (__replaceCartContext && __replaceCartContext.lineKey) return __replaceCartContext;

    return getCartContextFromUrl();
  }

  function hasExplicitReopenContext() {
    try {
      const params = new URLSearchParams(window.location.search);

      return (
        params.has('line_key') ||
        params.has('line_qty') ||
        params.has('reopen') ||
        params.has('reopenurl') ||
        params.has('pvshare')
      );
    } catch (e) {
      return false;
    }
  }

  function isHiddenReopenProductPage() {
    // data-obx alleine kennzeichnet KEIN konfiguriertes Produkt, sondern nur
    // einen Start-OBX-Pfad (z.B. Narbutas-Produkte mit hinterlegter Start-Konfig).
    // Auto-Open darf nur bei echten Reopen-Signalen feuern: data-reopenurl (vom
    // CF-Backend gesetzt bei Hidden-Produkten) oder data-pv-configured.
    try {
      const mainButtons = getMainProductButtons();
      if (!mainButtons.length) return false;

      return mainButtons.some(btn => {
        return (
          btn.hasAttribute('data-reopenurl') ||
          btn.getAttribute('data-pv-configured') === 'true'
        );
      });
    } catch (e) {
      return false;
    }
  }

  function isTrustedMessageOrigin(origin) {
    if (!origin || origin === 'null') return false;

    return (
      origin === PCON_UI_ORIGIN ||
      origin === PV_KFG_ORIGIN ||
      origin === PV_API_ORIGIN ||
      origin === window.location.origin
    );
  }

  function warmPconConnections(flow = null) {
    flowMark(flow, 'warmPconConnections called', {
      alreadyWarmed: __pconWarmed
    });

    if (__pconWarmed) return;
    __pconWarmed = true;

    try {
      PCON_ORIGINS.forEach(origin => {
        if (!document.querySelector(`link[rel="preconnect"][href="${origin}"]`)) {
          const preconnect = document.createElement('link');
          preconnect.rel = 'preconnect';
          preconnect.href = origin;
          preconnect.crossOrigin = 'anonymous';
          document.head.appendChild(preconnect);
        }

        if (!document.querySelector(`link[rel="dns-prefetch"][href="${origin}"]`)) {
          const dnsPrefetch = document.createElement('link');
          dnsPrefetch.rel = 'dns-prefetch';
          dnsPrefetch.href = origin;
          document.head.appendChild(dnsPrefetch);
        }
      });

      flowMark(flow, 'pCon preconnect/dns-prefetch injected', {
        origins: PCON_ORIGINS
      });
    } catch (e) {
      flowWarn(flow, 'pCon connection warmup failed', {
        error: String(e && e.message ? e.message : e)
      });
    }
  }

  function getConnectionInfo() {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection ||
      null;

    return {
      saveData: !!(connection && connection.saveData),
      effectiveType: connection && connection.effectiveType ? String(connection.effectiveType) : '',
      downlink: connection && typeof connection.downlink === 'number' ? connection.downlink : null,
      rtt: connection && typeof connection.rtt === 'number' ? connection.rtt : null
    };
  }

  function shouldSkipIframeWarmup() {
    const info = getConnectionInfo();

    if (!isProductPageContext()) return true;
    if (hasExplicitReopenContext()) return true;
    if (isHiddenReopenProductPage()) return true;
    if (info.saveData) return true;
    if (__cartFlowActive) return true;

    return false;
  }

  function getIframeWarmupDelay() {
    const info = getConnectionInfo();

    const isTouch =
      window.matchMedia &&
      (
        window.matchMedia('(pointer: coarse)').matches ||
        window.matchMedia('(hover: none)').matches
      );

    if (info.effectiveType === 'slow-2g' || info.effectiveType === '2g') return 9000;
    if (info.effectiveType === '3g') return 3500;
    // 31.07.: 2800 -> 1400. Am Touch-Geraet gibt es keinen Hover-Intent-Pfad —
    // der Timer ist dort der einzige fruehe Ausloeser, und PSI/Lighthouse sind
    // bereits durch runAfterFirstUserInteraction ausgesperrt. Das load-Event
    // (alle Bilder) liegt ohnehin nach dem LCP-Fenster.
    // 20.08.: 1400 -> 700. Der Kaltstart braucht am 4G-Handy 6–7.5 s (gemessen,
    // _mobile_ladezeit.mjs; Feld: pcon_load_ok median 4.1 s / p90 7.6 s) — jede
    // frueher gestartete Vorwaermung erhoeht direkt den Anteil warmer (sofortiger)
    // Oeffnungen. Idle-Callback + Erst-Interaktions-Gate bleiben unveraendert.
    if (isTouch || window.innerWidth <= 768) return 700;

    return 2200;
  }

  function runWhenBrowserIdle(callback, timeout = 2500) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout });
      return;
    }

    setTimeout(callback, timeout);
  }

  function getWarmupTargetButton() {
    const mainButtons = getMainProductButtons();

    if (mainButtons.length) {
      return (
        mainButtons.find(btn => canBuildConfiguratorUrlFromButton(btn)) ||
        mainButtons[0]
      );
    }

    const allButtons = $$('.open-configuration');

    return (
      allButtons.find(btn => canBuildConfiguratorUrlFromButton(btn)) ||
      allButtons[0] ||
      null
    );
  }

  function startProductIframeWarmup(reason = 'idle') {
    if (__iframeWarmupStarted) return;
    if (shouldSkipIframeWarmup()) return;

    // Politur 20.07.: Nie warmen, waehrend ein echtes Modal offen ist — der Warmup
    // wuerde sonst das globale iframe unter dem Nutzer wegnavigieren.
    if (__activeModalState) return;

    const btn = getWarmupTargetButton();
    if (!btn) return;

    const runtime = ensureGlobalModal();
    if (!runtime || !runtime.modal || !runtime.iframe) return;

    const modal = runtime.modal;
    const iframe = runtime.iframe;
    const warmupUrl = buildFreshIframeUrl(btn, iframe);

    if (!warmupUrl) return;

    const normalizedWarmupUrl = normalizeConfiguratorUrlForCompare(warmupUrl);
    const currentSrc = normalizeConfiguratorUrlForCompare(iframe.getAttribute('src'));
    const loadedSrc = normalizeConfiguratorUrlForCompare(iframe.getAttribute('data-pv-loaded-src'));
    const requestedSrc = normalizeConfiguratorUrlForCompare(iframe.getAttribute('data-pv-requested-src'));

    if (
      loadedSrc === normalizedWarmupUrl ||
      currentSrc === normalizedWarmupUrl ||
      requestedSrc === normalizedWarmupUrl
    ) {
      return;
    }

    __iframeWarmupStarted = true;
    __iframeWarmupUrl = normalizedWarmupUrl;

    warmPconConnections();

    // GRAUE-BUEHNE-FIX (04.08.2026, Beda-Befund 03.08. am Ditch — trifft ALLE Produkte):
    // Bisher wurde hier `display:none` gesetzt. Ein display:none-Modal hat KEINE
    // Layout-Box, also ist der WebGL-Canvas im iframe 300x150 (Babylon-Default) und
    // die Kamera-Rahmung rechnet auf einer Nullflaeche. Beim spaeteren Einblenden
    // landete die Kameraposition auf NaN -> Modell vollstaendig geladen, Buehne grau
    // (gemessen: 0 von 10 Meshes im Sichtfeld, 0 % Modellpixel; weder Drehen noch
    // resize(true) heilt es). Jetzt waermt das Modal MIT echter Layoutgroesse vor,
    // aber unsichtbar (visibility) und interaktionslos (pointer-events) — die Buehne
    // bootet damit in genau der Groesse, in der sie danach angezeigt wird.
    // `data-pv-warming` markiert den Zustand, damit `display:block` nirgends als
    // «Modal ist offen» fehlgedeutet wird (Sticky-Button).
    modal.style.display = 'block';
    modal.style.visibility = 'hidden';
    modal.style.pointerEvents = 'none';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('data-pv-warming', '1');

    adjustModalContent(modal, iframe);

    iframe.setAttribute('data-src', normalizedWarmupUrl);
    iframe.setAttribute('data-pv-requested-src', normalizedWarmupUrl);
    iframe.setAttribute('data-pv-warmup-src', normalizedWarmupUrl);

    const warmupFlow = DEBUG_TIMING
      ? newFlow('iframe_warmup', {
          reason,
          url: normalizedWarmupUrl,
          connection: getConnectionInfo()
        })
      : null;

    flowMark(warmupFlow, 'iframe warmup start', {
      reason,
      url: normalizedWarmupUrl,
      connection: getConnectionInfo()
    });

    const quietTracker = startPconNetworkQuietTracker(warmupFlow, 'warmup-pcon-network', {
      quietMs: 1400,
      maxMs: 30000,
      minMs: 1800
    });

    iframe.addEventListener(
      'load',
      function () {
        const stillWarmup =
          normalizeConfiguratorUrlForCompare(iframe.getAttribute('data-pv-warmup-src')) === normalizedWarmupUrl &&
          normalizeConfiguratorUrlForCompare(iframe.getAttribute('src')) === normalizedWarmupUrl;

        if (!stillWarmup) return;

        iframe.setAttribute('data-pv-loaded-src', normalizedWarmupUrl);
        __iframeWarmupCompleted = true;

        flowMark(warmupFlow, 'iframe warmup onload', {
          url: normalizedWarmupUrl
        });

        flowSummary(warmupFlow, 'iframe-warmup-loaded', {
          resources: getPconResourceSnapshot(warmupFlow ? warmupFlow.startedAt : 0).slice(-60)
        });

        if (DEBUG_TIMING) {
          console.log('[ConfiguratorWarmup] iframe warmup loaded', {
            reason,
            url: normalizedWarmupUrl
          });
        }
      },
      { once: true }
    );

    if (DEBUG_TIMING) {
      console.log('[ConfiguratorWarmup] iframe warmup started', {
        reason,
        delay: getIframeWarmupDelay(),
        connection: getConnectionInfo(),
        url: normalizedWarmupUrl,
        quietTracker: !!quietTracker
      });
    }

    iframe.src = normalizedWarmupUrl;
  }

  function armProductIframeWarmup() {
    if (__iframeWarmupArmed) return;
    if (shouldSkipIframeWarmup()) return;

    __iframeWarmupArmed = true;

    const delay = getIframeWarmupDelay();

    const scheduleWarmup = () => {
      if (__iframeWarmupTimer) {
        clearTimeout(__iframeWarmupTimer);
        __iframeWarmupTimer = null;
      }

      __iframeWarmupTimer = setTimeout(() => {
        runWhenBrowserIdle(() => {
          if (document.hidden) return;

          // Erst nach der ersten echten Interaktion: macht den Warmup fuer
          // Lighthouse/PSI per Konstruktion unsichtbar, ohne echte Nutzer zu
          // verzoegern (deren Scroll/Pointer kommt vor Ablauf des Delays).
          runAfterFirstUserInteraction(() => {
            if (document.hidden) return;
            startProductIframeWarmup('delayed-idle');
          });
        }, 2500);
      }, delay);
    };

    if (document.readyState === 'complete') {
      scheduleWarmup();
    } else {
      window.addEventListener('load', scheduleWarmup, { once: true });
    }

    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden && __iframeWarmupArmed && !__iframeWarmupStarted) {
          scheduleWarmup();
        }
      },
      { passive: true }
    );
  }

  // 'pointerover' statt 'pointerenter': pointerenter bubblet nicht — ein
  // document-Listener sah das Event am Button nie, der Hover-Pfad war fuer
  // Maus-Nutzer tot (nur touchstart/focusin feuerten).
  ['pointerover', 'touchstart', 'focusin'].forEach(evt => {
    document.addEventListener(
      evt,
      ev => {
        const btn = ev.target && ev.target.closest ? ev.target.closest('.open-configuration') : null;
        if (!btn) return;

        warmPconConnections();
        pvLiefertageVorholen(btn); // PV 17.09.2026: Liefertage fuer Karten-/Warenkorb-Knoepfe vorholen

        if (isProductPageContext() && !__iframeWarmupStarted && !shouldSkipIframeWarmup()) {
          startProductIframeWarmup(`user-intent:${evt}`);
        }
      },
      { passive: true }
    );
  });

  window.addEventListener(
    'scroll',
    () => {
      if (!__pconWarmed && document.querySelector('.open-configuration')) {
        warmPconConnections();
      }
    },
    { passive: true, once: true }
  );

  // Touch-Ersatz fuer den Hover-Intent (Backlog iOS-Runde 2e, 31.07.): Steht der
  // Konfigurieren-Knopf im Sichtfenster, ist der Griff danach wahrscheinlich —
  // dann sofort waermen statt auf den Timer zu warten. Drei Schranken halten
  // Labor-Messungen und den Seitenaufbau sauber: erste ECHTE Interaktion
  // (runAfterFirstUserInteraction — PSI/Lighthouse interagieren nie), load-Event
  // (LCP ist durch) und die bestehenden Skip-Regeln (Save-Data, Reopen, Cartflow).
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (!isProductPageContext()) return;
    const buttons = $$('.open-configuration');
    if (!buttons.length) return;
    const io = new IntersectionObserver(entries => {
      if (!entries.some(e => e.isIntersecting)) return;
      io.disconnect();
      runAfterFirstUserInteraction(() => {
        const go = () => {
          if (!__iframeWarmupStarted && !shouldSkipIframeWarmup()) {
            startProductIframeWarmup('button-visible');
          }
        };
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true });
      });
    }, { threshold: 0.6 });
    buttons.forEach(btn => io.observe(btn));
  })();

  // ---------------------------------------------------------------------------
  // Listen-Warmup (Paket C): Auf Nicht-Produkt-Seiten mit Konfigurator-Buttons
  // (Collections, Recently-Viewed, Cart) wird nach der ersten echten Interaktion
  // einmalig ein verstecktes pCon-iframe mit GATEKEEPER-only-URL geladen und
  // danach wieder ENTFERNT: Die JS-Bundles/Assets liegen anschliessend im
  // HTTP-Cache (content-hashed, ~30 Tage); die Warmup-Session laeuft ohne
  // keepAlive ~5min nach dem Entfernen bei EG aus. frameRef isoliert die
  // Warmup-Session vom spaeteren echten Konfigurator (EG-Tipp bei mehreren
  // iframes pro Seite; Vorladen von EG ausdruecklich freigegeben: "keine
  // Kontingente, fair use", Ticket 7210944). Auf Produktseiten laeuft
  // stattdessen der praezisere Produkt-Warmup mit echter Produkt-URL.
  // ---------------------------------------------------------------------------

  let __listWarmupArmed = false;
  let __listWarmupStarted = false;
  let __listWarmupIframe = null;
  let __listWarmupTimers = [];

  function buildListWarmupUrl() {
    // Gleiche App-Flags wie die echte Konfigurator-URL (adv/ltt), damit der
    // Warmup denselben Bundle-Graph zieht — nur ohne Produktkontext und mit
    // frameRef zur Session-Isolation.
    return (
      `${PCON_UI_ORIGIN}/#GATEKEEPER_ID=${encodeURIComponent(PCON_GATEKEEPER_ID)}` +
      `&lang=de` +
      `&adv=modular` +
      `&ltt=true` +
      `&frameRef=pvlistwarm`
    );
  }

  function hasRecentListWarmupMemo() {
    try {
      const at = Number(sessionStorage.getItem('pv_list_warmup_at') || 0);
      return at > 0 && Date.now() - at < 6 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markListWarmupMemo() {
    try {
      sessionStorage.setItem('pv_list_warmup_at', String(Date.now()));
    } catch (e) {}
  }

  function shouldSkipListWarmup() {
    const info = getConnectionInfo();

    if (__listWarmupStarted) return true;
    if (isProductPageContext()) return true;
    if (!document.querySelector('.open-configuration')) return true;
    if (info.saveData) return true;
    if (info.effectiveType === 'slow-2g' || info.effectiveType === '2g') return true;
    if (__cartFlowActive) return true;
    if (__activeModalState) return true;

    // Einmal pro Tab-Session reicht: die Bundles sind content-hashed gecacht
    // (~30 Tage) — ohne Memo wuerde jede Listen-Navigation die komplette
    // pCon-Shell erneut hidden booten (CPU + eine EAIWS-Session pro Seite).
    if (hasRecentListWarmupMemo()) return true;

    // Stufe 1 bewusst nur Desktop: Android (partielle Site-Isolation) und
    // iOS/WebKit (kein OOPIF) parsen die ~1.8MB iframe-JS auf dem Main-Thread
    // der Seite — Feld-INP-Risiko auf den traffic-staerksten Seiten. Nach
    // CrUX-Review ggf. oeffnen.
    if (getConfiguratorInputMode() !== 'desktop') return true;

    // Theme-Editor-Preview nicht aufwaermen
    if (window.Shopify && window.Shopify.designMode) return true;

    return false;
  }

  function removeListWarmupIframe(reason = 'done') {
    __listWarmupTimers.splice(0).forEach(timer => clearTimeout(timer));

    if (!__listWarmupIframe) return;

    try {
      __listWarmupIframe.remove();
    } catch (e) {}

    __listWarmupIframe = null;

    sendFlowBeacon('list_warmup_done', { reason });
  }

  function startListWarmup(reason = 'idle') {
    if (shouldSkipListWarmup()) return;

    __listWarmupStarted = true;

    warmPconConnections();

    const iframe = document.createElement('iframe');
    iframe.id = 'pv-list-warmup-iframe';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('title', '');
    // Bewusst KEIN loading="lazy" — versteckte iframes wuerden damit nie laden.
    iframe.style.cssText = 'display:none !important;width:0;height:0;border:0;position:absolute;';

    // Entfernt wird erst deutlich NACH onload: Das load-Event meldet nur das
    // Dokument; die grossen Bundles laden danach weiter und sind in der
    // Parent-Performance-Timeline nicht beobachtbar (Cross-Origin-iframe).
    // Ein zu fruehes Entfernen wuerde laufende Downloads abbrechen — auf 3G
    // entsprechend laengerer Puffer.
    const removeAfterLoadMs = getConnectionInfo().effectiveType === '3g' ? 90000 : 35000;

    iframe.addEventListener(
      'load',
      () => {
        __listWarmupTimers.push(setTimeout(() => removeListWarmupIframe('loaded'), removeAfterLoadMs));
      },
      { once: true }
    );

    // Harte Grenze, falls onload nie feuert
    __listWarmupTimers.push(setTimeout(() => removeListWarmupIframe('hard-timeout'), removeAfterLoadMs + 30000));

    iframe.src = buildListWarmupUrl();
    document.body.appendChild(iframe);
    __listWarmupIframe = iframe;

    markListWarmupMemo();

    sendFlowBeacon('list_warmup_start', { reason });
  }

  function armListWarmup() {
    // Welle 2 (06.09.2026, Fremdaudit F12): STILLGELEGT. Der Listen-Warmup lud auf
    // Kollektionsseiten ein unsichtbares pCon.ui-iframe (ui.pcon-solutions.com) - die
    // Produkte oeffnen aber den eigenen Konfigurator auf 3d.primovero.ch. Das Vorwaermen
    // traf den falschen Konfigurator und kostete je Desktop-Besucher und sechs Stunden
    // eine Gatekeeper-Sitzung. Der Produktseiten-Warmup (armProductIframeWarmup) bleibt.
    return;
    if (__listWarmupArmed) return;
    if (shouldSkipListWarmup()) return;

    __listWarmupArmed = true;

    const delay = getIframeWarmupDelay();

    const schedule = () => {
      setTimeout(() => {
        runWhenBrowserIdle(() => {
          if (document.hidden) return;

          // Wie beim Produkt-Warmup: erst nach echter Interaktion —
          // fuer Lighthouse/PSI per Konstruktion unsichtbar.
          runAfterFirstUserInteraction(() => {
            if (document.hidden) return;
            startListWarmup('delayed-idle');
          });
        }, 2500);
      }, delay);
    };

    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }

    // Hintergrund-Tab-Fall (z.B. Collection per Mittelklick geoeffnet): feuert
    // die Idle-Kette waehrend document.hidden, ist sie konsumiert — beim
    // Sichtbarwerden neu planen, wie es der Produktseiten-Warmup auch tut.
    // Mehrfache Ketten sind harmlos: startListWarmup skippt via
    // __listWarmupStarted, ein zweites iframe kann nicht entstehen.
    document.addEventListener(
      'visibilitychange',
      () => {
        if (!document.hidden && __listWarmupArmed && !__listWarmupStarted) {
          schedule();
        }
      },
      { passive: true }
    );
  }

  function showLoadingOverlay(text = null) {
    __overlayCount++;

    let wrap = document.getElementById('loadingDiv');

    if (!wrap) {
      // Designsprache wie das Lade-UI im Modal (Glas-Panel + Wave-Linie).
      // Kritische Blocker-Styles bleiben inline, damit das Overlay auch ohne
      // geladene CSS-Datei zuverlaessig vollflaechig sperrt — der Rest kommt
      // aus product-configurator.css (.pv-cart-overlay*).
      wrap = document.createElement('div');
      wrap.id = 'loadingDiv';
      wrap.className = 'pv-cart-overlay';
      wrap.setAttribute('role', 'status');
      wrap.setAttribute('aria-live', 'polite');
      wrap.style.cssText = `
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        position: fixed !important;
        z-index: 2147483647 !important;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        inset: 0 !important;
        padding: 24px !important;
        box-sizing: border-box !important;
        background: rgba(255, 255, 255, 0.9);
        pointer-events: auto !important;
      `;

      const panel = document.createElement('div');
      panel.className = 'pv-cart-overlay__panel';

      const label = document.createElement('div');
      label.className = 'pv-cart-overlay__label';
      label.id = 'loadingDivLabel';
      if (text) label.textContent = text;

      const bar = document.createElement('div');
      bar.className = 'pv-cart-overlay__bar';
      bar.appendChild(document.createElement('span'));

      panel.appendChild(label);
      panel.appendChild(bar);
      wrap.appendChild(panel);
      document.body.appendChild(wrap);
    } else {
      wrap.style.display = 'flex';
      wrap.style.zIndex = '2147483647';

      if (text) {
        const label = document.getElementById('loadingDivLabel');
        if (label) label.textContent = text;
      }
    }
  }

  function hideLoadingOverlay(force = false) {
    if (!force) __overlayCount = Math.max(0, __overlayCount - 1);
    if (!force && __overlayCount > 0) return;

    __overlayCount = 0;

    const el = document.getElementById('loadingDiv');
    if (el) el.remove();
  }

  window.addEventListener('pagehide', () => {
    hideLoadingOverlay(true);
    // Seite verlassen mit OFFENEM Konfigurator-Modal: der sendBeacon in
    // pvSendKfgModalClose ueberlebt das Entladen (gtag dagegen best effort).
    try { pvSendKfgModalClose('pagehide'); } catch (e) {}
    // Seite verlassen WAEHREND der Konfigurator noch laedt: als Lade-Abbruch
    // zaehlen (20.08.) — der Beacon ueberlebt das Entladen.
    try { abortPconLoadWatch('pagehide'); } catch (e) {}
  });

  // --- GA4-Bruecke (Beda 20.07., verifizierter Weg): NUR die kfg_*-Konfigurator-Events
  // an die GA4-Property der Google-App — im Seitenkontext (gleicher _ga-Cookie wie der
  // App-Pixel -> Events landen in denselben Sitzungen, Kampagnen-Attribution moeglich).
  // send_page_view:false => KEIN zusaetzlicher Seitenaufruf; Commerce-Events sendet
  // weiterhin ausschliesslich der Google-App-Pixel. Consent-Best-Effort: Privacy-API,
  // sonst _tracking_consent-Cookie, sonst Status quo der Seite (wie der Ads-Lead-Tag).
  const PV_GA4_ID = 'G-6JJBQM12BC';
  let __pvGa4Ready = false;

  // PV 17.08. (Beda: «Interaktion wird nicht gemessen»): Das iframe-eigene kfg_close
  // erreicht GA4/PMS nur in ~1/4 der Sitzungen — closeConfiguratorModal versteckt das
  // Modal nur (display:none), das echte close feuert erst beim Seiten-pagehide und
  // der Empfaenger stirbt dann meist mit; resetGlobalIframe zerstoert das Dokument
  // ganz ohne pagehide. Das Theme sieht das Modal-Schliessen dagegen zuverlaessig:
  // kfg_modal_close traegt Verweildauer + letztbekannten Stand aus dem iframe.
  let __pvKfgModalOpenedAt = 0;
  let __pvKfgLast = null; // letzte pv_metric-Payload des iframes (metric/n/cat/ban)
  // WARMUP-PHANTOM-GATE (20.08.): Vorwaerm-iframes durchlaufen den kompletten Ladeweg
  // und melden «open»/«close», ohne dass je ein Kunde geklickt hat — mobil bestanden
  // dadurch 89 von 120 kfg_open-Sitzungen (PMS 17.–20.08.) nur aus dem Open, und die
  // Absprungrate des Konfigurators war zu einem grossen Teil ein Messartefakt.
  let __pvKfgEverOpened = false;   // wurde das Modal in diesem Seitenaufruf je geoeffnet?
  // PHANTOM-CLOSE-FIX (22.08., Beda: «close ohne open in der Live-Ansicht»): Das Gate
  // unten verlangte bisher, dass eine Meldung nachweislich aus dem globalen Modal-iframe
  // stammt. Beim SCHLIESSEN ist dieses Element aber meist schon abgeraeumt, die Zuordnung
  // schlaegt fehl und das Vorwaermer-close lief durch: 43 von 52 kfg_close waren Phantome
  // (meta.nth = 0), ihr dwell mass die Verweildauer auf der PRODUKTSEITE, bis zu 6 h.
  // Dieser Merker haengt am ZUSTAND des Seitenaufrufs statt am DOM und ueberlebt das
  // Abraeumen des iframes.
  let __pvKfgZaehlbar = false;
  let __pvKfgPrewarmLast = null;   // letzte (verworfene) Warmup-Payload — Quelle fuers warme Nachmelden
  let __pvKfgClickSrc = null;      // 'sticky'/'reopen': gesetzt unmittelbar vor btn.click()
  let __pvKfgOpenSentAt = 0;       // Doppelklick-Dedupe fuer pvSendKfgOpen

  // Klickquelle fuer kfg_open (Beda 20.08., «sticky vs. main»): Sticky/Reopen kommen
  // per Marker, Cart-Linien am data-line-key, Karten-Buttons an der product-card-
  // Klasse; auf der Produktseite bleibt 'main', sonst 'card' (Listen/Zuletzt-gesehen).
  // ---- Liefertage fuer Knoepfe ausserhalb der Produktseite (PV 17.09.2026) ----
  // `data-deliver-days` traegt nur der Knopf der Produktseite (Vorlagen-Block `shipping`,
  // Metafeld custom.deliver_days). Kollektionskarten, Suche, Warenkorb und «Zuletzt
  // angesehen» oeffneten den Konfigurator ohne — er zeigte dort «Lieferzeit auf Anfrage»
  // (Beda 17.09., Natura Terra: Produktseite fuehrt dd=35). Liquid kann die Vorlage eines
  // fremden Produkts nicht lesen, also holt das Theme den Wert von der Produktseite selbst:
  // same-origin, als Stream nur bis zum Treffer gelesen, je URL einmal je Seitenaufruf.
  // EINE Quelle bleibt die Produktvorlage; hier steht keine zweite Tabelle.
  const __pvLiefertageCache = new Map();
  let __pvLiefertageKnopf = null;

  function pvLiefertageBekannt(btn) {
    return /^\d{1,3}$/.test(((btn && btn.getAttribute('data-deliver-days')) || '').trim());
  }

  function pvLiefertageHolen(purl) {
    if (__pvLiefertageCache.has(purl)) return __pvLiefertageCache.get(purl);
    const p = (async () => {
      const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      try {
        const res = await fetch(purl, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined });
        if (!res.ok) return '';
        const re = /data-deliver-days="(\d{0,3})"/;
        if (!res.body || !res.body.getReader) {
          const m = (await res.text()).match(re);
          return m ? m[1] : '';
        }
        const reader = res.body.getReader();
        const dec = new TextDecoder();
        let buf = '';
        for (;;) {
          const { value, done } = await reader.read();
          if (value) buf += dec.decode(value, { stream: true });
          const m = buf.match(re);
          if (m) {
            try { if (ctrl) ctrl.abort(); } catch (abortErr) {}
            return m[1];
          }
          if (done) return '';
          if (buf.length > 60000) buf = buf.slice(-4000);
        }
      } catch (fetchErr) { return ''; }
    })();
    __pvLiefertageCache.set(purl, p);
    return p;
  }

  // Vorgriff bei Absicht (Hover/Touch/Fokus) und beim Klick; setzt das Attribut am Knopf,
  // damit buildPvKfgUrlFromButton den Wert wie auf der Produktseite als &dd= mitgibt.
  function pvLiefertageVorholen(btn) {
    try {
      if (!btn || pvLiefertageBekannt(btn)) return null;
      if (btn.__pvLiefertage) return btn.__pvLiefertage;
      let purl = getButtonConfiguratorData(btn).purl;
      if (!purl) {
        // Warenkorb (main-cart.liquid): die Zeile ist ein <tr class="cart-item">, das kennt getButtonConfiguratorData
        // nicht — Produktlink der Zeile nehmen (das Warenkorb-Produkt erbt die Vorlage samt shipping-Block).
        const zeile = btn.closest('tr.cart-item, .cart-item');
        const a = zeile ? zeile.querySelector('a[href*="/products/"]') : null;
        if (a) { try { const u = new URL(a.getAttribute('href'), location.origin); purl = u.origin + u.pathname.replace(/\/$/, ''); } catch (urlErr) {} }
      }
      if (!purl || !/\/products\//.test(purl)) return null;
      btn.__pvLiefertage = pvLiefertageHolen(purl).then(v => {
        if (v && !pvLiefertageBekannt(btn)) btn.setAttribute('data-deliver-days', v);
        return v;
      });
      return btn.__pvLiefertage;
    } catch (ddErr) { return null; }
  }

  // Klick: den laufenden Vorgriff kurz abwarten (Deckel 1000 ms — eine Karte darf nicht an
  // ihrer Produktseite haengen); die Klickquelle (sticky/reopen) ueber die Wartezeit retten.
  function pvOeffnenMitLiefertagen(btn) {
    __pvLiefertageKnopf = btn;
    const p = pvLiefertageVorholen(btn);
    if (!p || pvLiefertageBekannt(btn)) { openConfigurator(btn); return; }
    const src = __pvKfgClickSrc;
    let fertig = false;
    const weiter = () => {
      if (fertig) return;
      fertig = true;
      const alt = __pvKfgClickSrc;
      __pvKfgClickSrc = src;
      try { openConfigurator(btn); } finally { __pvKfgClickSrc = alt; }
    };
    p.then(weiter, weiter);
    setTimeout(weiter, 1000);
  }

  // Antwort auf pv_ddq des Konfigurators (ab 0.5.39): Wert des zuletzt geklickten Knopfs —
  // sofort, wenn bekannt, sonst sobald der Vorgriff da ist (auch nach dem ersten Preis).
  function pvLiefertageAntworten(quelle) {
    const btn = __pvLiefertageKnopf;
    if (!btn || !quelle || !quelle.postMessage) return;
    const senden = v => {
      try {
        if (/^\d{1,3}$/.test(String(v || ''))) quelle.postMessage({ action: 'pv_dd', dd: String(v) }, PV_KFG_ORIGIN);
      } catch (ddPostErr) {}
    };
    if (pvLiefertageBekannt(btn)) { senden(btn.getAttribute('data-deliver-days').trim()); return; }
    const p = pvLiefertageVorholen(btn);
    if (p) p.then(senden);
  }

  function pvKfgOpenSrcFuer(btn) {
    try {
      if (__pvKfgClickSrc) return __pvKfgClickSrc;
      const cart = getCartContextFromButton(btn);
      if (cart && cart.lineKey) return 'cart';
      if (btn && btn.closest && btn.closest('.product-card')) return 'card';
      return isProductPageContext() ? 'main' : 'card';
    } catch (srcErr) { return 'main'; }
  }

  // Sichtbarkeitstest der Meldequelle (22.08.): Vorwaerm-iframes sind unsichtbar (0x0
  // bzw. ausserhalb des Layouts), sichtbare Einbettungen wie die Demo-Seite haben eine
  // echte Flaeche. Im Zweifel «nicht sichtbar» — lieber ein echtes Ereignis verlieren
  // als die Statistik mit Phantomen fluten.
  function pvKfgQuelleSichtbar(srcWin) {
    try {
      if (!srcWin) return false;
      const frames = document.getElementsByTagName('iframe');
      for (let i = 0; i < frames.length; i++) {
        if (frames[i].contentWindow === srcWin) {
          const r = frames[i].getBoundingClientRect();
          return r.width > 80 && r.height > 80;
        }
      }
    } catch (sichtErr) {}
    return false;
  }

  function pvSendKfgModalClose(reason) {
    // Welle 3a: meta.reason = close|pagehide (Feldname mit der PMS-Auswertung vereinbart, 06.09.2026)
    if (!__pvKfgModalOpenedAt) return;
    const dwell = Date.now() - __pvKfgModalOpenedAt;
    __pvKfgModalOpenedAt = 0;

    try {
      let kfgSid = sessionStorage.getItem('pv_kfg_sid');

      if (!kfgSid) {
        kfgSid = window.crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : String(Date.now()) + Math.random().toString(16).slice(2);
        sessionStorage.setItem('pv_kfg_sid', kfgSid);
      }

      const nth = parseInt(sessionStorage.getItem('pv_kfg_nth') || '0', 10) || 0;
      const last = __pvKfgLast || {};

      // meta bewusst in der bestehenden /collect-Form (cat/ban/nth/n/err) — kein
      // neues Feld, damit der PMS-Endpoint nichts verwerfen muss.
      if (navigator.sendBeacon) {
        navigator.sendBeacon('https://pms.primovero.ch/collect', new Blob([JSON.stringify({
          src: 'shop',
          t: 'kfg_modal_close',
          sid: kfgSid,
          path: location.pathname,
          dwell: dwell > 0 ? Math.min(dwell, 21600000) : null,
          meta: {
            cat: String(last.cat || '').slice(0, 24),
            ban: String(last.ban || '').slice(0, 40),
            nth: nth,
            n: Number(last.n) >= 0 ? Math.min(Number(last.n), 9999) : 0,
            err: '',
            reason: String(reason || 'close').slice(0, 12)
          }
        })], { type: 'text/plain' }));
      }

      try {
        if (pvGa4Allowed()) {
          pvEnsureGa4();

          window.gtag('event', 'kfg_modal_close', {
            send_to: PV_GA4_ID,
            kfg_cat: String(last.cat || '').slice(0, 24),
            kfg_ban: String(last.ban || '').slice(0, 40),
            kfg_nth: nth,
            kfg_changes: Number(last.n) >= 0 ? Math.min(Number(last.n), 9999) : 0,
            kfg_dwell_ms: dwell > 0 ? Math.min(dwell, 21600000) : 0,
            kfg_last: String(last.metric || '').slice(0, 24)
          });
        }
      } catch (ga4Err) {}
    } catch (e) {}
  }

  // Ehrliches kfg_open BEIM KLICK (20.08., Beda: «soll feuern, sobald jemand auf
  // ‹Jetzt konfigurieren› klickt»): das Theme meldet das Oeffnen selbst — warm wie
  // kalt — im Moment, in dem das Modal sichtbar wird. Das iframe-eigene «open»
  // (erst bei sichtbarer Geometrie) zaehlt NICHT mehr als kfg_open, sonst bliebe
  // jeder Ladeabbruch im Funnel unsichtbar; Ladezeiten tragen pcon_load_ok/-abort.
  // meta.warm: 1 = vorgewaermtes iframe wiederverwendet (sofort da), 0 = kalter Load.
  // meta.src: main|sticky|card|cart|reopen — welcher Knopf die Sitzung startete.
  function pvSendKfgOpen(btnData, warm, quelle, fehler) {
    try {
      // Doppelklick-Dedupe: zwei Klicks, die beide noch VOR dem ersten
      // setTimeout-Lauf verarbeitet werden (Main-Thread-Jank), erzeugten sonst
      // zwei kfg_open fuer EINE Sitzung.
      const jetztMs = Date.now();
      if (jetztMs - __pvKfgOpenSentAt < 500) return;
      __pvKfgOpenSentAt = jetztMs;

      let kfgSid = sessionStorage.getItem('pv_kfg_sid');

      if (!kfgSid) {
        kfgSid = window.crypto && crypto.randomUUID
          ? crypto.randomUUID()
          : String(Date.now()) + Math.random().toString(16).slice(2);
        sessionStorage.setItem('pv_kfg_sid', kfgSid);
      }

      const kfgNth = (parseInt(sessionStorage.getItem('pv_kfg_nth') || '0', 10) || 0) + 1;
      sessionStorage.setItem('pv_kfg_nth', String(kfgNth));

      // cat fuehrt NUR das EAIWS-Katalog-Vokabular des iframes (z.B. «gsx:0») —
      // beim kalten Klick noch unbekannt, dann bewusst LEER statt das moc-Kuerzel
      // («GS») einzumischen (Vokabularbruch). Der Hersteller steht stabil in
      // meta.moc, die Artikelnummer in ban (Warmup-Payload > Button-SKU).
      const last = (warm && __pvKfgPrewarmLast) || {};
      const cat = String(last.cat || '').slice(0, 24);
      const ban = String(last.ban || (btnData && btnData.sku) || '').slice(0, 40);
      const moc = String((btnData && btnData.moc) || '').slice(0, 16);

      // Stand fuer kfg_modal_close: die Sitzung beginnt mit 0 Aenderungen.
      __pvKfgLast = { metric: 'open', n: 0, cat: cat, ban: ban };

      if (navigator.sendBeacon) {
        navigator.sendBeacon('https://pms.primovero.ch/collect', new Blob([JSON.stringify({
          src: 'shop',
          t: 'kfg_open',
          sid: kfgSid,
          path: location.pathname,
          dwell: null,
          meta: { cat: cat, ban: ban, moc: moc, nth: kfgNth, n: 0, err: String(fehler || '').slice(0, 120), warm: warm ? 1 : 0, src: String(quelle || '').slice(0, 12) }
        })], { type: 'text/plain' }));
      }

      try {
        if (pvGa4Allowed()) {
          pvEnsureGa4();

          window.gtag('event', 'kfg_open', {
            send_to: PV_GA4_ID,
            kfg_cat: cat,
            kfg_ban: ban,
            kfg_moc: moc,
            kfg_nth: kfgNth,
            kfg_changes: 0,
            kfg_err: String(fehler || '').slice(0, 100),
            kfg_src: String(quelle || '').slice(0, 12),
            kfg_warm: warm ? 1 : 0
          });
        }
      } catch (ga4Err) {}
    } catch (e) {}
  }

  function pvGa4Allowed() {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;

      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() !== false;
      }
    } catch (cpErr) {}

    try {
      const raw = document.cookie.split('; ').find(c => c.indexOf('_tracking_consent=') === 0);

      if (raw) {
        const consent = JSON.parse(decodeURIComponent(raw.slice(raw.indexOf('=') + 1)));
        const analytics = consent && consent.con && consent.con.CMP && consent.con.CMP.a;
        if (analytics === '0') return false; // explizit abgelehnt
      }
    } catch (cookieErr) {}

    return true;
  }

  function pvEnsureGa4() {
    if (__pvGa4Ready) return;

    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }

    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + PV_GA4_ID;
      document.head.appendChild(s);
    }

    window.gtag('js', new Date());
    window.gtag('config', PV_GA4_ID, { send_page_view: false });

    __pvGa4Ready = true;
  }

  // --- PV Glass-Cart-Flow (20.07.): EIN kohaerentes Lade-UI ab Klick im Konfigurator.
  // Der teuerste Teil (OBX-Export + Beleg + Shopify-Produktanlage) laeuft VOR add_product
  // und hatte bisher kein Theme-Feedback ("toter Button" fuer 3-6s). Stufen mit definiertem
  // Fortschritt statt Endlos-Welle — wirkt schneller und ist ehrlich. Der PV-Konfigurator
  // meldet cart_flow_started/cart_flow_failed (ab 0.2.52); der alte pCon.ui-OCI-Hook kennt
  // beides nicht und steigt kompatibel erst bei add_product ein.
  let __cartPreflightTimer = null;
  let __cartCreepTimer = null;
  // F17 (Codex-Gegenanalyse, 28.09.2026): Zeitpunkt von cart_flow_started, solange die Speicherrunde
  // laeuft (0 = keine). Bis add_product, replace_cart_line, cart_flow_failed oder error eintrifft,
  // loescht closeConfiguratorModal den Bearbeitungskontext nicht (Escape waehrend des Speicherns
  // machte sonst aus dem Ersetzen ein Hinzufuegen, die alte Zeile blieb stehen). Nach 45 s verfaellt
  // der Merker wie das Sicherheitsnetz __cartPreflightTimer.
  let __pvSpeicherRundeSeit = 0;

  const CART_FLOW_STAGES = {
    saving: { text: 'Ihre Konfiguration wird gespeichert …', progress: 35, creepTo: 62 },
    saving_replace: { text: 'Ihre Änderungen werden gespeichert …', progress: 35, creepTo: 62 },
    adding: { text: 'Wird in den Warenkorb gelegt …', progress: 78 },
    replacing: { text: 'Der Warenkorb wird aktualisiert …', progress: 78 },
    opening: { text: 'Der Warenkorb wird geöffnet …', progress: 96 }
  };

  function clearCartPreflightTimer() {
    if (__cartPreflightTimer) {
      clearTimeout(__cartPreflightTimer);
      __cartPreflightTimer = null;
    }
  }

  function showCartFlowStage(stage) {
    const def = CART_FLOW_STAGES[stage];

    if (!def) {
      showLoadingOverlay(null);
      return;
    }

    showLoadingOverlay(null);

    const wrap = document.getElementById('loadingDiv');
    if (!wrap) return;

    wrap.classList.add('pv-cart-overlay--flow');

    // Produktzeile (einmalig) macht das Panel persoenlich («se:joy» statt anonym)
    const panel = wrap.querySelector('.pv-cart-overlay__panel');
    const productTitle = (__activeModalState && __activeModalState.productTitle) || '';

    if (panel && productTitle && !panel.querySelector('.pv-cart-overlay__product')) {
      const sub = document.createElement('div');
      sub.className = 'pv-cart-overlay__product';
      sub.textContent = productTitle;
      panel.insertBefore(sub, panel.firstChild);
    }

    const label = document.getElementById('loadingDivLabel');

    if (label && label.textContent !== def.text) {
      label.classList.remove('is-swap');
      void label.offsetWidth; // Animation-Restart fuer den Textwechsel
      label.textContent = def.text;
      label.classList.add('is-swap');
    }

    // Definierter Fortschritt; geht nie rueckwaerts. In der langen Speicher-Phase
    // kriecht die Linie langsam weiter (lebendig, ohne falsche Versprechen).
    const barSpan = wrap.querySelector('.pv-cart-overlay__bar span');

    if (barSpan) {
      if (__cartCreepTimer) {
        clearTimeout(__cartCreepTimer);
        __cartCreepTimer = null;
      }

      const current = parseFloat(barSpan.style.width) || 0;

      barSpan.style.transition = 'width 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
      barSpan.style.width = Math.max(current, def.progress) + '%';

      if (def.creepTo) {
        __cartCreepTimer = setTimeout(() => {
          __cartCreepTimer = null;
          barSpan.style.transition = 'width 9s linear';
          barSpan.style.width = def.creepTo + '%';
        }, 700);
      }
    }
  }

  // bfcache-Restore (Zurueck-Navigation z.B. von /cart): Der eingefrorene
  // Cart-Flow-Zustand muss zurueckgesetzt werden, sonst bleiben ESC-Close,
  // iframe-Warmup und Overlay-Hide dauerhaft blockiert und der Body gesperrt.
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;

    __cartFlowActive = false;
    hideLoadingOverlay(true);

    const restoredModal = __activeModalState && __activeModalState.modal;

    if (restoredModal) {
      closeConfiguratorModal(restoredModal);
    } else {
      unlockBody();
    }
  });

  function getConfiguratorInputMode() {
    const hasCoarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const hasNoHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
    const hasTouchPoints = navigator.maxTouchPoints && navigator.maxTouchPoints > 0;
    const smallOrMediumViewport = window.innerWidth <= 1024;

    if (hasCoarsePointer) return 'touch';
    if (hasNoHover && smallOrMediumViewport) return 'touch';
    if (hasTouchPoints && smallOrMediumViewport) return 'touch';

    return 'desktop';
  }

  function markConfiguratorGuideSeen() {
    try {
      localStorage.setItem('pv_pcon_guide_seen_v2', 'true');
    } catch (e) {}
  }

  function modalShowsPvKfg(modal) {
    // PV-Konfigurator bringt seine EIGENE Bedienhilfe im Header mit — der pCon.ui-Guide
    // und dessen ?-Button wuerden doppelt erscheinen (Beda-Befund 17.07.).
    const ifr = modal && modal.querySelector('iframe');
    const src = ifr ? String(ifr.src || ifr.getAttribute('data-src') || '') : '';
    return src.indexOf(PV_KFG_ORIGIN) === 0;
  }

  function ensureConfiguratorHelpButton(modal) {
    if (!modal) return null;

    const modalContent = modal.querySelector('.modal-content');
    if (!modalContent) return null;

    let helpButton = modalContent.querySelector('.pv-pcon-help');

    if (modalShowsPvKfg(modal)) {
      if (helpButton) helpButton.style.display = 'none';
      return null;
    }
    if (helpButton) { helpButton.style.display = ''; return helpButton; }

    helpButton = document.createElement('button');
    helpButton.type = 'button';
    helpButton.className = 'pv-pcon-help';
    helpButton.setAttribute('aria-label', 'Hilfe zur Bedienung öffnen');
    helpButton.setAttribute('title', 'Hilfe zur Bedienung');
    helpButton.innerHTML = '<span aria-hidden="true">?</span>';

    helpButton.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();

      helpButton.classList.remove('is-attention');

      createConfiguratorGuide(modal, {
        force: true,
        highlightHelpAfterClose: false
      });
    });

    modalContent.appendChild(helpButton);

    return helpButton;
  }

  function highlightConfiguratorHelpButton(modal) {
    const helpButton = ensureConfiguratorHelpButton(modal);
    if (!helpButton) return;

    helpButton.classList.remove('is-attention');

    window.requestAnimationFrame(() => {
      helpButton.classList.add('is-attention');

      setTimeout(() => {
        helpButton.classList.remove('is-attention');
      }, 1800);
    });
  }

  function getConfiguratorGuideItems(mode) {
    if (mode === 'touch') {
      return `
        <div class="pv-pcon-guide__item">
          <strong>Ausführung wählen</strong>
          <span>Tippen Sie die gewünschten Optionen, Farben und Materialien an.</span>
        </div>
        <div class="pv-pcon-guide__item">
          <strong>Produkt ansehen</strong>
          <span>Drehen Sie das Produkt mit einem Finger.</span>
        </div>
        <div class="pv-pcon-guide__item">
          <strong>Ansicht vergrössern</strong>
          <span>Zoomen Sie mit zwei Fingern auseinander oder zusammen.</span>
        </div>
        <div class="pv-pcon-guide__item">
          <strong>Preis & Warenkorb</strong>
          <span>Der Preis wird anhand Ihrer Auswahl aktualisiert. Anschliessend legen Sie die Konfiguration in den Warenkorb.</span>
        </div>
      `;
    }

    return `
      <div class="pv-pcon-guide__item">
        <strong>Ausführung wählen</strong>
        <span>Wählen Sie rechts die gewünschte Ausführung, Farben, Materialien und Optionen.</span>
      </div>
      <div class="pv-pcon-guide__item">
        <strong>Produkt ansehen</strong>
        <span>Drehen Sie das Produkt mit gedrückter linker Maustaste.</span>
      </div>
      <div class="pv-pcon-guide__item">
        <strong>Ansicht vergrössern</strong>
        <span>Zoomen Sie mit dem Mausrad näher heran oder wieder heraus.</span>
      </div>
      <div class="pv-pcon-guide__item">
        <strong>Preis & Warenkorb</strong>
        <span>Der Preis wird anhand Ihrer Auswahl aktualisiert. Anschliessend legen Sie die Konfiguration in den Warenkorb.</span>
      </div>
    `;
  }

  function createConfiguratorGuide(modal, options = {}) {
    if (!modal) return null;
    if (modalShowsPvKfg(modal)) return null; // PV-Konfigurator erklaert sich selbst (Header-?)

    const modalContent = modal.querySelector('.modal-content');
    if (!modalContent) return null;

    ensureConfiguratorHelpButton(modal);

    let guide = modalContent.querySelector('.pv-pcon-guide');

    if (guide) {
      guide.classList.remove('is-hidden');
      return guide;
    }

    const inputMode = getConfiguratorInputMode();
    const guideItems = getConfiguratorGuideItems(inputMode);

    guide = document.createElement('div');
    guide.className = `pv-pcon-guide pv-pcon-guide--${inputMode}`;
    guide.setAttribute('role', 'dialog');
    guide.setAttribute('aria-modal', 'false');
    guide.setAttribute('aria-label', 'Hinweise zur Bedienung des Konfigurators');

    guide.innerHTML = `
      <div class="pv-pcon-guide__card">
        <button class="pv-pcon-guide__close" type="button" aria-label="Hinweis schliessen">×</button>

        <div class="pv-pcon-guide__eyebrow">3D-Konfigurator</div>
        <h2 class="pv-pcon-guide__title">So funktioniert der Konfigurator</h2>

        <div class="pv-pcon-guide__grid">
          ${guideItems}
        </div>

        <div class="pv-pcon-guide__functions">
          <strong>Weitere Funktionen</strong>
          <span>
            Über die Symbole oben lassen sich je nach Produkt zusätzliche Funktionen öffnen –
            zum Beispiel Vollbild, Masse, Schnappschuss, PDF oder AR.
          </span>
        </div>

        <div class="pv-pcon-guide__contact">
          <span>Unsicher bei Farben, Materialien oder der passenden Ausführung?</span>
          <span>
            Wir helfen gerne:
            <a href="${PV_CONTACT_PHONE_HREF}">${PV_CONTACT_PHONE_LABEL}</a>
            <span aria-hidden="true">·</span>
            <a href="${PV_CONTACT_EMAIL_HREF}">${PV_CONTACT_EMAIL_LABEL}</a>
          </span>
        </div>

        <a href="/pages/3d-konfigurator" style="display:block;margin-top:10px;font-size:13px;color:inherit;opacity:.85;text-decoration:underline;text-underline-offset:2px;">Ausführliche Anleitung mit Tour und Antworten: Der 3D-Konfigurator erklärt →</a>

        <button class="pv-pcon-guide__button" type="button">Verstanden</button>
      </div>
    `;

    modalContent.appendChild(guide);

    const closeGuide = () => {
      guide.classList.add('is-hidden');
      markConfiguratorGuideSeen();

      setTimeout(() => {
        if (guide && guide.parentNode) guide.remove();

        if (options.highlightHelpAfterClose !== false) {
          highlightConfiguratorHelpButton(modal);
        }
      }, 220);
    };

    const closeButton = guide.querySelector('.pv-pcon-guide__close');
    const confirmButton = guide.querySelector('.pv-pcon-guide__button');

    if (closeButton) closeButton.addEventListener('click', closeGuide);
    if (confirmButton) confirmButton.addEventListener('click', closeGuide);

    guide.addEventListener('click', event => {
      if (event.target === guide) closeGuide();
    });

    return guide;
  }

  function maybeShowConfiguratorGuide(modal) {
    if (!modal) return;

    // Hilfe-Button weiterhin anzeigen, aber Bedienhilfe nicht mehr automatisch öffnen.
    ensureConfiguratorHelpButton(modal);
  }

  function closePredictiveSearch() {
    const active = document.activeElement;

    if (active && active.closest && active.closest('predictive-search, .predictive-search, .search__form')) {
      try {
        active.blur();
      } catch (e) {}
    }

    document.documentElement.classList.remove('predictive-search-open');
    document.body.classList.remove('predictive-search-open', 'search-open', 'no-scroll', 'overflow-hidden');

    document.querySelectorAll('predictive-search').forEach(el => {
      el.classList.remove('predictive-search-open');
    });

    const main = document.querySelector('main, #MainContent, [data-main-content]');

    if (main) {
      main.removeAttribute('aria-hidden');
      main.removeAttribute('inert');
      main.classList.remove('aria-hidden');
    }
  }

  function lockBody(productId) {
    if (__bodyLocked) return;

    __lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (productId) {
      scrollPositions[productId] = __lockedScrollY;
    }

    document.body.style.top = `${-__lockedScrollY}px`;
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.classList.add('modal-open');

    __bodyLocked = true;
  }

  function unlockBody(productId = null) {
    if (!__bodyLocked) {
      document.body.classList.remove('modal-open');
      return;
    }

    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('height');
    document.body.style.removeProperty('width');

    const y = productId && scrollPositions[productId] != null ? scrollPositions[productId] : __lockedScrollY;

    __bodyLocked = false;
    __lockedScrollY = 0;

    // Instant zurueck zur alten Position: html{scroll-behavior:smooth} wuerde
    // das Restore sonst als sichtbare Scroll-Fahrt animieren.
    const de = document.documentElement;
    const prevBehavior = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';
    window.scrollTo(0, y || 0);
    if (prevBehavior) {
      de.style.scrollBehavior = prevBehavior;
    } else {
      de.style.removeProperty('scroll-behavior');
    }
  }

  async function readResponsePayload(response) {
    try {
      const text = await response.text();

      if (!text) return null;

      try {
        return JSON.parse(text);
      } catch (e) {
        return text;
      }
    } catch (e) {
      return null;
    }
  }

  async function logHttpFailure(context, response, flow = null) {
    const payload = await readResponsePayload(response);

    console.warn(`[Configurator] ${context} failed`, {
      status: response.status,
      statusText: response.statusText,
      payload
    });

    flowWarn(flow, `${context} failed`, {
      status: response.status,
      statusText: response.statusText,
      payload
    });

    return payload;
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Passiver Mess-Beacon fuer die Cart-Flows (Basis fuer Delay-Tuning).
  // text/plain ist bewusst: nicht-safelisted Content-Types wuerden einen
  // CORS-Preflight ausloesen, den ein fire-and-forget-Beacon nicht braucht.
  function sendFlowBeacon(kind, data = {}) {
    try {
      if (!navigator.sendBeacon) return;

      const payload = JSON.stringify({
        kind,
        t: Date.now(),
        ...data
      });

      navigator.sendBeacon(PV_BEACON_URL, new Blob([payload], { type: 'text/plain' }));
    } catch (e) {}
  }

  async function addVariantToCart(variantId, quantity, properties = null) {
    const item = {
      id: variantId,
      quantity
    };

    if (properties && typeof properties === 'object') {
      item.properties = properties;
    }

    return fetch(buildShopifyUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [item] }),
      credentials: 'same-origin'
    });
  }

  async function changeCartLine(lineKey, quantity) {
    return fetch(buildShopifyUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      }),
      credentials: 'same-origin'
    });
  }

  async function getCart(flow = null) {
    flowMark(flow, 'cart.js request start');

    const response = await fetch(buildShopifyUrl(`cart.js?t=${Date.now()}`), {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      flowWarn(flow, 'cart.js request failed', { status: response.status });
      throw new Error(`HTTP ${response.status}`);
    }

    flowMark(flow, 'cart.js request ok');
    return response.json();
  }

  async function waitForVariantInCart(variantId, options = {}) {
    const maxAttempts = Number(options.maxAttempts || 24);
    const pollInterval = Number(options.pollInterval || 500);
    const flow = options.flow || null;

    flowMark(flow, 'waitForVariantInCart start', {
      variantId,
      maxAttempts,
      pollInterval
    });

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      try {
        const cart = await getCart(flow);
        const found = Array.isArray(cart.items)
          ? cart.items.find(item => Number(item.variant_id) === Number(variantId))
          : null;

        if (found) {
          flowMark(flow, 'variant visible in cart.js', {
            variantId,
            attempt: attempt + 1,
            quantity: found.quantity,
            lineKey: found.key || ''
          });

          return found;
        }
      } catch (err) {
        flowWarn(flow, 'waitForVariantInCart poll failed', {
          attempt: attempt + 1,
          error: String(err && err.message ? err.message : err)
        });
      }

      if (attempt < maxAttempts - 1) {
        await sleep(pollInterval);
      }
    }

    flowError(flow, 'variant not visible in cart.js after polling', {
      variantId
    });

    throw new Error(`Variant ${variantId} not visible in cart after polling`);
  }

  // F16 (Codex-Gegenanalyse, 28.09.2026): Liegt die Variante schon im Warenkorb? Im Replace-Pfad
  // zaehlt nur die Zeile mit demselben _pv_rev, sonst waere die alte Zeile derselben Variante ein Treffer.
  function pvKorbHatVariante(cart, variantId, properties) {
    const rev = properties && properties._pv_rev ? String(properties._pv_rev) : '';

    return !!(cart && Array.isArray(cart.items) && cart.items.some(it =>
      Number(it.variant_id) === Number(variantId) &&
      (!rev || String((it.properties && it.properties._pv_rev) || '') === rev)
    ));
  }

  async function addVariantWithBackoff(variantId, quantity, options = {}) {
    const safeQuantity = Math.max(1, parseInt(quantity, 10) || 1);
    const initialDelayMs = Number(options.initialDelayMs || 500);

    const retryDelaysMs =
      Array.isArray(options.retryDelaysMs) && options.retryDelaysMs.length
        ? options.retryDelaysMs
        : [1200, 2000, 3200, 4500];

    const properties = options.properties || null;
    const label = options.label || 'addVariantWithBackoff';
    const flow = options.flow || null;

    let lastError = null;

    // F16: Nach Netzfehler oder HTTP 5xx ist offen, ob Shopify die Position angenommen hat. Dann vor
    // jedem weiteren POST /cart.js lesen (fruehestens 1.5 s nach dem Fehler). Treffer = Erfolg, ohne
    // Treffer erneut senden; scheitert das Lesen, weiter lesen, nie blind senden.
    let pvUnklar = false;
    let pvUnklarSeit = 0;

    const pvKorbLesen = async () => {
      const pvWarten = 1500 - (Date.now() - pvUnklarSeit);
      if (pvWarten > 0) await sleep(pvWarten);

      const pvKorb = await getCart(flow);
      if (!pvKorb || !Array.isArray(pvKorb.items)) throw new Error('cart.js ohne items');

      return pvKorbHatVariante(pvKorb, variantId, properties);
    };

    flowMark(flow, `${label} start`, {
      variantId,
      quantity: safeQuantity,
      initialDelayMs,
      retries: retryDelaysMs.length
    });

    if (initialDelayMs > 0) {
      await sleep(initialDelayMs);
    }

    for (let attempt = 0; attempt <= retryDelaysMs.length; attempt++) {
      try {
        if (pvUnklar) {
          if (await pvKorbLesen()) {
            flowMark(flow, `${label} F16: Variante nach unklarem Ausgang im Warenkorb, kein neuer POST`, { attempt: attempt + 1, variantId });
            return { ok: true, attempts: attempt + 1, recovered: true };
          }

          pvUnklar = false;
        }

        flowMark(flow, `${label} request start`, {
          attempt: attempt + 1,
          variantId,
          quantity: safeQuantity
        });

        const response = await addVariantToCart(variantId, safeQuantity, properties);

        if (response.ok) {
          flowMark(flow, `${label} request ok`, {
            attempt: attempt + 1,
            status: response.status
          });

          return { ok: true, attempts: attempt + 1 };
        }

        const payload = await logHttpFailure(`${label} attempt ${attempt + 1}`, response, flow);

        const err = new Error(`HTTP ${response.status}`);
        err.status = response.status;
        err.responsePayload = payload;
        lastError = err;

        if (response.status !== 422) throw err;

        flowWarn(flow, `${label} retryable 422`, {
          attempt: attempt + 1,
          status: response.status
        });
      } catch (err) {
        lastError = err;

        flowWarn(flow, `${label} attempt failed`, {
          attempt: attempt + 1,
          error: String(err && err.message ? err.message : err),
          status: err && err.status ? err.status : null
        });

        // F16: 400/401/403 heilen nicht, sofort abbrechen. Netzfehler, 5xx und gescheitertes Lesen:
        // vor dem naechsten POST lesen. 404/422/429 wie bisher wiederholen (Propagation).
        const pvStatus = err && err.status ? Number(err.status) : 0;
        if (pvStatus === 400 || pvStatus === 401 || pvStatus === 403) break;

        if (!pvStatus || pvStatus >= 500) {
          if (!pvUnklar) pvUnklarSeit = Date.now();
          pvUnklar = true;
        }

        if (attempt >= retryDelaysMs.length) break;
      }

      if (attempt < retryDelaysMs.length) {
        await sleep(retryDelaysMs[attempt]);
      }
    }

    // F16: War auch der letzte Ausgang unklar, ein letztes Mal lesen, statt einen Fehler zu melden,
    // obwohl die Position im Warenkorb liegt.
    if (pvUnklar) {
      try {
        if (await pvKorbLesen()) {
          flowMark(flow, `${label} F16: Variante nach unklarem Ausgang im Warenkorb (Schlusslesung)`, { variantId });
          return { ok: true, attempts: retryDelaysMs.length + 1, recovered: true };
        }
      } catch (pvErr) {}
    }

    flowError(flow, `${label} exhausted`, {
      variantId,
      quantity: safeQuantity,
      error: String(lastError && lastError.message ? lastError.message : lastError)
    });

    throw lastError || new Error(`${label} failed`);
  }

  function getButtonConfiguratorData(btn) {
    if (!btn) {
      return {
        productId: '',
        variantId: '',
        moc: '',
        sid: '',
        ovc: '',
        sku: '',
        template: '',
        vendor: '',
        ptype: '',
        reopenurl: '',
        obx: '',
        configured: false
      };
    }

    // Match-/Routing-Attribute trimmen (Combus-Fix: Whitespace in custom.obx_url brach das \.obx$-Muster)
    const g = (a) => (btn.getAttribute(a) || '').trim();

    // Kanonische Produkt-URL (fuer «Konfiguration teilen» im Konfigurator): auf der PDP die
    // Seite selbst, in Listen der Karten-Link. Ohne Fund bleibt purl leer — der Konfigurator
    // blendet den Teilen-Eintrag dann aus (degradiert sauber).
    let productUrl = '';

    try {
      if (isProductPageContext() && /\/products\//.test(location.pathname)) {
        productUrl = location.origin + location.pathname.split('?')[0].replace(/\/$/, '');
      } else {
        const card = btn.closest('.product-card, .product-card__wrapper, li, article');
        const cardLink = card ? card.querySelector('a[href*="/products/"]') : null;

        if (cardLink) {
          const u = new URL(cardLink.getAttribute('href'), location.origin);
          productUrl = u.origin + u.pathname.replace(/\/$/, '');
        }
      }
    } catch (purlErr) {}

    // HART auf die Kundendomain kanonisieren: der Preview-/interne Host
    // (primo-vero.myshopify.com) darf NIE in geteilte Links wandern (Beda 21.07.).
    productUrl = productUrl.replace(/^https:\/\/primo-vero\.myshopify\.com/i, 'https://primovero.ch');

    return {
      productId: g('data-product-id'),
      variantId: g('data-variant-id'),
      moc: g('data-moc'),
      sid: g('data-sid'),
      ovc: g('data-ovc'),
      sku: g('data-sku'),
      configuratorBan: g('data-configurator-ban'),
      template: g('data-template'),
      vendor: g('data-vendor'),
      ptype: g('data-ptype'),
      // PV 11.09.2026: Lieferzeit in TAGEN aus der Produktvorlage (Produkt-Metafeld
      // uebersteuert). Der Konfigurator rechnet daraus dieselbe Spanne wie die
      // Produktseite, statt eine zweite Tabelle zu fuehren. Leer = «auf Anfrage».
      deliverDays: g('data-deliver-days'),
      reopenurl: g('data-reopenurl'),
      obx: g('data-obx'),
      configured: g('data-pv-configured') === 'true',
      pvKfg: g('data-pv-kfg'),
      pvTitle: btn.getAttribute('data-pv-title') || '',
      purl: productUrl
    };
  }

  function canBuildConfiguratorUrlFromButton(btn) {
    const data = getButtonConfiguratorData(btn);

    return !!(data.productId && data.moc && data.sku);
  }

  function buildCustomFieldsString(data, replaceContext = null) {
    let customFields =
      `&template=${encodeURIComponent(data.template || '')}` +
      `&id=${encodeURIComponent(data.productId || '')}` +
      `&pid=${encodeURIComponent(data.productId || '')}` +
      `&vid=${encodeURIComponent(data.variantId || '')}` +
      `&sid=${encodeURIComponent(data.sid || '')}` +
      `&ovc=${encodeURIComponent(data.ovc || '')}` +
      `&moc=${encodeURIComponent(data.moc || '')}` +
      `&vendor=${encodeURIComponent(data.vendor || '')}` +
      `&ptype=${encodeURIComponent(data.ptype || '')}`;

    if (replaceContext && replaceContext.lineKey) {
      customFields +=
        `&line_key=${encodeURIComponent(replaceContext.lineKey || '')}` +
        `&line_qty=${encodeURIComponent(String(replaceContext.quantity || 1))}` +
        `&old_variant_id=${encodeURIComponent(replaceContext.variantId || '')}` +
        `&old_product_id=${encodeURIComponent(replaceContext.productId || '')}`;
    }

    return customFields;
  }

  // PV-Konfigurator-URL: Parameter im FRAGMENT (wie pCon.ui) — lange ovc-Variantcodes
  // gehen so nie ueber den Draht (keine Server-Logs/Header-Limits).
  function buildPvKfgUrlFromButton(data, replaceContext) {
    let frag =
      `moc=${encodeURIComponent(data.moc || '')}` +
      `&ban=${encodeURIComponent(data.configuratorBan || data.sku || '')}` +
      (data.ovc ? `&vc=${encodeURIComponent(data.ovc)}` : '') +
      (data.sid ? `&sid=${encodeURIComponent(data.sid)}` : '') +
      `&pid=${encodeURIComponent(data.productId || '')}` +
      `&ptype=${encodeURIComponent(data.ptype || '')}` +
      // Hersteller des Quellprodukts (09.9): cart-position.cfm gibt ihn ans Warenkorb-Produkt
      // weiter, statt ihn aus einer Festliste zu raten (Beda-Befund 02.09.: Hopper stand als
      // «Primo Vero» im Warenkorb, weil Extremis in der Liste fehlte).
      (data.vendor ? `&vendor=${encodeURIComponent(data.vendor)}` : '') +
      // Vorlage des Quellprodukts (template_suffix): vererbt der Hook ans Warenkorb-Produkt,
      // damit dessen Reopen-PDP die herstellerspezifischen Bloecke traegt (Beda 20.07.).
      (data.template ? `&tpl=${encodeURIComponent(data.template)}` : '') +
      // Lieferzeit-Tage der Produktvorlage (11.09.2026): der Konfigurator rendert daraus
      // «Lieferzeit ca. X-Y Wochen» mit derselben Formel wie der shipping-Block der PDP
      // (dd-7 bis dd+7, Untergrenze 7 Tage). Ohne Wert zeigt er ehrlich «auf Anfrage»,
      // statt wie bis 0.5.29 «8-10» zu raten. Nur reine Zahlen gehen durch.
      (/^\d{1,3}$/.test(String(data.deliverDays || '').trim())
        ? `&dd=${encodeURIComponent(String(data.deliverDays).trim())}` : '') +
      // Kanonische Produkt-URL fuer den «Konfiguration teilen»-Link (01.3)
      (data.purl ? `&purl=${encodeURIComponent(data.purl)}` : '') +
      // Kuratierter Shop-Titel als Anzeigename (Katalog-shortText ist bei NARFC/FUNCTIONALS
      // eine rohe Artikelnummer/EAN und bei ZIZI englisch)
      (data.pvTitle ? `&title=${encodeURIComponent(data.pvTitle)}` : '');

    // Geteilte Konfiguration (?pvshare=<BelegId>, 01.3): der geteilte Beleg gewinnt vor
    // data-obx/reopenurl — exakt der bestehende obx-Reopen-Pfad, nur mit fremdem Beleg.
    let sharedObx = '';

    try {
      const shareId = new URLSearchParams(window.location.search).get('pvshare') || '';
      if (/^[A-Z0-9]{6,20}$/.test(shareId)) sharedObx = PV_OBX_PREFIX + shareId;
      // QR->AR-Direktsprung (Beda 23.07.): der Desktop-QR haengt &pvar=1 an den
      // Share-Link — durchgereicht ins Fragment oeffnet der Konfigurator auf dem
      // Handy direkt die AR-Startkarte (1 Tipp zur Kamera statt Button-Suche).
      if (sharedObx && new URLSearchParams(window.location.search).get('pvar') === '1') frag += '&pvar=1';
    } catch (pvshareErr) {}

    // Prüfkennungen der Seiten-URL an den Konfigurator durchreichen (30.07.). Damit lässt
    // sich ein Gerätebefund direkt am Gerät belegen, ohne Sonderlink und ohne Deploy:
    //   ?pvdiag=1  Geräte-Diagnose einblenden (Bewegung/WebGL/Ladephasen, «Senden» ans Log)
    //   ?pvrm=1    «Bewegung reduzieren» nachstellen (der iPhone-Fall vom 30.07.)
    // Beide sind wirkungslos, solange sie niemand anhängt.
    try {
      const q = new URLSearchParams(window.location.search);
      if (q.get('pvdiag') === '1') frag += '&pvdiag=1';
      if (q.get('pvrm') === '1') frag += '&pvrm=1';
      // 0.4.34: Kapitel-A/B auf der echten PDP testbar machen — pvkap=1 holt die
      // alte Pillen-Leiste zurueck (Default ist die gefuehrte Liste).
      if (q.get('pvkap') === '1' || q.get('pvkap') === '0') frag += '&pvkap=' + q.get('pvkap');
    } catch (pvflagErr) {}

    // Reopen/Start: gespeicherte Konfiguration bzw. kuratierter Start-Beleg 1:1 oeffnen.
    // pCon.ui-Pfade (/obx-reopen/, /obx/) werden auf den obx-alt-Proxy uebersetzt.
    const reopenSrc = sharedObx || String(data.reopenurl || data.obx || '');
    if (reopenSrc.indexOf(PV_OBX_PREFIX) === 0) {
      frag += `&obx=${encodeURIComponent(reopenSrc)}`;
    } else if (reopenSrc.indexOf(PV_OBX_ALT_PREFIX) === 0) {
      const altId = (reopenSrc.slice(PV_OBX_ALT_PREFIX.length).match(/^([0-9]{6,20})\.obx$/) || [])[1];
      if (altId) frag += `&obx=${encodeURIComponent(PV_OBX_ALT_PROXY + altId)}`;
    } else if (reopenSrc.indexOf(PV_OBX_START_PREFIX) === 0) {
      const startId = (reopenSrc.slice(PV_OBX_START_PREFIX.length).match(/^([A-Za-z0-9_][A-Za-z0-9._-]{0,80})\.obx$/) || [])[1];
      if (startId) frag += `&obx=${encodeURIComponent(PV_OBX_START_PROXY + startId)}`;
    }

    // Cart-Re-Edit: bestehende Warenkorbzeile ERSETZEN statt neu hinzufuegen
    if (replaceContext && replaceContext.lineKey) {
      frag +=
        `&line_key=${encodeURIComponent(replaceContext.lineKey)}` +
        `&line_qty=${encodeURIComponent(String(Math.max(1, parseInt(replaceContext.quantity, 10) || 1)))}` +
        `&old_variant_id=${encodeURIComponent(replaceContext.variantId || '')}` +
        `&old_product_id=${encodeURIComponent(replaceContext.productId || '')}`;
    }

    return `${PV_KFG_ORIGIN}/${PV_KFG_VERSION}/index.html#${frag}`;
  }

  function shouldUsePvKfg(data, replaceContext) {
    if (!PV_KFG_MOCS.includes(String(data.moc || '').toUpperCase())) return false;

    // Reopen/Cart-Re-Edit: eigene Positionen (pfadfoermige Beleg-URL) UND alte
    // pCon.ui-Positionen (/obx-reopen/) oeffnen im PV-Konfigurator — inklusive Ersetzen
    // der Warenkorbzeile. Import-Fehler faengt pv_fail -> pCon.ui.
    // Kuratierte START-Belege (/obx/, custom.obx_url — narbutas) sind KEIN Reopen: sie
    // starten den PV-Konfigurator mit der Grundkonfiguration (ACTIVE-Befund 17.07.).
    // Nur Belege fremder EAIWS-Quellen bleiben bei pCon.ui.
    const reopenSrc = String(data.reopenurl || data.obx || '');
    if ((replaceContext && replaceContext.lineKey) || reopenSrc) {
      if (reopenSrc.indexOf(PV_OBX_PREFIX) === 0) return true;
      if (/^https:\/\/api\.primovero\.ch\/obx-reopen\/[0-9]{6,20}\.obx$/.test(reopenSrc)) return true;
      if (/^https:\/\/api\.primovero\.ch\/obx\/[A-Za-z0-9_][A-Za-z0-9._-]{0,80}\.obx$/.test(reopenSrc)) {
        // Start-Beleg: Weiche wie bei Neu-Konfiguration (Opt-in/Testmodus), kein Zwang
        if (!(replaceContext && replaceContext.lineKey)) {
          if (data.pvKfg === 'true') return true;
          return PV_KFG_TESTMODE;
        }
        return true;
      }
      return false;
    }

    // Neu-Konfiguration — Produkt-Opt-in (Metafeld custom.pv_konfigurator, Beda-Entscheid
    // 17.07.): freigegebene Produkte nutzen den PV-Konfigurator IMMER; ohne Freigabe
    // entscheidet der Testmodus (Draft true = hersteller-weit, Live-Gang false).
    if (data.pvKfg === 'true') return true;

    return PV_KFG_TESTMODE;
  }

  // pCon.ui-URL (Alt-Weg) — separat aufrufbar, damit ein pv_fail des PV-Konfigurators im
  // selben Modal auf den alten Konfigurator umschwenken kann (fail closed).
  function buildPconUiUrlFromButton(btn) {
    const data = getButtonConfiguratorData(btn);
    const replaceContext = getEffectiveReplaceContext();

    const customFields = buildCustomFieldsString(data, replaceContext);
    const hookUrl = `${PV_API_HOOK_URL}?${encodeURIComponent(customFields)}`;

    let url =
      `${PCON_UI_ORIGIN}/#GATEKEEPER_ID=${encodeURIComponent(PCON_GATEKEEPER_ID)}` +
      `&moc=${encodeURIComponent(data.moc || '')}` +
      `&ban=${encodeURIComponent(data.configuratorBan || data.sku || '')}`;

    if (data.sid) {
      url += `&sid=${encodeURIComponent(data.sid)}`;
    }

    if (data.ovc) {
      url += `&ovc=${encodeURIComponent(data.ovc)}`;
    }

    url +=
      `&lang=de` +
      `&adv=modular` +
      `&ltt=true`;

    if (replaceContext && replaceContext.lineKey) {
      url +=
        `&upd=true` +
        `&qty=${encodeURIComponent(String(Math.max(1, parseInt(replaceContext.quantity, 10) || 1)))}`;
    }

    if (data.reopenurl) {
      url += `&obx=${encodeURIComponent(data.reopenurl)}`;
    } else if (data.obx) {
      url += `&obx=${encodeURIComponent(data.obx)}`;
    }

    url += `&HOOK_URL=${hookUrl}`;

    return url;
  }

  function buildConfiguratorUrlFromButton(btn) {
    const data = getButtonConfiguratorData(btn);
    const replaceContext = getEffectiveReplaceContext();

    if (shouldUsePvKfg(data, replaceContext)) {
      return buildPvKfgUrlFromButton(data, replaceContext);
    }

    return buildPconUiUrlFromButton(btn);
  }

  function buildFreshIframeUrl(btn, iframeEl) {
    const fallback = iframeEl?.getAttribute('data-src') || '';

    if (canBuildConfiguratorUrlFromButton(btn)) {
      return buildConfiguratorUrlFromButton(btn);
    }

    return fallback;
  }

  function normalizeConfiguratorUrlForCompare(url) {
    return String(url || '').trim();
  }

  function dedupeBodyPconModals() {
    const seen = new Map();

    $$(PCON_MODAL_SELECTOR).forEach(modal => {
      const id = modal.id;

      if (!seen.has(id)) {
        seen.set(id, modal);
        return;
      }

      const existing = seen.get(id);
      const existingInBody = existing.parentNode === document.body;
      const currentInBody = modal.parentNode === document.body;

      if (existingInBody && !currentInBody) {
        modal.remove();
        return;
      }

      if (!existingInBody && currentInBody) {
        existing.remove();
        seen.set(id, modal);
        return;
      }

      modal.remove();
    });
  }

  function createGlobalModal() {
    const modal = document.createElement('div');
    modal.className = 'modal';
    modal.id = GLOBAL_MODAL_ID;
    modal.setAttribute('aria-hidden', 'true');
    modal.style.cssText = `
      display: none;
      position: fixed;
      z-index: 150;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: auto;
      background-color: rgba(0,0,0,0.4);
    `;

    modal.innerHTML = `
      <div class="modal-content"
        style="background-color: #fefefe; margin: auto; position: absolute; top: 0; left: 0; right: 0; bottom: 0; padding: 0; border: none; width: 100%; max-width: 1800px; box-shadow: 0 0 10px rgba(0,0,0,0.5); display: flex; flex-direction: column; border-radius: 20px;">
        <span class="close-modal" aria-label="Konfigurator schliessen" role="button" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5.25 5.25 18.75 18.75M18.75 5.25 5.25 18.75"/></svg></span>
        <iframe
          id="${GLOBAL_IFRAME_ID}"
          title="3D-Produktkonfigurator"
          width="100%"
          height="100%"
          pcon-ui-iframe=""
          allowtransparency="true"
          frameborder="0"
          scrolling="no"
          style="border: none;"
          allow="clipboard-write; web-share"
        ></iframe>
      </div>
    `;

    document.body.appendChild(modal);

    return modal;
  }

  function ensureGlobalModal() {
    let modal = document.getElementById(GLOBAL_MODAL_ID);

    if (!modal) {
      modal = createGlobalModal();
    }

    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    let iframe = modal.querySelector(`#${GLOBAL_IFRAME_ID}`);

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = GLOBAL_IFRAME_ID;
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');
      iframe.setAttribute('title', '3D-Produktkonfigurator');
      iframe.setAttribute('pcon-ui-iframe', '');
      iframe.setAttribute('allowtransparency', 'true');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('scrolling', 'no');
      iframe.setAttribute('allow', 'clipboard-write; web-share');
      iframe.style.border = 'none';

      const modalContent = modal.querySelector('.modal-content');
      if (modalContent) modalContent.appendChild(iframe);
    }

    setupModalCloseHandlers(modal);

    return {
      modal,
      iframe,
      isGlobal: true
    };
  }

  // Erste Stufe des Schliessens (07.5): liegt im Konfigurator eine eigene Ebene oben,
  // geht zuerst NUR diese zu — so, wie gestapelte Dialoge sich ueberall verhalten.
  // Die Flagge faellt dabei sofort: abgefangen wird hoechstens EIN Klick, nie entsteht
  // ein Modal, das sich nicht mehr schliessen laesst (auch nicht, wenn der iframe die
  // Nachricht verschluckt oder inzwischen gestorben ist).
  function pvInnereEbeneZuerst(modal) {
    if (!__pvOverlayOpen) return false;

    __pvOverlayOpen = false;

    const ifr =
      (modal && modal.querySelector('iframe[pcon-ui-iframe], iframe')) ||
      (__activeModalState && __activeModalState.iframe);

    if (!ifr || !ifr.contentWindow) return false;

    let ziel = '*';

    try {
      ziel = new URL(ifr.src, window.location.href).origin;
    } catch (err) {
      ziel = '*';
    }

    try {
      ifr.contentWindow.postMessage({ action: 'pv_overlay_close' }, ziel);
    } catch (err) {
      return false;
    }

    return true;
  }

  function setupModalCloseHandlers(modal) {
    if (!modal || modal.__pvCloseBound) return;

    modal.__pvCloseBound = true;

    modal.addEventListener('click', event => {
      if (event.target === modal) {
        if (pvInnereEbeneZuerst(modal)) return;

        closeConfiguratorModal(modal);
      }
    });

    const closeX = modal.querySelector('.close-modal');

    if (closeX) {
      closeX.addEventListener('click', event => {
        event.preventDefault();

        if (pvInnereEbeneZuerst(modal)) return;

        closeConfiguratorModal(modal);
      });

      closeX.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();

          if (pvInnereEbeneZuerst(modal)) return;

          closeConfiguratorModal(modal);
        }
      });
    }
  }

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (!__activeModalState || !__activeModalState.modal) return;
    if (__cartFlowActive) return;
    // Layer-Prinzip (Beda 02.08.): liegt ein Theme-Popup (Beratung/Projektliste)
    // ueber dem Konfigurator, gehoert Escape dem Popup — basic-modal schliesst
    // sich auf keyup selbst; der naechste Escape trifft dann den Konfigurator.
    if (document.querySelector('basic-modal[open]')) return;
    // Dasselbe Layer-Prinzip eine Ebene tiefer (07.5): liegt im Konfigurator selbst
    // eine eigene Ebene oben, gehoert Escape zuerst ihr.
    if (pvInnereEbeneZuerst(__activeModalState.modal)) return;

    closeConfiguratorModal(__activeModalState.modal);
  });

  function showPvDryRunNotice(ref, price) {
    try {
      let el = document.getElementById('pv-kfg-dryrun-notice');

      if (!el) {
        el = document.createElement('div');
        el.id = 'pv-kfg-dryrun-notice';
        el.style.cssText =
          'position:fixed;top:18px;left:50%;transform:translateX(-50%);z-index:2147483000;' +
          'background:#1d3b2a;color:#fff;padding:12px 18px;border-radius:10px;font-size:14px;' +
          'box-shadow:0 6px 24px rgba(0,0,0,.25);max-width:min(92vw,560px);text-align:center;';
        document.body.appendChild(el);
      }

      el.textContent =
        'Testmodus: Konfiguration serverseitig geprüft (Ref ' + ref + (price ? ', CHF ' + price : '') +
        ') — der Warenkorb wird erst nach dem Live-Schalten des Konfigurators befüllt.';
      el.style.display = 'block';
      clearTimeout(el.__pvT);
      el.__pvT = setTimeout(() => { el.style.display = 'none'; }, 8000);
    } catch (e) {}
  }


  // --- Beratung & Projektliste (Beda 21.07., PV-Konfigurator-Abschlusskarte) --------
  // Der Konfigurator (iframe) erzeugt dauerhafte Beleg-Links und meldet sie hierhin;
  // das Theme besitzt Formular und Projektliste (localStorage der Shop-Domain,
  // produktuebergreifend, ohne Konto). Links werden hart validiert, bevor sie in
  // href/open wandern (Allowlist: eigene PDP mit pvshare-Beleg).
  const PJ_KEY = 'pv_project_v1';
  const PJ_LINK_RE = /^https:\/\/(www\.)?primovero\.ch\/products\/[a-z0-9-]+\?pvshare=[A-Za-z0-9_-]{4,64}$/;

  function pjEsc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);
  }

  // Mengen und Notizen je Position (09.9, Paket 2): qty 1..99 (Standard 1), note = Raum /
  // Bemerkung (bis 120 Zeichen); vendor/ban kommen seit Konfigurator 0.5.22 mit (Projektblatt,
  // Anfrage-Mail). Aeltere Eintraege ohne diese Felder werden hier still normalisiert.
  function pjNorm(x) {
    const q = parseInt(x.qty, 10);
    x.qty = isFinite(q) ? Math.max(1, Math.min(99, q)) : 1;
    x.note = typeof x.note === 'string' ? x.note.slice(0, 120) : '';
    x.vendor = typeof x.vendor === 'string' ? x.vendor.slice(0, 60) : '';
    x.ban = typeof x.ban === 'string' ? x.ban.slice(0, 40) : '';
    return x;
  }

  function pjList() {
    try {
      const raw = JSON.parse(localStorage.getItem(PJ_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(x => x && x.id && PJ_LINK_RE.test(x.link || '')).map(pjNorm) : [];
    } catch (e) { return []; }
  }

  function pjSave(list, opts) {
    try { localStorage.setItem(PJ_KEY, JSON.stringify(list)); }
    catch (e) {
      // Quota (Konfigurations-Thumbs): einmal ohne Bilder, bevor still etwas verloren geht.
      try { localStorage.setItem(PJ_KEY, JSON.stringify(list.map(x => Object.assign({}, x, { img: '' })))); } catch (e2) {}
    }
    // Header-Projekt-Badge (01.6) und andere Zuhoerer derselben Seite aktuell halten
    // (storage-Events feuern nur in ANDEREN Tabs).
    try { document.dispatchEvent(new CustomEvent('pv:project-changed')); } catch (e3) {}
    // Etappe B: jede Aenderung geht gebremst zum Partnerzugang (quiet = kam gerade von dort).
    if (!(opts && opts.quiet)) pjSyncSchedule();
  }

  // --- Projekt am Konto (Projektkarte Schritt 2, 02.09.2026 nachts) oder am Partnerzugang (Etappe B) --
  // Die Liste liegt zusaetzlich im PMS an einer IDENTITAET: dem Shopify-Kundenkonto (window.PV_KUNDE
  // mit id + signiertem Tages-Token aus theme.liquid) oder dem Partnerzugang (Schluessel
  // pv_partner_key + Server-Cookie). Jedes Geraet mit derselben Identitaet sieht denselben Stand,
  // und der Projektlink wird lebend (?pvproject=Q…). Ohne beides bleibt alles wie bisher im
  // Browser. Regeln: der Server ist die Wahrheit; jede Aenderung hier geht gebremst hinauf; beim
  // Laden und beim Oeffnen der Liste wird der Serverstand geholt und zusammengefuehrt — je
  // Position gewinnt die juengere Aenderung (mod); eine Position, die seit der letzten
  // Synchronisation hier nicht angefasst wurde und auf dem Server fehlt, wurde anderswo
  // geloescht. Ist der Server weiter (409), wird zusammengefuehrt und nochmals geschickt.
  const PJ_PROJEKT_API = 'https://api.primovero.ch/konfigurator/api/partner-projekt.cfm';
  const PJ_SYNC_KEY = 'pv_project_sync_v1';       // {version, at, token, ids, konto}
  const PJ_TITLE_MOD_KEY = 'pv_project_title_mod_v1';
  let pjSyncBusy = null, pjSyncT = null, pjSyncPulledAt = 0, pjSyncZustand = '', pjSaveFrisch = false, pjSaveReturn = false;
  function pjPartnerKey() { try { return String(localStorage.getItem('pv_partner_key') || '').toUpperCase(); } catch (e) { return ''; } }
  // Identitaet fuer den Abgleich: das Konto vor dem Partnerzugang (das Konto hat die Person
  // selbst gewaehlt; ein Partnerprojekt derselben E-Mail uebernimmt der Server ins Konto).
  function pjIdent() {
    try {
      const k = window.PV_KUNDE;
      if (k && typeof k === 'object' && k.token && k.id) {
        return { typ: 'kunde', kunde: { id: String(k.id), tok: String(k.token), email: String(k.email || ''), name: String(k.name || ''), firma: String(k.firma || '') } };
      }
    } catch (e) {}
    const key = pjPartnerKey();
    if (key) return { typ: 'partner', key: key };
    return null;
  }
  // Schluessel der Identitaet fuer den Sync-Stand (Audit 03.09.2026, B4): wechselt die Person am
  // selben Browser, darf die alte Liste nicht in das neue Konto wandern.
  function pjIdentKey() { const id = pjIdent(); return id ? (id.typ === 'kunde' ? 'k:' + id.kunde.id : 'p:' + id.key) : ''; }
  // Login-Adresse (neue Shopify-Konten, Code per E-Mail): zurueck auf DIESE Seite mit ?pvsave=1,
  // damit die Karte nach der Anmeldung abgleicht und die Bestaetigung zeigt. 10.2: NUR
  // `/customer_authentication/login?return_to=<relativer Pfad>` kehrt auf die Seite zurueck —
  // `routes.account_login_url` (…/redirect) landet immer auf der Bestellliste (Bedas Test 02.09.).
  function pjLoginUrl() {
    let back = window.location.pathname || '/';
    try { const q = new URLSearchParams(window.location.search); q.set('pvsave', '1'); back += '?' + q.toString(); } catch (e) { back += '?pvsave=1'; }
    return '/customer_authentication/login?return_to=' + encodeURIComponent(back);
  }
  // Der Sync-Stand liegt zusaetzlich im Arbeitsspeicher (Audit 03.09.2026, B3): kann der Browser
  // nicht schreiben, bleibt die Version trotzdem bekannt — und der Server verlangt sie jetzt.
  let pjSyncMem = null;
  function pjSyncState() {
    try { const s = JSON.parse(localStorage.getItem(PJ_SYNC_KEY) || 'null'); if (s && typeof s === 'object') return s; } catch (e) {}
    if (pjSyncMem && typeof pjSyncMem === 'object') return pjSyncMem;
    return { version: 0, at: 0, token: '' };
  }
  function pjSyncSet(s) { pjSyncMem = s; try { localStorage.setItem(PJ_SYNC_KEY, JSON.stringify(s)); } catch (e) {} }
  // Geloeschte Positionen (Audit 03.09.2026, B6): bis der Server die Loeschung kennt, darf ein
  // Abgleich sie nicht zurueckbringen. Geleert, sobald ein Push durch ist.
  function pjTombstone(id) { const st = pjSyncState(); st.del = Object.assign({}, st.del || {}); st.del[id] = Date.now(); pjSyncSet(st); }
  // Positionen aus dem Browser, die noch nicht zur Identitaet gehoeren (B4): geparkt, bis die
  // Person entscheidet — uebernehmen oder verwerfen.
  const PJ_PENDING_KEY = 'pv_project_pending_v1';
  function pjPending() { try { const p = JSON.parse(localStorage.getItem(PJ_PENDING_KEY) || 'null'); return (p && Array.isArray(p.items) && p.items.length) ? p : null; } catch (e) { return null; } }
  function pjPendingSet(p) { try { if (p) localStorage.setItem(PJ_PENDING_KEY, JSON.stringify(p)); else localStorage.removeItem(PJ_PENDING_KEY); } catch (e) {} }
  // Erste gelungene Synchronisation mit dem Konto: einmal messen (kfg_saved) — der Weg
  // «Speichern mit Konto» ist damit zu Ende gegangen.
  function pjSyncKonto(s) {
    const id = pjIdent();
    if (!id || id.typ !== 'kunde' || s.konto) return s;
    s.konto = true;
    pjKfgBeacon('saved', { n: Array.isArray(s.ids) ? s.ids.length : 0 });
    return s;
  }
  function pjTitleMod() { try { return Number(localStorage.getItem(PJ_TITLE_MOD_KEY) || 0) || 0; } catch (e) { return 0; } }
  function pjRemote(body) {
    const id = pjIdent();
    if (!id) return Promise.reject(new Error('keine Identitaet'));
    const ac = ('AbortController' in window) ? new AbortController() : null;
    const t = ac ? setTimeout(() => ac.abort(), 15000) : 0;
    return fetch(PJ_PROJEKT_API, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign(id.typ === 'kunde' ? { kunde: id.kunde } : { key: id.key }, body)), signal: ac ? ac.signal : undefined })
      .then(r => r.json().catch(() => ({})).then(j => ({ status: r.status, json: (j && typeof j === 'object') ? j : {} })))
      .finally(() => clearTimeout(t));
  }
  // Nutzlast einer Liste (Thumbs gebremst, bodyJson kappt bei 2 MB) — fuer Snapshot UND Server.
  function pjItemsPayload(list) {
    let imgBudget = 1300000;
    return list.map(x => {
      const ok = typeof x.img === 'string' && x.img.indexOf('data:image/jpeg;base64,') === 0 && imgBudget - x.img.length > 0;
      if (ok) imgBudget -= x.img.length;
      return { id: x.id, link: x.link, title: x.title, price: x.price, qty: x.qty || 1, note: x.note || '',
        vendor: x.vendor || '', ban: x.ban || '', img: ok ? x.img : '', at: x.at, mod: x.mod || 0 };
    });
  }
  // bekannt = Ids, die bei der letzten Synchronisation auf dem Server lagen. Fehlt so eine
  // Position jetzt dort, wurde sie anderswo geloescht; eine Position, die der Server nie
  // kannte, ist hier neu (auch eine alte Browserliste beim ersten Abgleich) und bleibt.
  function pjMerge(local, remote, bekannt, del) {
    const lid = new Map(local.map(x => [x.id, x]));
    const rid = new Map(remote.map(x => [x.id, x]));
    const kannte = new Set(Array.isArray(bekannt) ? bekannt : []);
    const tot = (del && typeof del === 'object') ? del : {};
    const out = [];
    for (const r of remote) {
      // Hier geloescht und seither anderswo nicht neuer bearbeitet: bleibt geloescht (B6).
      if (tot[r.id] && Number(tot[r.id]) >= (r.mod || 0)) continue;
      const l = lid.get(r.id);
      const w = (l && (l.mod || 0) > (r.mod || 0)) ? l : r;
      if (l && !w.img && l.img) w.img = l.img;   // Thumb behalten, wenn der Server keins mehr traegt
      out.push(w);
    }
    for (const l of local) {
      if (rid.has(l.id)) continue;
      if (!kannte.has(l.id)) out.push(l);
    }
    return out.filter(x => x && x.id && PJ_LINK_RE.test(x.link || '')).map(pjNorm);
  }
  function pjSyncSchedule() {
    if (!pjIdent()) return;
    clearTimeout(pjSyncT);
    pjSyncT = setTimeout(() => { pjSyncPush(false); }, 900);
  }
  // Serverstand einarbeiten (nach get oder 409). Liefert true, wenn danach nichts hochzuladen ist.
  function pjSyncUebernehmen(j) {
    const st = pjSyncState();
    const remote = Array.isArray(j.items) ? j.items : [];
    const merged = pjMerge(pjList(), remote, st.ids, st.del);
    const rtm = Number(j.title_mod || 0);
    if (rtm > pjTitleMod()) {
      const t = String(j.title || '').slice(0, 80);
      try { localStorage.setItem(PJ_TITLE_KEY, t); localStorage.setItem(PJ_TITLE_MOD_KEY, String(rtm)); } catch (e) {}
      const inp = document.getElementById('PvProjectTitle'); if (inp) inp.value = t;
    }
    pjSave(merged, { quiet: true });
    pjSyncSet(pjSyncKonto({ version: Number(j.version || 0), at: Date.now(), token: String(j.token || st.token || ''), ids: remote.map(x => x.id), konto: !!st.konto, wer: pjIdentKey(), del: st.del || {} }));
    const gleicheIds = remote.map(x => x.id).sort().join(',') === merged.map(x => x.id).sort().join(',');
    const nichtsNeuer = merged.every(m => { const r = remote.find(x => x.id === m.id); return r && (r.mod || 0) >= (m.mod || 0); });
    return gleicheIds && nichtsNeuer && rtm >= pjTitleMod();
  }
  function pjSyncPull(grund) {
    if (!pjIdent()) return Promise.resolve(false);
    if (pjSyncBusy) return pjSyncBusy;
    pjSyncZustand = 'busy'; pjRenderSyncLine();
    pjSyncBusy = pjRemote({ action: 'get' }).then(r => {
      if (r.status === 401) { pjSyncZustand = 'gate'; return false; }
      if (r.status !== 200 || !r.json.ok) throw new Error('get ' + r.status);
      pjSyncPulledAt = Date.now();
      // Audit 03.09.2026 (B4): erster gelungener Abgleich dieser Identitaet in diesem Browser mit
      // einer schon vorhandenen Liste, ohne ausdruecklichen Speichern-Wunsch (?pvsave=1): parken und
      // fragen — sonst wandert, was eine andere Person am selben Geraet gesammelt hat, in dieses
      // Konto. Erst HIER, nicht vor dem Abgleich: ein ungueltiger Schluessel darf nichts wegparken.
      try {
        const st0 = pjSyncState(), lok = pjList();
        if (!st0.wer && lok.length && !pjSaveReturn) {
          let t0 = '';
          try { t0 = String(localStorage.getItem(PJ_TITLE_KEY) || ''); localStorage.removeItem(PJ_TITLE_KEY); localStorage.removeItem(PJ_TITLE_MOD_KEY); } catch (e) {}
          // Auch das Feld der (im Leerlauf vorgebauten) Karte leeren — sonst bleibt der alte Name
          // dort stehen und wird beim naechsten Abgleich als Titel dieses Kontos hochgeladen.
          try { const ti = document.getElementById('PvProjectTitle'); if (ti && !t0) t0 = String(ti.value || '').trim(); if (ti) ti.value = ''; } catch (e) {}
          pjPendingSet({ items: lok, title: t0, at: Date.now() });
          pjSave([], { quiet: true });
        }
        if (!st0.wer) pjSyncSet(Object.assign({}, st0, { wer: pjIdentKey() }));
      } catch (e) {}
      if (!r.json.found) { pjSyncZustand = 'ok'; return pjList().length ? pjSyncPushJetzt(true) : true; }   // Server leer: lokale Liste hochziehen — nichts hochziehen, wenn auch sie leer ist
      const gleich = pjSyncUebernehmen(r.json);
      pjSyncZustand = 'ok';
      return gleich ? true : pjSyncPushJetzt(false);
    }).catch(() => { pjSyncZustand = 'fehler'; return false; })
      .finally(() => { pjSyncBusy = null; try { pjRender(); } catch (e) {} });
    return pjSyncBusy;
  }
  function pjSyncPush(force) {
    if (!pjIdent()) return Promise.resolve(false);
    if (pjSyncBusy) return pjSyncBusy.then(() => pjSyncPush(force));
    pjSyncBusy = pjSyncPushJetzt(force).finally(() => { pjSyncBusy = null; pjRenderSyncLine(); });
    return pjSyncBusy;
  }
  function pjSyncPushJetzt(force, zweiter) {
    const st = pjSyncState();
    const liste = pjList();
    const body = { action: 'put', title: pjGetTitle(), title_mod: pjTitleMod(), kond: PJ_KOND, items: pjItemsPayload(liste) };
    if (!force && st.version) body.version = st.version;
    return pjRemote(body).then(r => {
      if (r.status === 409 && r.json.conflict && !zweiter) { pjSyncUebernehmen(r.json); return pjSyncPushJetzt(false, true); }
      if (r.status === 401) { pjSyncZustand = 'gate'; return false; }
      if (r.status !== 200 || !r.json.ok) throw new Error('put ' + r.status);
      pjSyncSet(pjSyncKonto({ version: Number(r.json.version || 0), at: Date.now(), token: String(r.json.token || st.token || ''), ids: liste.map(x => x.id), konto: !!st.konto, wer: pjIdentKey(), del: {} }));
      pjSyncZustand = 'ok';
      return true;
    }).catch(() => { pjSyncZustand = 'fehler'; return false; });
  }
  // Teilen und Projektblatt: mit Identitaet der lebende Link (Token), sonst der Snapshot.
  function pjLinkQuelle(list) {
    if (!pjIdent()) return pjSnapshot(list);
    return pjSyncPush(false).then(okk => {
      const st = pjSyncState();
      if (okk && PJ_PROJECT_ID_RE.test(st.token || '')) return { ok: true, id: st.token, url: 'https://primovero.ch/?pvproject=' + st.token, live: true };
      return pjSnapshot(list);
    });
  }
  // Statuszeile im Kopf der Karte: nur MIT Identitaet (ohne traegt die Speichern-Karte die Botschaft).
  function pjRenderSyncLine() {
    const sub = document.getElementById('PvProjectSub'); if (!sub) return;
    const id = pjIdent();
    const txt = sub.querySelector('span') || sub;
    if (!id || !pjList().length) { sub.hidden = true; return; }
    sub.hidden = false;
    const st = pjSyncState();
    const d = st.at ? new Date(st.at) : null;
    const std = d ? (d.getHours() + ':' + ('0' + d.getMinutes()).slice(-2)) : '';
    const ort = id.typ === 'kunde' ? 'in Ihrem Konto' : 'am Partnerzugang';
    const warn = pjSyncZustand === 'fehler' || pjSyncZustand === 'gate';
    sub.classList.toggle('is-warn', warn);
    if (pjSyncZustand === 'fehler') txt.textContent = 'Abgleich gerade nicht möglich – hier gespeichert, wird beim nächsten Öffnen nachgeholt.';
    else if (pjSyncZustand === 'gate') txt.textContent = id.typ === 'kunde' ? 'Anmeldung abgelaufen – bitte die Seite neu laden.' : 'Partnerzugang nicht mehr gültig – gespeichert in diesem Browser.';
    else if (pjSyncZustand === 'busy' && !st.version) txt.textContent = 'Projekt wird abgeglichen …';
    else if (pjSaveFrisch && id.typ === 'kunde') txt.textContent = 'Projekt gespeichert – ab jetzt in Ihrem Konto, auf allen Geräten.';
    else txt.textContent = 'Gespeichert ' + ort + ' · auf allen Geräten' + (std ? ' · Stand ' + std : '');
  }

  function pjSendState(win) {
    // form: existiert das Projektformular auf DIESER Seite? Der Konfigurator blendet
    // den Beratungs-Button sonst aus (statt eines toten Umwegs). tourDone: Shop-
    // seitiges Einmal-Flag der Einfuehrung — der iframe-Storage ist im Admin-Preview/
    // Brave cross-site partitioniert oder fluechtig (Beda sah die Tour mehrfach).
    let tourDone = false;
    try { tourDone = !!localStorage.getItem('pv_tour_done_v1'); } catch (e) {}
    // Partnerzugang (02.09.2026): Schluessel aus dem Shop-Kontext (Zugangs-Link, s.
    // theme.liquid) + Vorbefuellung aus dem Shop-Login (window.PV_KUNDE). Der Konfigurator
    // schickt den Schluessel als Rueckfall mit, falls das Server-Cookie fehlt; die Person
    // muss dann nichts erneut oeffnen. Ohne beides bleibt partner leer — alles wie bisher.
    let partner = { key: '', email: '', name: '', firma: '' };
    try { partner.key = String(localStorage.getItem('pv_partner_key') || '').toUpperCase(); } catch (e) {}
    try {
      const k = window.PV_KUNDE;
      if (k && typeof k === 'object') {
        partner.email = typeof k.email === 'string' ? k.email : '';
        partner.name = typeof k.name === 'string' ? k.name : '';
        partner.firma = typeof k.firma === 'string' ? k.firma : '';
      }
    } catch (e) {}
    try {
      win.postMessage({
        action: 'pv_project_state',
        count: pjList().length,
        form: !!document.querySelector('[id^="PopupModal-ProjectInquiryForm-"]'),
        tourDone: tourDone,
        partner: partner
      }, PV_KFG_ORIGIN);
    } catch (e) {}
  }

  function pjFromPvIframe(e) {
    if (pjFromActiveModal(e)) return true;
    // Demo-Seite: der Konfigurator laeuft dort ohne Modal — jedes ECHTE PV-iframe
    // der Seite ist legitim (Origin ist im Listener bereits geprueft).
    return Array.from(document.querySelectorAll('iframe')).some(f =>
      f.contentWindow === e.source && String(f.src).indexOf(PV_KFG_ORIGIN) === 0);
  }

  function pjFromActiveModal(e) {
    return !!(
      __activeModalState &&
      __activeModalState.iframe &&
      __activeModalState.iframe.contentWindow &&
      e.source === __activeModalState.iframe.contentWindow
    );
  }

  // Projektformular oeffnen und Konfigurations-Links anheften (hidden-Feld
  // contact[konfigurationen] + sichtbarer Chip im Snippet project-inquiry-form.liquid).
  function pjOpenConsultForm(links, label, ptitle, muster, opts) {
    // 09.9: Eintraege duerfen Links (String) oder Positionen ({link, title, qty, note}) sein —
    // die Anfrage-Mail nennt dann Menge und Raum je Konfiguration.
    const objs = (links || []).map(l => (typeof l === 'string' ? { link: l } : l)).filter(o => o && PJ_LINK_RE.test(o.link || ''));
    const clean = objs.map(o => ((o.qty > 1 ? o.qty + '× ' : '') + (o.title ? String(o.title).slice(0, 120) + ' – ' : '')
      + (o.note ? '[' + String(o.note).slice(0, 120) + '] ' : '') + o.link));
    if (!clean.length) return;
    const offerte = !!(opts && opts.offerte);
    const preis = !!(opts && opts.preis); // Preisanfrage (kind 'preis', 0.5.23)
    const kondJa = !!(opts && opts.kond);
    // Gewaehlte Stoffe (Konfigurator 0.5.43, nur beim Stoffmuster-Anliegen): «Feld: Wert» je Stofffeld.
    const stoffe = (muster && opts && Array.isArray(opts.stoffe)) ? opts.stoffe.map(s => String(s || '').trim()).filter(Boolean).slice(0, 8) : [];
    // Kurzform fuer den Anhang-Chip: nur die Werte, hoechstens zwei, der Rest als «+N».
    const stoffKurz = stoffe.length
      ? '(' + stoffe.slice(0, 2).map(s => (s.indexOf(': ') > 0 ? s.slice(s.indexOf(': ') + 2) : s)).join(', ') + (stoffe.length > 2 ? ' +' + (stoffe.length - 2) : '') + ') '
      : '';
    // Projektname (Beda 23.07.): sichtbar im Anhang-Chip UND als erste Zeile im
    // Uebergabefeld — so traegt die Anfrage-Mail den Arbeitstitel des Kunden.
    const pt = String(ptitle || '').trim().slice(0, 80);
    const modal = document.querySelector('[id^="PopupModal-ProjectInquiryForm-"]');
    // Kein Projektformular auf der Seite (seit dem globalen Modal in theme.liquid nur
    // noch theoretisch): Kontaktseite statt PDP — die PDP wirkte wie «oeffnet einfach
    // das Produkt nochmals» (Beda 21.07.).
    if (!modal) { window.open('/pages/kontakt', '_blank', 'noopener'); return; }
    // Layer-Prinzip (Beda 02.08.): ueber dem offenen Konfigurator-Modal anzeigen.
    modal.classList.toggle('pv-above-kfg', !!__activeModalState);
    // Konfigurator-Einstieg = schlank (Beda 02.08.): eigener Titel, Projektfelder
    // zugeklappt (alle optional — die Konfiguration haengt ja als Anhang an).
    // Vom Projekt-Modal aus bleibt das volle «Projekt besprechen».
    const slim = !!(opts && opts.slim);
    const head = modal.querySelector('.pv-inquiry-form-body .ask-question-form-header h3');
    const sub = modal.querySelector('.pv-inquiry-form-body .ask-question-form-header p');
    if (head) head.textContent = offerte ? 'Offerte anfragen' : slim
      ? (muster ? 'Stoffmuster anfragen' : preis ? 'Preis anfragen' : 'Beratung anfragen')
      : 'Projekt besprechen';
    if (sub) sub.textContent = offerte
      ? 'Wir prüfen Ihr Projekt und offerieren innert eines Arbeitstags. Ein Satz zu Raum und Zeitplan hilft uns.'
      : slim
      ? (muster
        ? (stoffe.length
          ? 'Muster der gewählten Stoffe stellen wir für Sie zusammen. Weitere Wünsche nennen Sie in der Nachricht.'
          : 'Nennen Sie uns Wunschfarben oder Materialien – wir stellen passende Muster für Sie zusammen.')
        : preis
        ? 'Diese Ausführung hat keinen Online-Preis. Wir prüfen Ihre Konfiguration und melden uns persönlich mit dem Preis – innert 24 Stunden.'
        : 'Wir prüfen Ihre Konfiguration und melden uns innert 24 Stunden.')
      : 'Wir melden uns innert 24 Stunden persönlich bei Ihnen.';
    // Projektfelder immer zugeklappt (E7, Beda 02.09.): die Konfigurationen haengen an, der
    // Rest ist freiwillig — neun Felder verloren 10 von 12 Anfragen vor dem Senden.
    const det = modal.querySelector('.pv-projdetails');
    if (det) det.open = false;
    // Kurzform fuer erkannte Personen (Shop-Login oder Partnerzugang): das Formular-Snippet
    // haengt an jede Instanz form.__pvKurz — beim Oeffnen nochmals anwenden, weil die
    // Personendaten des Partnerzugangs auch erst nach dem Seitenaufbau bekannt sein koennen.
    try { modal.querySelectorAll('form').forEach(f => { if (typeof f.__pvKurz === 'function') f.__pvKurz(); }); } catch (e) {}
    // Frueherer Submit derselben Seiten-Session: Danke-Ansicht zuruecksetzen, sonst
    // beginnt die NEUE Beratungsanfrage auf dem alten «Vielen Dank» (Beda 22.07.).
    modal.querySelectorAll('form.pv-posted').forEach(f => f.classList.remove('pv-posted'));
    // Modal-scoped statt getElementById: das Formular existiert auf PDPs doppelt
    // (Produkt-Block + globales Modal) — befuellt wird das Modal, das sich oeffnet.
    const fld = modal.querySelector('#PvInquiryConfigLinks');
    if (fld) fld.value = (muster ? 'Anliegen: Stoffmuster zu dieser Konfiguration.\n' + (stoffe.length ? 'Gewählte Stoffe: ' + stoffe.join('; ') + '\n' : '') : '')
      + (preis ? 'Anliegen: Preisanfrage – diese Ausführung hat keinen Online-Preis.\n' : '')
      + (offerte ? 'Anliegen: Offerte für das Projekt (' + String((opts && opts.kondTxt) || '') + (kondJa ? '; Projektkonditionen: ja' : '') + ').\n' : '')
      + (pt ? 'Projekt: ' + pt + '\n' : '') + clean.join('\n');
    const chip = modal.querySelector('#PvInquiryAttach');
    const txt = modal.querySelector('#PvInquiryAttachText');
    if (chip && txt) {
      txt.textContent = (muster ? 'Stoffmuster ' + stoffKurz + '· ' : preis ? 'Preisanfrage · ' : '') + (pt ? 'Projekt «' + pt + '» – ' : '') + (label || 'Ihre Konfiguration');
      // Mit Stoffnamen wird der Chip laenger als eine Telefonzeile (iPhone-Abnahme 22.09.): dann umbrechen statt
      // abschneiden — .pv-attach b steht auf nowrap, das × lag sonst ueber dem Text.
      txt.style.whiteSpace = (muster && stoffe.length) ? 'normal' : '';
      chip.hidden = false;
      const x = modal.querySelector('#PvInquiryAttachRemove');
      if (x) x.onclick = () => { if (fld) fld.value = ''; chip.hidden = true; };
    }
    const show = () => { try { if (typeof modal.show === 'function') modal.show(); } catch (e) {} };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('basic-modal').then(() => setTimeout(show, 180));
    } else setTimeout(show, 180);
  }

  // Summe ueber Preis × Menge — nur, wenn ALLE Preise parsebar sind (lieber keine als eine falsche).
  function pjSumNum(list) {
    let sum = 0;
    for (const it of list) {
      const m = /CHF\s*([\d'’]+(?:\.\d{2})?)/.exec(it.price || '');
      if (!m) return null;
      sum += parseFloat(m[1].replace(/['’]/g, '')) * (it.qty || 1);
    }
    return isFinite(sum) && sum > 0 ? sum : null;
  }
  // PV 31.07.: ganze Franken ohne «.00» (Konfigurator 0.4.16 + Theme-Liquid ziehen gleich);
  // echte Rappen bleiben zweistellig.
  function pjFmt(sum) {
    const parts = Number(sum).toFixed(2).split('.');
    return 'CHF ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + (parts[1] === '00' ? '' : '.' + parts[1]);
  }
  function pjChf(list) { const s = pjSumNum(list); return s == null ? '' : pjFmt(s); }
  function pjStueck(list) { return list.reduce((n, x) => n + (x.qty || 1), 0); }

  // Projektrabatt (Beda 02.09.2026, Paket 2): der Anreiz, das Projekt bei uns anzufragen —
  // Schwelle in Stueck ODER Projektsumme. Beide Zahlen wandern in den Snapshot, damit das
  // Projektblatt dieselben Werte druckt. Wortlaut und Zahlen sind ein VORSCHLAG; das hier ist
  // die einzige Stelle im Theme, an der sie stehen.
  const PJ_KOND = { stueck: 5, chf: 5000 };
  function pjKond(list) {
    const st = pjStueck(list), sum = pjSumNum(list);
    const erreicht = list.length > 0 && (st >= PJ_KOND.stueck || (sum != null && sum >= PJ_KOND.chf));
    return { stueck: st, sum: sum, erreicht: erreicht,
      fehltStueck: Math.max(0, PJ_KOND.stueck - st), fehltChf: sum == null ? null : Math.max(0, PJ_KOND.chf - sum) };
  }

  // Theme-seitige Funnel-Beacons (Review 22.07.): die CTAs im Projekt-/Shared-Modal
  // und das Teilen liefen an der Messung vorbei — gleiche Leitung wie der pv_metric-
  // Pfad (sendBeacon text/plain -> kein Preflight; dieselbe sessionStorage-Sid, damit
  // die Funnel-Kachel Sitzungen konsistent zaehlt).
  function pjKfgBeacon(evt, meta) {
    try {
      if (!navigator.sendBeacon) return;
      let sid = sessionStorage.getItem('pv_kfg_sid');
      if (!sid) {
        sid = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        sessionStorage.setItem('pv_kfg_sid', sid);
      }
      navigator.sendBeacon('https://pms.primovero.ch/collect', new Blob([JSON.stringify({
        src: 'shop', t: 'kfg_' + evt, sid: sid,
        path: window.location.pathname,
        meta: meta || {}
      })], { type: 'text/plain' }));
    } catch (e) {}
  }

  const PJ_TITLE_KEY = 'pv_project_title_v1';
  function pjGetTitle() {
    // Feld gewinnt (frischste Eingabe); ohne offenes Modal traegt localStorage den
    // Namen — so kommt er auch in «Beratung zu dieser Konfiguration» aus dem
    // Konfigurator und in jedes Teilen (Beda 23.07. «ueberall uebernehmen»).
    const inp = document.getElementById('PvProjectTitle');
    const v = inp ? String(inp.value || '').trim() : '';
    if (v) return v.slice(0, 80);
    try { return String(localStorage.getItem(PJ_TITLE_KEY) || '').trim().slice(0, 80); } catch (e) { return ''; }
  }

  // --- Projekt teilen (Beda 22.07.): unveraenderlicher Server-Snapshot der Liste,
  // kurzer Link https://primovero.ch/?pvproject=<id>; Empfang unten (pjOpenSharedModal).
  const PJ_SHARE_API = 'https://api.primovero.ch/konfigurator/api/project-share.cfm';
  // P = Snapshot (project-share.cfm), Q = lebendes Projekt am Partnerzugang (Etappe B)
  const PJ_PROJECT_ID_RE = /^[PQ][A-F0-9]{12}$/;

  // Snapshot der Liste beim Server (Teilen UND Projektblatt): Mengen, Notizen, Hersteller,
  // Artikel und die Rabatt-Schwellen gehen mit. Thumbs, solange das Server-Budget reicht
  // (bodyJson kappt bei 2 MB). Liefert {ok, id, url}.
  function pjSnapshot(list) {
    const items = pjItemsPayload(list);
    const ac = ('AbortController' in window) ? new AbortController() : null;
    const tId = ac ? setTimeout(() => ac.abort(), 12000) : 0;
    // String-Body ohne Content-Type-Header = simple request (kein CORS-Preflight noetig).
    return fetch(PJ_SHARE_API, { method: 'POST', body: JSON.stringify({ title: pjGetTitle(), kond: PJ_KOND, items: items }), signal: ac ? ac.signal : undefined })
      .then(r => r.json())
      .then(j => {
        clearTimeout(tId);
        if (!j || !j.ok || !j.url || !PJ_PROJECT_ID_RE.test(j.id || '')) throw new Error((j && j.error) || 'Fehler');
        return j;
      })
      .catch(e => { clearTimeout(tId); throw e; });
  }

  function pjShareProject(btn, mode) {
    const list = pjList();
    if (!list.length || btn.dataset.busy) return;
    btn.dataset.busy = '1';
    const lbl = btn.querySelector('span') || btn;
    const old = lbl.textContent;
    const out = document.getElementById('PvProjectShareOut');
    const reset = () => { lbl.textContent = old; delete btn.dataset.busy; };
    // Fallback ohne blockierendes prompt(): Link-Zeile im Modal, vorselektiert.
    const showLink = (url, live) => {
      if (!out) return reset();
      out.hidden = false;
      const inp = out.querySelector('input');
      inp.value = url;
      // Lebender Link (Audit 03.09.2026, B9): wer teilt, soll wissen, dass der Empfaenger jeden
      // spaeteren Stand sieht.
      const hint = out.querySelector('#PvProjectShareHint'); if (hint) hint.hidden = !live;
      try { inp.focus(); inp.select(); } catch (e) {}
      reset();
    };
    lbl.textContent = 'Link wird erstellt…';
    if (out) out.hidden = true;
    pjLinkQuelle(list)
      .then(j => {
        pjKfgBeacon('share', { src: 'project', mode: mode === 'mail' ? 'mail' : 'link', n: list.length, stk: pjStueck(list) });
        const pt = pjGetTitle();
        const copied = () => { lbl.textContent = 'Link kopiert ✓'; if (j.live) showLink(j.url, true); setTimeout(reset, 2600); };
        if (mode === 'mail') {
          // Vorbefuellte Mail im eigenen Mailprogramm — «an mich selbst / an die
          // Geschaeftsleitung» ist der weichste Einstieg (Beda-Vorschlag 4).
          const su = encodeURIComponent(pt ? 'Projekt «' + pt + '» – Primo Vero' : 'Ihre Möbel-Konfigurationen bei Primo Vero');
          const bo = encodeURIComponent('Guten Tag\r\n\r\n' + (pt ? 'Hier finden Sie unser Projekt «' + pt + '» bei Primo Vero:' : 'Hier finden Sie unsere zusammengestellten Konfigurationen bei Primo Vero:') + '\r\n' + j.url + '\r\n\r\nProjektblatt (PDF): ' + PJ_PDF_API + '?id=' + j.id + (j.live ? '\r\n\r\nDer Link zeigt immer den aktuellen Stand des Projekts.' : '') + '\r\n\r\nFreundliche Grüsse');
          window.location.href = 'mailto:?subject=' + su + '&body=' + bo;
          reset();
          return;
        }
        // Touch: natives Teilen-Sheet. Desktop: Zwischenablage (das Windows-Share-
        // Popup irritiert dort nur). Verweigert/fehlt beides -> Link-Zeile.
        const coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
        if (coarse && navigator.share) {
          navigator.share({ title: pt ? 'Projekt «' + pt + '» – Primo Vero' : 'Primo Vero – Projekt', text: 'Unsere Möbel-Konfigurationen bei Primo Vero', url: j.url })
            .then(reset)
            .catch(err => { if (err && err.name === 'AbortError') reset(); else showLink(j.url, !!j.live); });
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(j.url).then(copied, () => showLink(j.url, !!j.live));
        } else showLink(j.url, !!j.live);
      })
      .catch(() => {
        lbl.textContent = 'Teilen fehlgeschlagen – erneut versuchen';
        setTimeout(reset, 3200);
      });
  }

  // Projektblatt als PDF (Paket 2, Beda 02.09.): Snapshot wie beim Teilen, dann
  // project-pdf.cfm?id= — Lucee laesst das PMS rendern (Hausstil wie AB/Produktliste) und
  // haelt die Datei am Snapshot. Das Fenster wird SYNCHRON im Klick geoeffnet (Popup-Sperre
  // in Safari) und nach dem Snapshot auf die PDF geleitet; geht das nicht, erscheint die
  // Link-Zeile mit der PDF-Adresse.
  const PJ_PDF_API = 'https://api.primovero.ch/konfigurator/api/project-pdf.cfm';
  function pjProjektblatt(btn) {
    const list = pjList();
    if (!list.length || btn.dataset.busy) return;
    let win = null;
    try {
      win = window.open('', '_blank');
      if (win && win.document) {
        win.document.title = 'Projektblatt wird erstellt…';
        win.document.body.innerHTML = '<p style="font:15px/1.5 system-ui,sans-serif;padding:28px;color:#444">Projektblatt wird erstellt…</p>';
      }
    } catch (e) { win = null; }
    btn.dataset.busy = '1';
    const lbl = btn.querySelector('span') || btn;
    const old = lbl.textContent;
    const out = document.getElementById('PvProjectShareOut');
    const reset = () => { lbl.textContent = old; delete btn.dataset.busy; };
    lbl.textContent = 'Projektblatt wird erstellt…';
    pjLinkQuelle(list)
      .then(j => {
        const k = pjKond(list);
        pjKfgBeacon('pdf', { n: list.length, stk: k.stueck, kond: k.erreicht ? 1 : 0 });
        const pdfUrl = PJ_PDF_API + '?id=' + j.id;
        if (win && !win.closed) { win.location.href = pdfUrl; reset(); return; }
        if (out) {
          out.hidden = false;
          const inp = out.querySelector('input');
          inp.value = pdfUrl;
          try { inp.focus(); inp.select(); } catch (e) {}
        }
        reset();
      })
      .catch(() => {
        try { if (win && !win.closed) win.close(); } catch (e) {}
        lbl.textContent = 'Projektblatt fehlgeschlagen – erneut versuchen';
        setTimeout(reset, 3200);
      });
  }

  function pjOpenSharedModal(doc, sharedId) {
    // Server validiert schon — hier Doppelgurt: nur echte pvshare-Links rendern.
    const items = (doc.items || []).filter(x => x && typeof x.link === 'string' && PJ_LINK_RE.test(x.link)).slice(0, 30).map(pjNorm);
    if (!items.length) return;
    let m = document.getElementById('PvSharedProjectModal');
    if (!m) {
      m = document.createElement('basic-modal');
      m.id = 'PvSharedProjectModal';
      m.className = 'drawer modal';
      m.innerHTML =
        '<style>' +
        '#PvSharedProjectModal .pvpj{padding:0 2px}' +
        '#PvSharedProjectModal .pvpj h3{margin:0 0 4px}' +
        '#PvSharedProjectModal .pvpj__sub{margin:0 0 12px;font-size:13px;opacity:.65}' +
        '#PvSharedProjectModal .pvpj__item{display:flex;align-items:center;gap:12px;padding:10px 0;border-top:1px solid rgba(0,0,0,.08)}' +
        '#PvSharedProjectModal .pvpj__item:last-of-type{border-bottom:1px solid rgba(0,0,0,.08)}' +
        '#PvSharedProjectModal .pvpj__img{width:52px;height:52px;border-radius:8px;object-fit:cover;background:#f4f4f3;flex:none;display:block}' +
        '#PvSharedProjectModal .pvpj__t{flex:1 1 auto;min-width:0}' +
        '#PvSharedProjectModal .pvpj__name{font-weight:600;font-size:14px;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
        '#PvSharedProjectModal .pvpj__meta{font-size:12.5px;opacity:.65}' +
        '#PvSharedProjectModal .pvpj__open{font-size:12.5px;text-decoration:underline;text-underline-offset:2px;color:inherit;white-space:nowrap}' +
        '#PvSharedProjectModal .pvpj__sum{display:flex;justify-content:space-between;font-size:14px;font-weight:600;margin:12px 2px 0}' +
        '#PvSharedProjectModal .pvpj__cta{margin-top:14px}' +
        '#PvSharedProjectModal .pvpj__cta .btn{width:100%}' +
        '#PvSharedProjectModal .pvpj__share{margin-top:8px}' +
        '#PvSharedProjectModal .pvpj__share button,#PvSharedProjectModal .pvpj__share a{width:100%;height:44px;display:flex;align-items:center;justify-content:center;gap:8px;background:none;border:1px solid rgba(0,0,0,.18);border-radius:8px;font:inherit;font-size:13.5px;cursor:pointer;color:inherit;text-decoration:none}' +
        '#PvSharedProjectModal .pvpj__share button:hover,#PvSharedProjectModal .pvpj__share a:hover{border-color:rgba(0,0,0,.4)}' +
        '#PvSharedProjectModal .pvpj__note{font-size:12.5px;opacity:.75;margin-top:2px}' +
        '#PvSharedProjectModal .pvpj h3{padding-right:44px}' +
        '#PvSharedProjectModal .pvpj__t{flex:1 1 0%;min-width:0}' +
        '#PvSharedProjectModal .pvpj__img,#PvSharedProjectModal .pvpj__open{flex:none}' +
        '#PvSharedProjectModal .drawer__inner{display:flex;flex-direction:column;max-height:calc(100vh - 3.2rem);max-height:calc(100dvh - 3.2rem)}' +
        '#PvSharedProjectModal .drawer__body{flex:1 1 auto;min-height:0;max-height:none;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding-bottom:calc(2rem + env(safe-area-inset-bottom))}' +
        '@media (max-width:640px){#PvSharedProjectModal .pvpj__name{white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}}' +
        '#PvSharedProjectModal .pvpj__share button[disabled]{opacity:.55;cursor:default}' +
        '#PvSharedProjectModal .pvpj__hint{margin:10px 0 0;font-size:12px;opacity:.55;text-align:center}' +
        '</style>' +
        '<div class="fixed-overlay" aria-controls="PvSharedProjectModal"></div>' +
        '<div class="drawer__inner">' +
        '<button class="drawer__close-btn" aria-controls="PvSharedProjectModal" aria-label="Schliessen"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24" style="width:18px;height:18px"><path d="M18.75 5.135 5.25 18.854" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M5.25 5.135 18.75 18.854" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
        '<div class="drawer__body v-scrollable h-full"><div class="pvpj">' +
        '<h3 class="h5">Geteiltes Projekt</h3>' +
        '<p class="pvpj__sub" id="PvSharedSub"></p>' +
        '<div id="PvSharedItems"></div>' +
        '<div class="pvpj__sum" id="PvSharedSum" hidden><span>Gesamt</span><span id="PvSharedSumVal"></span></div>' +
        '<div class="pvpj__cta"><button type="button" class="btn btn--primary" id="PvSharedConsult"><span class="btn__text"></span></button></div>' +
        '<div class="pvpj__share"><button type="button" id="PvSharedImport"><span>In mein Projekt übernehmen</span></button></div>' +
        '<div class="pvpj__share" id="PvSharedPdfWrap" hidden><a id="PvSharedPdf" href="#" target="_blank" rel="noopener"><span>Projektblatt (PDF)</span></a></div>' +
        '<p class="pvpj__hint">Diese Liste wurde mit Ihnen geteilt – «Ansehen» öffnet die Konfiguration in 3D.</p>' +
        '</div></div></div>';
      document.body.appendChild(m);
      m.querySelector('#PvSharedConsult').addEventListener('click', () => {
        try { if (typeof m.hide === 'function') m.hide(); else m.querySelector('.drawer__close-btn').click(); } catch (e) {}
        pjKfgBeacon('consult', { src: 'shared', n: items.length });
        const label = items.length === 1
          ? (items[0].title || 'Ihre Konfiguration')
          : items.length + ' Konfigurationen (geteiltes Projekt)';
        const kondTxt = items.length + (items.length === 1 ? ' Position, ' : ' Positionen, ') + pjStueck(items) + ' Stück' + (pjChf(items) ? ', ' + pjChf(items) : '');
        setTimeout(() => pjOpenConsultForm(items, label, sharedTitle, false, { offerte: true, kond: pjKond(items).erreicht, kondTxt: kondTxt }), 240);
      });
      m.querySelector('#PvSharedImport').addEventListener('click', ev => {
        const b = ev.currentTarget;
        const cur = pjList();
        for (const x of items) {
          const xid = (x.id && String(x.id).slice(0, 64)) || (x.link.split('pvshare=')[1] || '').slice(0, 64);
          if (!cur.some(y => y.id === xid)) {
            cur.push({ id: xid, link: x.link, title: String(x.title || 'Konfiguration').slice(0, 120),
              price: String(x.price || '').slice(0, 40), qty: x.qty || 1, note: x.note || '', vendor: x.vendor || '', ban: x.ban || '', mod: Date.now(),
              img: (typeof x.img === 'string' && x.img.indexOf('data:image/jpeg;base64,') === 0 && x.img.length < 60000) ? x.img : '',
              at: (typeof x.at === 'number' && x.at > 0) ? x.at : Date.now() });
          }
        }
        pjSave(cur);
        pjRender();
        pjKfgBeacon('project_import', { n: items.length });
        b.disabled = true;
        b.querySelector('span').textContent = 'Übernommen ✓ – oben im Projekt';
      });
    }
    const wrap = m.querySelector('#PvSharedItems');
    wrap.innerHTML = items.map(it => {
      const img = (typeof it.img === 'string' && it.img.indexOf('data:image/jpeg;base64,') === 0)
        ? '<img class="pvpj__img" alt="" src="' + pjEsc(it.img) + '">'
        : '<span class="pvpj__img"></span>';
      return '<div class="pvpj__item">' + img +
        '<div class="pvpj__t"><div class="pvpj__name">' + pjEsc(it.title || 'Konfiguration') + '</div>' +
        '<div class="pvpj__meta">' + pjEsc(pjMeta(it)) + '</div>' +
        (it.note ? '<div class="pvpj__note">' + pjEsc(it.note) + '</div>' : '') + '</div>' +
        '<a class="pvpj__open" href="' + pjEsc(it.link) + '" target="_blank" rel="noopener">Ansehen</a></div>';
    }).join('');
    const sharedTitle = typeof doc.title === 'string' ? doc.title.trim().slice(0, 80) : '';
    m.querySelector('h3').textContent = sharedTitle ? 'Projekt «' + sharedTitle + '»' : 'Geteiltes Projekt';
    let standTxt = '';
    try { if (doc.live && doc.updated_at) { const d = new Date(doc.updated_at); if (!isNaN(d)) standTxt = ' (Stand ' + d.getDate() + '.' + (d.getMonth() + 1) + '., ' + d.getHours() + ':' + ('0' + d.getMinutes()).slice(-2) + ')'; } } catch (e) {}
    m.querySelector('#PvSharedSub').textContent = (items.length === 1
      ? 'Eine Konfiguration, zusammengestellt bei Primo Vero.'
      : items.length + ' Konfigurationen, zusammengestellt bei Primo Vero.')
      + (doc.live ? ' Lebender Projektlink: zeigt immer den aktuellen Stand' + standTxt + '.' : '');
    const sum = pjChf(items);
    const sumRow = m.querySelector('#PvSharedSum');
    sumRow.hidden = !sum || (items.length < 2 && pjStueck(items) < 2);
    m.querySelector('#PvSharedSumVal').textContent = sum;
    sumRow.querySelector('span').textContent = 'Gesamt (' + pjStueck(items) + ' Stück)';
    // Projektblatt zum geteilten Snapshot: dieselbe Id, keine neue Kopie noetig.
    const pdfWrap = m.querySelector('#PvSharedPdfWrap'), pdfA = m.querySelector('#PvSharedPdf');
    if (pdfWrap && pdfA) {
      const okId = typeof sharedId === 'string' && PJ_PROJECT_ID_RE.test(sharedId);
      pdfWrap.hidden = !okId;
      if (okId) pdfA.href = PJ_PDF_API + '?id=' + sharedId;
    }
    m.querySelector('#PvSharedConsult .btn__text').textContent = 'Offerte anfragen (' + items.length + ')';
    const show = () => { try { if (typeof m.show === 'function') m.show(); } catch (e) {} };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('basic-modal').then(() => setTimeout(show, 60));
    } else setTimeout(show, 60);
  }

  function pjEnsureModal() {
    let m = document.getElementById('PvProjectModal');
    if (m) return m;
    m = document.createElement('basic-modal');
    m.id = 'PvProjectModal';
    m.className = 'drawer modal';
    // Projektkarte neu (Beda 02.09. nachts): Kopf = Name (editierbar) + Kennzahlen + Status;
    // Positionen; Speichern-Karte (ohne Konto) ODER Konditionen-Satz (mit Identitaet, Schwelle
    // erreicht, ohne Zahlen); EIN Hauptknopf «Offerte anfragen»; Teilen und Projektblatt leise.
    m.innerHTML =
      '<style>' +
      '#PvProjectModal .pvpj{padding:0 2px}' +
      '#PvProjectModal .pvpj__kopf{padding-right:44px;margin:0 0 4px}' +
      '#PvProjectModal .pvpj__kopf[hidden]{display:none}' +
      '#PvProjectModal input.pvpj__titel{display:block;width:100%;border:0;border-bottom:1px dashed transparent;border-radius:0;box-shadow:none;background:none;padding:0 0 2px;margin:0;height:auto;min-height:0;font-weight:600;font-size:20px;line-height:1.3;color:inherit;letter-spacing:inherit;outline:none}' +
      '#PvProjectModal input.pvpj__titel:hover{border-bottom-color:rgba(0,0,0,.2)}' +
      '#PvProjectModal input.pvpj__titel:focus{border-bottom-color:rgba(0,0,0,.4)}' +
      '#PvProjectModal input.pvpj__titel::placeholder{color:rgba(0,0,0,.45)}' +
      '#PvProjectModal .pvpj__kenn{margin:4px 0 0;font-size:13px;opacity:.7}' +
      '#PvProjectModal .pvpj__status{display:flex;align-items:center;gap:7px;margin:6px 0 0;font-size:12.5px;color:#3f7a52;line-height:1.35}' +
      '#PvProjectModal .pvpj__status i{width:7px;height:7px;border-radius:50%;background:#3f7a52;flex:none}' +
      '#PvProjectModal .pvpj__status.is-warn{color:#8a5a12}#PvProjectModal .pvpj__status.is-warn i{background:#c98a1e}' +
      '#PvProjectModal .pvpj__status[hidden]{display:none}' +
      '#PvProjectModal .pvpj__item{display:flex;align-items:center;gap:12px;padding:10px 0;border-top:1px solid rgba(0,0,0,.08);flex-wrap:wrap}' +
      '#PvProjectModal .pvpj__item:last-of-type{border-bottom:1px solid rgba(0,0,0,.08)}' +
      '#PvProjectModal .pvpj__img{width:52px;height:52px;border-radius:8px;object-fit:cover;background:#f4f4f3;flex:none;display:block}' +
      '#PvProjectModal .pvpj__t{flex:1 1 0%;min-width:0}' +
      '#PvProjectModal .pvpj__name{font-weight:600;font-size:14px;line-height:1.3;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '#PvProjectModal .pvpj__meta{font-size:12.5px;opacity:.65}' +
      '#PvProjectModal .pvpj__open{font-size:12.5px;text-decoration:underline;text-underline-offset:2px;color:inherit;white-space:nowrap;flex:none}' +
      '#PvProjectModal .pvpj__rm{border:0;background:none;font-size:18px;line-height:1;padding:8px;cursor:pointer;opacity:.5;flex:none}' +
      '#PvProjectModal .pvpj__rm:hover{opacity:1}' +
      '#PvProjectModal .pvpj__ctl{display:flex;align-items:center;gap:8px;min-width:0;flex:0 0 100%;padding-left:64px;margin-top:8px}' +
      '#PvProjectModal .pvpj__qty{display:inline-flex;align-items:center;border:1px solid rgba(0,0,0,.15);border-radius:8px;flex:none;height:32px;background:#fff}' +
      '#PvProjectModal .pvpj__qty button{border:0;background:none;width:30px;height:30px;font-size:16px;line-height:1;cursor:pointer;color:inherit;padding:0}' +
      '#PvProjectModal .pvpj__qty input{width:34px;height:30px;border:0;background:none;text-align:center;font:inherit;font-size:13.5px;color:inherit;padding:0;-moz-appearance:textfield}' +
      '#PvProjectModal .pvpj__qty input::-webkit-outer-spin-button,#PvProjectModal .pvpj__qty input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}' +
      '#PvProjectModal .pvpj__note{flex:1 1 auto;min-width:0;height:32px;padding:0 9px;border:1px solid rgba(0,0,0,.15);border-radius:8px;font:inherit;font-size:12.5px;color:inherit;background:#fff}' +
      '#PvProjectModal .pvpj__note::placeholder{color:rgba(0,0,0,.4)}' +
      '#PvProjectModal .pvpj__karte{margin:12px 2px 0;padding:12px 14px;background:#f4f4f2;border-radius:10px;font-size:12.8px;line-height:1.45}' +
      '#PvProjectModal .pvpj__karte[hidden]{display:none}' +
      '#PvProjectModal .pvpj__karte b{display:block;font-weight:600;margin-bottom:2px}' +
      '#PvProjectModal .pvpj__karte.is-ok{background:#eef4ee}' +
      '#PvProjectModal .pvpj__savebtn{display:inline-block;margin-top:10px;padding:8px 13px;border:1px solid rgba(0,0,0,.28);border-radius:8px;font-size:13px;font-weight:500;color:inherit;text-decoration:none;background:#fff}' +
      '#PvProjectModal .pvpj__savebtn:hover{border-color:rgba(0,0,0,.55)}' +
      '#PvProjectModal button.pvpj__savebtn{font-family:inherit;line-height:1.2;cursor:pointer}' +
      '#PvProjectModal .pvpj__savebtn--leise{border-color:transparent;background:none;opacity:.7}' +
      '#PvProjectModal .pvpj__savebtn--leise:hover{border-color:transparent;opacity:1}' +
      '#PvProjectModal .pvpj__hint2{display:block;margin-top:6px;font-size:12px;opacity:.65}' +
      '#PvProjectModal .pvpj__hint2[hidden],#PvProjectModal .pvpj__leise button[hidden],#PvProjectModal .pvpj__dot[hidden]{display:none}' +
      '#PvProjectModal .pvpj__cta{margin-top:14px}' +
      '#PvProjectModal .pvpj__cta[hidden]{display:none}' +
      '#PvProjectModal .pvpj__cta .btn{width:100%}' +
      '#PvProjectModal .pvpj__leise{display:flex;justify-content:center;align-items:center;gap:10px;margin-top:10px;font-size:12.5px}' +
      '#PvProjectModal .pvpj__leise[hidden]{display:none}' +
      '#PvProjectModal .pvpj__leise button,#PvProjectModal .pvpj__leise a{border:0;background:none;font:inherit;font-size:12.5px;color:inherit;opacity:.7;text-decoration:underline;text-underline-offset:2px;cursor:pointer;padding:6px 2px}' +
      '#PvProjectModal .pvpj__leise button:hover,#PvProjectModal .pvpj__leise a:hover{opacity:1}' +
      '#PvProjectModal .pvpj__leise button[disabled]{opacity:.35;cursor:default;text-decoration:none}' +
      '#PvProjectModal .pvpj__dot{opacity:.4}' +
      '#PvProjectModal .pvpj__shareout{margin-top:8px}' +
      '#PvProjectModal .pvpj__shareout[hidden]{display:none}' +
      '#PvProjectModal .pvpj__shareout input{width:100%;height:40px;padding:0 10px;border:1px solid rgba(0,0,0,.15);border-radius:8px;font-size:12.5px;color:inherit;background:#fafaf9}' +
      '#PvProjectModal .pvpj__empty{padding:14px 4px 8px;text-align:center;font-size:14px;line-height:1.5}' +
      '#PvProjectModal .pvpj__empty h3{margin:0 0 8px;padding-right:44px;text-align:left}' +
      '#PvProjectModal .pvpj__empty p{margin:0 0 14px;opacity:.7;text-align:left}' +
      '#PvProjectModal .pvpj__empty .btn{width:100%}' +
      '#PvProjectModal .drawer__inner{display:flex;flex-direction:column;max-height:calc(100vh - 3.2rem);max-height:calc(100dvh - 3.2rem)}' +
      '#PvProjectModal .drawer__body{flex:1 1 auto;min-height:0;max-height:none;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding-bottom:calc(2rem + env(safe-area-inset-bottom))}' +
      '@media (max-width:640px){#PvProjectModal .pvpj__ctl{padding-left:0}#PvProjectModal .pvpj__dat{display:none}' +
      '#PvProjectModal .pvpj__name{white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
      '#PvProjectModal .pvpj__meta{white-space:normal}#PvProjectModal .pvpj__note{font-size:16px}#PvProjectModal input.pvpj__titel{font-size:19px}}' +
      '</style>' +
      '<div class="fixed-overlay" aria-controls="PvProjectModal"></div>' +
      '<div class="drawer__inner">' +
      '<button class="drawer__close-btn" aria-controls="PvProjectModal" aria-label="Schliessen"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 24 24" style="width:18px;height:18px"><path d="M18.75 5.135 5.25 18.854" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M5.25 5.135 18.75 18.854" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<div class="drawer__body v-scrollable h-full"><div class="pvpj">' +
      '<div class="pvpj__kopf" id="PvProjectKopf">' +
      '<input type="text" class="pvpj__titel h5" id="PvProjectTitle" maxlength="80" placeholder="Ihr Projekt – Namen vergeben" aria-label="Projektname" autocomplete="off">' +
      '<p class="pvpj__kenn" id="PvProjectKenn"></p>' +
      '<p class="pvpj__status" id="PvProjectSub" hidden><i aria-hidden="true"></i><span></span></p>' +
      '</div>' +
      '<div id="PvProjectItems"></div>' +
      '<div class="pvpj__karte" id="PvProjectPend" hidden><b>Konfigurationen aus diesem Browser</b><span id="PvProjectPendText"></span><br><button type="button" class="pvpj__savebtn" id="PvProjectPendTake">In mein Projekt übernehmen</button> <button type="button" class="pvpj__savebtn pvpj__savebtn--leise" id="PvProjectPendDrop">Verwerfen</button></div>' +
      '<div class="pvpj__karte" id="PvProjectSave" hidden><b>Projekt speichern</b><span>Mit Ihrem Konto liegt das Projekt auf jedem Gerät, Sie teilen es mit Kolleginnen und Kollegen, und gespeicherte Projekte offerieren wir mit Projektkonditionen. Kein Passwort: ein Code per E-Mail genügt.</span><br><a class="pvpj__savebtn" id="PvProjectSaveBtn" href="#">Speichern mit Konto</a></div>' +
      '<div class="pvpj__karte is-ok" id="PvProjectKond" hidden><b>Projektkonditionen</b><span id="PvProjectKondText">Für dieses Projekt offerieren wir mit Projektkonditionen. Sie erhalten die Offerte innert eines Arbeitstags.</span></div>' +
      '<div class="pvpj__cta" id="PvProjectCta"><button type="button" class="btn btn--primary" id="PvProjectConsult"><span class="btn__text">Offerte anfragen</span></button></div>' +
      '<div class="pvpj__leise" id="PvProjectLeise"><button type="button" id="PvProjectShare">Teilen</button><span class="pvpj__dot">·</span><button type="button" id="PvProjectPdf">Projektblatt (PDF)</button><span class="pvpj__dot" id="PvProjectDelDot" hidden>·</span><button type="button" id="PvProjectDelete" hidden>Aus dem Konto entfernen</button></div>' +
      '<div class="pvpj__shareout" id="PvProjectShareOut" hidden><input type="text" readonly aria-label="Link zu Ihrem Projekt"><span class="pvpj__hint2" id="PvProjectShareHint" hidden>Der Empfänger sieht immer den aktuellen Stand Ihres Projekts.</span></div>' +
      '</div></div></div>';
    document.body.appendChild(m);
    m.addEventListener('click', ev => {
      const rm = ev.target && ev.target.closest ? ev.target.closest('[data-pj-remove]') : null;
      if (!rm) return;
      pjTombstone(rm.getAttribute('data-pj-remove'));
      pjSave(pjList().filter(x => x.id !== rm.getAttribute('data-pj-remove')));
      pjRender();
      if (__activeModalState && __activeModalState.iframe && __activeModalState.iframe.contentWindow) {
        pjSendState(__activeModalState.iframe.contentWindow);
      }
    });
    // Mengen und Notizen (09.9): Stepper und Feld je Position — Aenderungen landen sofort im
    // Speicher; Kennzahlen und Konditionen rechnen mit. Die Notiz wird ohne Neuaufbau
    // gespeichert (sonst verloere das Feld beim Tippen den Fokus).
    const pjSet = (id, fn) => { const l = pjList(); const it = l.find(x => x.id === id); if (!it) return; fn(it); it.mod = Date.now(); pjSave(l); };
    m.addEventListener('click', ev => {
      const b = ev.target && ev.target.closest ? ev.target.closest('[data-pj-qty]') : null;
      if (!b) return;
      const row = b.closest('[data-pj-id]'); if (!row) return;
      pjSet(row.getAttribute('data-pj-id'), it => { it.qty = Math.max(1, Math.min(99, (it.qty || 1) + parseInt(b.getAttribute('data-pj-qty'), 10))); });
      pjRender();
    });
    m.addEventListener('change', ev => {
      const inp = ev.target && ev.target.matches && ev.target.matches('[data-pj-qtyin]') ? ev.target : null;
      if (!inp) return;
      const row = inp.closest('[data-pj-id]'); if (!row) return;
      const q = parseInt(inp.value, 10);
      pjSet(row.getAttribute('data-pj-id'), it => { it.qty = isFinite(q) ? Math.max(1, Math.min(99, q)) : 1; });
      pjRender();
    });
    let noteT = null;
    m.addEventListener('input', ev => {
      const inp = ev.target && ev.target.matches && ev.target.matches('[data-pj-note]') ? ev.target : null;
      if (!inp) return;
      const row = inp.closest('[data-pj-id]'); if (!row) return;
      const id = row.getAttribute('data-pj-id'), val = String(inp.value || '').slice(0, 120);
      clearTimeout(noteT);
      noteT = setTimeout(() => pjSet(id, it => { it.note = val; }), 250);
    });
    const pdfBtn = m.querySelector('#PvProjectPdf');
    if (pdfBtn) pdfBtn.addEventListener('click', () => pjProjektblatt(pdfBtn));
    const shr = m.querySelector('#PvProjectShare');
    if (shr) shr.addEventListener('click', () => pjShareProject(shr));
    // «Speichern mit Konto»: zum Shopify-Login (Code per E-Mail), zurueck hierher mit ?pvsave=1.
    const sv = m.querySelector('#PvProjectSaveBtn');
    if (sv) sv.addEventListener('click', ev => {
      ev.preventDefault();
      const list = pjList();
      pjKfgBeacon('save_click', { n: list.length, stk: pjStueck(list) });
      window.location.href = pjLoginUrl();
    });
    // Geparkte Browserliste (B4): uebernehmen oder verwerfen — beides eine Entscheidung der Person.
    const pt = m.querySelector('#PvProjectPendTake');
    if (pt) pt.addEventListener('click', () => {
      const p = pjPending(); if (!p) return;
      const cur = pjList();
      for (const x of p.items) { if (x && x.id && !cur.some(y => y.id === x.id)) cur.push(Object.assign({}, x, { mod: Date.now() })); }
      let vorhanden = ''; try { vorhanden = String(localStorage.getItem(PJ_TITLE_KEY) || '').trim(); } catch (e) {}
      if (p.title && !vorhanden) { try { localStorage.setItem(PJ_TITLE_KEY, String(p.title).slice(0, 80)); localStorage.setItem(PJ_TITLE_MOD_KEY, String(Date.now())); const inp = document.getElementById('PvProjectTitle'); if (inp) inp.value = String(p.title).slice(0, 80); } catch (e) {} }
      pjPendingSet(null);
      pjSave(cur);
      pjRender();
    });
    const pd = m.querySelector('#PvProjectPendDrop');
    if (pd) pd.addEventListener('click', () => { pjPendingSet(null); pjRender(); });
    // Projekt aus dem Konto / vom Partnerzugang entfernen (B8): zwei Klicks, kein Dialog.
    const dl = m.querySelector('#PvProjectDelete');
    if (dl) dl.addEventListener('click', () => {
      if (dl.dataset.armed !== '1') {
        dl.dataset.armed = '1'; dl.textContent = 'Wirklich entfernen? Nochmals klicken';
        setTimeout(() => { if (dl.dataset.armed === '1') { delete dl.dataset.armed; pjRender(); } }, 6000);
        return;
      }
      delete dl.dataset.armed; dl.disabled = true;
      pjRemote({ action: 'delete' }).then(r => {
        if (r.status !== 200 || !r.json.ok) throw new Error('delete ' + r.status);
        pjSave([], { quiet: true });
        try { localStorage.removeItem(PJ_TITLE_KEY); localStorage.removeItem(PJ_TITLE_MOD_KEY); } catch (e) {}
        pjSyncSet({ version: 0, at: 0, token: '', ids: [], wer: pjIdentKey(), del: {} });
        pjSyncPulledAt = Date.now();
        dl.disabled = false;
        pjRender();
      }).catch(() => { dl.disabled = false; dl.textContent = 'Entfernen fehlgeschlagen – erneut versuchen'; setTimeout(pjRender, 3200); });
    });
    const ttl = m.querySelector('#PvProjectTitle');
    if (ttl) {
      try { ttl.value = localStorage.getItem(PJ_TITLE_KEY) || ''; } catch (e) {}
      // Der Name ist der Kopf der Karte: gespeichert bei jedem Zeichen, kein Extra-Knopf.
      ttl.addEventListener('input', () => {
        try { localStorage.setItem(PJ_TITLE_KEY, ttl.value.slice(0, 80)); localStorage.setItem(PJ_TITLE_MOD_KEY, String(Date.now())); } catch (e) {}
        pjSyncSchedule();
        // Header-Icon-Label folgt sofort (upd() im header.liquid hoert auf dieses Event)
        try { document.dispatchEvent(new Event('pv:project-changed')); } catch (e) {}
      });
      ttl.addEventListener('keydown', ev => { if (ev.key === 'Enter') { ev.preventDefault(); ttl.blur(); } });
    }
    const cta = m.querySelector('#PvProjectConsult');
    if (cta) cta.addEventListener('click', () => {
      const list = pjList();
      if (!list.length) return;
      const k = pjKond(list);
      // src 'kond' = Anfrage mit erreichter Schwelle (Messreihe seit 09.9), sonst 'project_modal'.
      pjKfgBeacon('consult', { src: k.erreicht ? 'kond' : 'project_modal', n: list.length, stk: k.stueck, konto: pjIdent() ? pjIdent().typ : 'anon' });
      try { if (typeof m.hide === 'function') m.hide(); else m.querySelector('.drawer__close-btn').click(); } catch (e) {}
      const label = list.length === 1
        ? (list[0].title || 'Ihre Konfiguration')
        : list.length + ' Konfigurationen aus Ihrem Projekt';
      const kondTxt = list.length + (list.length === 1 ? ' Position, ' : ' Positionen, ') + k.stueck + ' Stück' + (k.sum != null ? ', ' + pjFmt(k.sum) : '');
      setTimeout(() => pjOpenConsultForm(list, label, pjGetTitle(), false, { offerte: true, kond: k.erreicht, kondTxt: kondTxt }), 240);
    });
    return m;
  }

  // Preiszeile je Position: «2 × CHF 3'351 = CHF 6'702» bei Menge > 1, sonst der Stueckpreis.
  function pjMeta(it) {
    const one = pjSumNum([Object.assign({}, it, { qty: 1 })]);
    if ((it.qty || 1) > 1 && one != null) return it.qty + ' × ' + pjFmt(one) + ' = ' + pjFmt(one * it.qty);
    return it.price || '';
  }

  function pjRender() {
    const m = pjEnsureModal();
    const wrap = m.querySelector('#PvProjectItems');
    const list = pjList();
    if (!wrap) return;
    const leer = !list.length;
    const id = pjIdent();
    const kopf = m.querySelector('#PvProjectKopf'); if (kopf) kopf.hidden = leer;
    if (leer) {
      // Leerzustand (Beda 02.09. nachts): der Ort erklaert sich, der Weg fuehrt zu den Moebeln
      // (Kollektionen, Raeume) — nicht zur Tour, die ist fuer die Bedienung des Konfigurators.
      const ort = id ? (id.typ === 'kunde' ? ' Das Projekt liegt in Ihrem Konto, auf allen Geräten.' : ' Das Projekt liegt an Ihrem Partnerzugang, auf allen Geräten.') : ' Mit Ihrem Konto liegt es auf allen Geräten.';
      // F14 (Fremdaudit 11.09.2026): Auf einer konfigurierbaren Produktseite fuehrte die
      // Hauptaktion zurueck in die Kollektion — wer sein Moebel schon gefunden hatte, wurde
      // in die Suche geschickt. Jetzt traegt die Produktseite «Dieses Produkt konfigurieren»,
      // die allgemeine Seite behaelt «Moebel entdecken». Die leisen Wege bleiben in BEIDEN
      // Faellen stehen, damit das Stoebern nicht verschwindet (Gegenpruefung des Berichts).
      const pdpBtn = (function () { try { return getMainProductButtons()[0] || null; } catch (e) { return null; } })();
      // Steht der Konfigurator schon offen, ist «weiter» ehrlicher als «konfigurieren».
      const imKfg = !!(__activeModalState && __activeModalState.modal);
      const hauptAktion = pdpBtn
        ? '<button type="button" class="btn btn--primary pvpj__go" id="PvProjectConfigure"><span class="btn__text">'
          + (imKfg ? 'Weiter konfigurieren' : 'Dieses Produkt konfigurieren') + '</span></button>'
        : '<a class="btn btn--primary pvpj__go" href="/collections"><span class="btn__text">Möbel entdecken</span></a>';
      wrap.innerHTML = '<div class="pvpj__empty"><h3 class="h5">Ihr Projekt</h3>' +
        '<p>Hier sammeln Sie Konfigurationen für Ihr Vorhaben: im 3D-Konfigurator «Zum Projekt hinzufügen» wählen. Mengen, Notizen und ein Projektblatt als PDF kommen dazu.' + ort + '</p>' +
        hauptAktion +
        '<div class="pvpj__leise"><a href="/pages/raeume">Nach Räumen</a><span class="pvpj__dot">·</span><a href="/collections">Nach Kategorien und Marken</a></div></div>';
      // Verdrahtung nach JEDEM Aufbau: der Leerzustand wird bei jedem pjRender neu gesetzt.
      const cfgBtn = wrap.querySelector('#PvProjectConfigure');
      if (cfgBtn && pdpBtn) cfgBtn.addEventListener('click', () => {
        // Ein laufender Konfigurationszustand darf NICHT neu gestartet werden (Bericht F14):
        // bei offenem Konfigurator nur die Projektebene schliessen und zurueckkehren.
        const nochOffen = !!(__activeModalState && __activeModalState.modal);
        try { if (typeof m.hide === 'function') m.hide(); else m.querySelector('.drawer__close-btn').click(); } catch (e) {}
        if (nochOffen) return;
        // KEIN eigener Melde-Quellwert: ein neuer src braeuchte BEIDE Allowlists
        // (GA4 + analytics.py). openConfigurator meldet ueber pvKfgOpenSrcFuer selbst.
        setTimeout(() => { try { openConfigurator(pdpBtn); } catch (e) {} }, 240);
      });
    } else {
      wrap.innerHTML = list.map(it => {
        const d = new Date(it.at || Date.now());
        const dat = d.getDate() + '.' + (d.getMonth() + 1) + '.';
        const img = (typeof it.img === 'string' && it.img.indexOf('data:image/jpeg;base64,') === 0)
          ? '<img class="pvpj__img" alt="" src="' + pjEsc(it.img) + '">'
          : '<span class="pvpj__img"></span>';
        return '<div class="pvpj__item" data-pj-id="' + pjEsc(it.id) + '">' + img +
          '<div class="pvpj__t"><div class="pvpj__name">' + pjEsc(it.title || 'Konfiguration') + '</div>' +
          '<div class="pvpj__meta">' + pjEsc(pjMeta(it)) + '<span class="pvpj__dat"> · ' + pjEsc(dat) + '</span></div></div>' +
          '<a class="pvpj__open" href="' + pjEsc(it.link) + '" target="_blank" rel="noopener">Ansehen</a>' +
          '<button type="button" class="pvpj__rm" data-pj-remove="' + pjEsc(it.id) + '" aria-label="Entfernen">&times;</button>' +
          '<div class="pvpj__ctl"><span class="pvpj__qty"><button type="button" data-pj-qty="-1" aria-label="Menge verringern">−</button><input type="number" min="1" max="99" inputmode="numeric" value="' + it.qty + '" data-pj-qtyin aria-label="Menge"><button type="button" data-pj-qty="1" aria-label="Menge erhöhen">+</button></span>' +
          '<input type="text" class="pvpj__note" maxlength="120" placeholder="Raum / Bemerkung" value="' + pjEsc(it.note || '') + '" data-pj-note aria-label="Raum oder Bemerkung"></div></div>';
      }).join('');
    }
    const k = pjKond(list);
    // Kopf: Kennzahlen «3 Positionen · 7 Stück · CHF 10'076 inkl. MwSt.» — die Summe nur, wenn
    // alle Preise lesbar sind (lieber keine als eine falsche).
    const kenn = m.querySelector('#PvProjectKenn');
    if (kenn) kenn.textContent = leer ? '' : (list.length + (list.length === 1 ? ' Position' : ' Positionen') + ' · ' + k.stueck + ' Stück' + (k.sum != null ? ' · ' + pjFmt(k.sum) + ' inkl. MwSt.' : ''));
    // Ohne Identitaet: die Speichern-Karte (der Anreiz, sich zu erkennen zu geben). Mit Identitaet
    // und erreichter Schwelle: der Konditionen-Satz — ohne Zahlen auf der Karte (Beda E12); die
    // Schwelle selbst bleibt in PJ_KOND und wandert ins Projektblatt.
    const sv = m.querySelector('#PvProjectSave'); if (sv) sv.hidden = leer || !!id;
    // Geparkte Browserliste (B4): nur mit Identitaet, solange die Person nicht entschieden hat.
    const pend = pjPending();
    const pk = m.querySelector('#PvProjectPend');
    if (pk) {
      pk.hidden = !id || !pend;
      const ptx = m.querySelector('#PvProjectPendText');
      if (ptx && pend) ptx.textContent = 'Hier ' + (pend.items.length === 1 ? 'lag eine Konfiguration, die' : 'lagen ' + pend.items.length + ' Konfigurationen, die') + (id && id.typ === 'kunde' ? ' noch nicht in Ihrem Konto ' : ' noch nicht an Ihrem Partnerzugang ') + (pend.items.length === 1 ? 'ist' : 'sind') + '. Übernehmen Sie sie in Ihr Projekt oder verwerfen Sie sie.';
    }
    const dlb = m.querySelector('#PvProjectDelete'), dld = m.querySelector('#PvProjectDelDot');
    if (dlb) { dlb.hidden = leer || !id; if (dlb.dataset.armed !== '1') dlb.textContent = (id && id.typ === 'kunde') ? 'Aus dem Konto entfernen' : 'Vom Partnerzugang entfernen'; }
    if (dld) dld.hidden = leer || !id;
    const kb = m.querySelector('#PvProjectKond'); if (kb) kb.hidden = leer || !id || !k.erreicht;
    const cta = m.querySelector('#PvProjectCta'); if (cta) cta.hidden = leer;
    const leise = m.querySelector('#PvProjectLeise'); if (leise) leise.hidden = leer;
    const so = m.querySelector('#PvProjectShareOut'); if (so && leer) so.hidden = true;
    pjRenderSyncLine();
  }

  function pjOpenListModal() {
    pjRender();
    if (pjIdent() && Date.now() - pjSyncPulledAt > 60000) pjSyncPull('open');
    const m = pjEnsureModal();
    // Layer-Prinzip (Beda 02.08.): ueber dem offenen Konfigurator-Modal anzeigen.
    m.classList.toggle('pv-above-kfg', !!__activeModalState);
    const show = () => { try { if (typeof m.show === 'function') m.show(); } catch (e) {} };
    // 30 statt 150 ms: das Modal ist dank Idle-Vorbau unten laengst im DOM — nur noch
    // ein Frame Abstand fuer die Einblend-Transition (Beda 22.07. «hat etwas gedauert»).
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('basic-modal').then(() => setTimeout(show, 30));
    } else setTimeout(show, 30);
  }

  // Modal-DOM im Leerlauf vorbauen, damit der erste Klick ohne Bau-Verzoegerung oeffnet.
  // Header-Projekt-Icon (01.6): globaler Einstieg — laedt eine Seite dieses Script erst
  // durch den Icon-Klick nach, traegt __pvProjectOpenPending den Oeffnen-Wunsch hierher.
  try {
    (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () {
      try { pjEnsureModal(); } catch (e) {}
    });
  } catch (e) {}
  window.pvOpenProjectModal = pjOpenListModal;
  // Rueckkehr aus «Speichern mit Konto» (?pvsave=1, angemeldet): erst abgleichen, dann die Karte
  // mit der Bestaetigung oeffnen; den Parameter aus der Adresse nehmen.
  let __pvSaveReturn = false;
  try { const __id = pjIdent(); __pvSaveReturn = /[?&]pvsave=1(?:&|$)/.test(window.location.search) && !!(__id && __id.typ === 'kunde'); } catch (e) {}
  if (/[?&]pvsave=1(?:&|$)/.test(window.location.search)) {
    try { const u = new URL(window.location.href); u.searchParams.delete('pvsave'); history.replaceState(null, '', u.pathname + (u.search || '') + (u.hash || '')); } catch (e) {}
  }
  if (pjIdent()) {
    // Audit 03.09.2026 (B4): wem gehoert die Liste in diesem Browser?
    pjSaveReturn = __pvSaveReturn;
    try {
      const __st = pjSyncState(), __ik = pjIdentKey();
      if (__st.wer && __st.wer !== __ik) {
        // Andere Identitaet als beim letzten Abgleich: die alte Liste liegt an ihrem Konto oder
        // Zugang — hier weg damit, der Server der neuen Identitaet ist die Wahrheit. (Das Parken
        // einer noch nie abgeglichenen Liste sitzt in pjSyncPull, nach dem gelungenen get.)
        pjSave([], { quiet: true });
        try { localStorage.removeItem(PJ_TITLE_KEY); localStorage.removeItem(PJ_TITLE_MOD_KEY); } catch (e) {}
        pjPendingSet(null);
        pjSyncSet({ version: 0, at: 0, token: '', ids: [], wer: __ik, del: {} });
      }
    } catch (e) {}
    const __p = pjSyncPull('init');
    if (__pvSaveReturn) { pjSaveFrisch = true; __p.then(() => { try { pjOpenListModal(); } catch (e) {} }); }
  }
  if (window.__pvProjectOpenPending) {
    window.__pvProjectOpenPending = false;
    pjOpenListModal();
  }
  // Geteiltes Projekt empfangen (?pvproject=<id>): theme.liquid laedt dieses Script bei
  // solchen URLs vor; hier den Snapshot holen und dem Empfaenger anzeigen.
  try {
    const __pvSharedId = new URLSearchParams(window.location.search).get('pvproject') || '';
    if (PJ_PROJECT_ID_RE.test(__pvSharedId)) {
      fetch(PJ_SHARE_API + '?id=' + __pvSharedId)
        .then(r => (r.ok ? r.json() : null))
        .then(doc => { if (doc && Array.isArray(doc.items) && doc.items.length) pjOpenSharedModal(doc, __pvSharedId); })
        .catch(() => {});
    }
  } catch (e) {}

  function setupMessageListener() {
    window.addEventListener('message', e => {
      const data = e?.data;
      if (!data || !data.action) return;

      // Messages aus dem versteckten Listen-Warmup-iframe duerfen NIE Cart-
      // Aktionen oder Fehler-Alerts ausloesen — gleiche Origin wie der echte
      // Konfigurator, daher hart per source unterscheiden.
      if (__listWarmupIframe && e.source === __listWarmupIframe.contentWindow) return;

      if (!isTrustedMessageOrigin(e.origin)) {
        if (DEBUG_TIMING) {
          console.warn('[Configurator] Ignored postMessage from untrusted origin', {
            origin: e.origin,
            data
          });
        }

        return;
      }

      // Politur 20.07.: Cart-relevante Messages muessen aus dem AKTIVEN Modal-iframe
      // stammen (zusaetzlich zum Origin-Check) — schuetzt gegen fremde iframes
      // derselben Origin (haengender Warmup, verwaiste Frames).
      const isCartAction =
        data.action === 'add_product' ||
        data.action === 'replace_cart_line' ||
        data.action === 'cart_flow_started' ||
        data.action === 'cart_flow_failed' ||
        data.action === 'pv_metric';

      if (
        isCartAction &&
        __activeModalState &&
        __activeModalState.iframe &&
        __activeModalState.iframe.contentWindow &&
        e.source &&
        e.source !== __activeModalState.iframe.contentWindow
      ) {
        if (DEBUG_TIMING) {
          console.warn('[Configurator] Cart-Message von fremdem iframe ignoriert', data.action);
        }

        return;
      }

      // Eigene Ebene im Konfigurator auf/zu (07.5). Bewusst VOR der Flow-Erzeugung:
      // das ist ein reiner Zustandsmerker, kein Vorgang, der gemessen werden will.
      // Sichtbarkeits-Handschlag (30.08.): das Overlay fragt beim Boot, ob es gerade
      // wirklich zu sehen ist (Warmup = unsichtbar vorgewaermt). Antwort an den
      // FRAGENDEN Frame — nicht an «das aktive Modal», denn gefragt wird ja gerade
      // auch aus dem Warmup heraus. visibility vererbt sich vom Modal auf das iframe,
      // getClientRects deckt display:none-Ketten, data-pv-warming den Warmup-Marker.
      // PV 17.09.2026: Liefertage-Nachfrage des Konfigurators (ab 0.5.39) — Antwort an den
      // FRAGENDEN Frame, sobald der Wert von der Produktseite da ist (pvLiefertageAntworten).
      if (data.action === 'pv_ddq') {
        try { pvLiefertageAntworten(e.source); } catch (pvDdqErr) {}
        return;
      }

      if (data.action === 'pv_visq') {
        try {
          var pvVisIframe = Array.prototype.find.call(document.querySelectorAll('iframe'),
            function (f) { return f.contentWindow === e.source; });
          var pvVisSichtbar = false;
          if (pvVisIframe) {
            var pvVisCs = window.getComputedStyle(pvVisIframe);
            pvVisSichtbar = pvVisCs.visibility !== 'hidden'
              && pvVisIframe.getClientRects().length > 0
              && !pvVisIframe.closest('[data-pv-warming]');
          }
          if (e.source && e.source.postMessage) e.source.postMessage({ action: 'pv_vis', shown: pvVisSichtbar }, '*');
        } catch (pvVisqErr) {}
        return;
      }
      if (data.action === 'pv_overlay') {
        const ifr = __activeModalState && __activeModalState.iframe;
        const vomAktiven = !ifr || !ifr.contentWindow || !e.source || e.source === ifr.contentWindow;
        if (vomAktiven) __pvOverlayOpen = !!data.open;
        return;
      }

      const action = data.action;

      // Reentrancy-Guard (Review 20.07.): waehrend ein Cart-Flow laeuft, keine zweite
      // Cart-Aktion starten — doppelte add_product/replace-Messages wuerden sonst
      // parallel cart/add ausfuehren (Doppel-Position im Warenkorb).
      if (__cartFlowActive && (action === 'add_product' || action === 'replace_cart_line')) {
        if (DEBUG_TIMING) console.warn('[Configurator] Cart-Flow aktiv – doppelte Message ignoriert', action);
        return;
      }

      const flow = setActiveFlow(
        newFlow(action, {
          productId: data.product_id || null,
          quantity: data.quantity || 1,
          hasOldLineKey: !!(data.old_line_key || (__replaceCartContext && __replaceCartContext.lineKey))
        })
      );

      flowMark(flow, 'postMessage received', {
        action,
        data,
        origin: e.origin || ''
      });

      // --- Beratung & Projektliste (PV-Abschlusskarte, 21.07.): Aktionen nur vom
      // AKTIVEN Modal-iframe (gleicher Guard-Gedanke wie bei Cart-Messages).
      if (action === 'pv_ready' && e.source) {
        pjSendState(e.source); // Zaehlerzeile im iframe initial fuellen
      }

      if (action === 'pv_tour_done') {
        if (!pjFromPvIframe(e)) return;
        try { localStorage.setItem('pv_tour_done_v1', '1'); } catch (e2) {}
        return;
      }

      if (action === 'pv_consult') {
        if (!pjFromPvIframe(e)) return;
        const cLink = typeof data.link === 'string' && PJ_LINK_RE.test(data.link) ? data.link : '';
        if (!cLink) return;
        // kind 'muster' = Stoffmuster-CTA aus dem Material-Schritt (Beda 01.08.):
        // gleicher Beratungsweg, aber als Muster-Anliegen gekennzeichnet.
        const cMuster = data.kind === 'muster';
        // kind 'preis' (0.5.23, Beda 05.09.): «Unverbindlich anfragen» bei «Preis auf Anfrage» —
        // gleicher Beratungsweg, Anliegen als Preisanfrage gekennzeichnet.
        const cPreis = data.kind === 'preis';
        const cLabel = [data.title, data.price].filter(Boolean).join(' · ') || 'Ihre Konfiguration';
        // Konfigurator 0.5.43 (Beda 22.09.): beim Stoffmuster-Anliegen reicht der Konfigurator die gewaehlten
        // Stoffe mit (pvStoffListe: «Feld: Wert»). Nur Text, je Eintrag gekappt, hoechstens 8 — der Wortlaut
        // im Formular entsteht in pjOpenConsultForm.
        const cStoffe = cMuster && Array.isArray(data.stoffe)
          ? data.stoffe.map(s => String(s || '').replace(/\s+/g, ' ').trim().slice(0, 90)).filter(Boolean).slice(0, 8)
          : [];
        // Layer-Prinzip (Beda 02.08.): der Konfigurator bleibt OFFEN, das Formular
        // legt sich per pv-above-kfg darueber — nach Schliessen oder Senden steht
        // der Kunde wieder in seiner Konfiguration statt auf der nackten PDP.
        // (Der fruehere closeConfiguratorModal-Aufruf stammte aus der Zeit, als der
        // Theme-Drawer bei z-index 32 HINTER dem Konfigurator verschwand.)
        pjOpenConsultForm([cLink], String(cLabel).slice(0, 140), pjGetTitle(), cMuster, { slim: true, preis: cPreis, stoffe: cStoffe });
        return;
      }

      if (action === 'pv_project_add') {
        if (!pjFromPvIframe(e)) return;
        if (typeof data.link !== 'string' || !PJ_LINK_RE.test(data.link)) return;
        if (typeof data.id !== 'string' || !data.id) return;
        const pjL = pjList();
        if (!pjL.some(x => x.id === data.id)) {
          pjL.push({
            id: data.id.slice(0, 64),
            link: data.link,
            title: String(data.title || 'Konfiguration').slice(0, 120),
            price: String(data.price || '').slice(0, 40),
            img: (typeof data.img === 'string' && data.img.indexOf('data:image/jpeg;base64,') === 0 && data.img.length < 60000) ? data.img : '',
            qty: 1, note: '', mod: Date.now(),
            vendor: typeof data.vendor === 'string' ? data.vendor.slice(0, 60) : '',
            ban: typeof data.ban === 'string' ? data.ban.slice(0, 40) : '',
            at: Date.now()
          });
          pjSave(pjL);
          // Nur bei echtem Neuzugang: Header-Icon einmal pulsen lassen (Discoverability).
          try { document.dispatchEvent(new CustomEvent('pv:project-added')); } catch (e2) {}
        }
        pjSendState(e.source);
        // Beda 02.08.: die Projektliste oeffnet als Layer ueber dem offenen
        // Konfigurator — Bestaetigung UND naechster Schritt («Projekt besprechen»)
        // sind sofort sichtbar; der Konfigurator-Toast ist seit 0.4.21 weg.
        pjOpenListModal();
        return;
      }

      if (action === 'pv_project_open') {
        if (!pjFromPvIframe(e)) return;
        // Layer-Prinzip (Beda 02.08.): Konfigurator bleibt offen, Liste darueber.
        pjOpenListModal();
        return;
      }

      if (data.action === 'pv_fail') {
        // 30.08.: Fuer normale Produktstarts zeigt das Overlay eine EIGENE Fehlerkarte
        // und meldet noFallback — der fruehere Umschwenk auf pCon.ui endete am selben
        // Artikel in dessen Standardbild «Dieser Konfigurator ist nicht lizenziert»,
        // als haetten WIR ein Lizenzproblem (Beda-Befund). Umgeschwenkt wird nur noch
        // fuer Reopen alter pCon.ui-Belege (dort laesst das Overlay noFallback weg).
        if (data.noFallback) {
          try { flowMark(flow, 'pv_fail ohne pCon.ui-Fallback (eigene Karte im Overlay)', { reason: data.reason || '' }); } catch (pvNfErr) {}
          return;
        }
        // Startfehler im PV-Konfigurator (Katalog fehlt, Artikel nicht aufloesbar, Suche
        // mehrdeutig): im SELBEN Modal auf pCon.ui umschwenken statt Sackgasse (fail closed).
        // Das iframe wird ueber e.source identifiziert (mehrere Produkt-Modals moeglich),
        // der zugehoerige Button ueber die pid im URL-Fragment.
        try {
          const failedIframe = Array.from(document.querySelectorAll('iframe'))
            .find(f => f.contentWindow === e.source);

          if (failedIframe && String(failedIframe.src).indexOf(PV_KFG_ORIGIN) === 0) {
            const frag = new URLSearchParams(String(failedIframe.src).split('#')[1] || '');
            const pid = frag.get('pid') || '';
            const pidSafe = window.CSS && CSS.escape ? CSS.escape(pid) : pid.replace(/[^0-9]/g, '');
            const srcBtn = pid
              ? document.querySelector('.open-configuration[data-product-id="' + pidSafe + '"]')
              : null;
            const fallbackUrl = srcBtn ? buildPconUiUrlFromButton(srcBtn) : '';

            if (fallbackUrl) {
              flowMark(flow, 'pv_fail -> pCon.ui fallback', { pid, reason: data.reason || '' });
              failedIframe.src = fallbackUrl;
              return;
            }
          }
        } catch (pvFailErr) {
          console.warn('[pCon] pv_fail-Fallback nicht moeglich:', pvFailErr);
        }

        // Kein Fallback moeglich: Fehlermeldung des PV-Konfigurators stehen lassen.
        return;
      }

      if (data.action === 'pv_dryrun_ok') {
        // Testmodus des PV-Konfigurators (PV_OCI_LIVE=0 auf dem Server): Die Position
        // wurde serverseitig verbindlich geprueft, aber es entsteht bewusst KEIN
        // Shopify-Produkt und KEIN Cart-Add — klare Meldung statt stillem "geht nicht".
        __cartFlowActive = false;
        clearCartPreflightTimer();
        hideLoadingOverlay(true);
        showPvDryRunNotice(data.ref || '', data.priceCHF || '');
        clearActiveFlow(flow);

        return;
      }

      if (data.action === 'pv_metric') {
        // WARMUP-PHANTOM-GATE (20.08., Mobile-Absprung-Analyse): Metriken aus dem
        // globalen Modal-iframe zaehlen erst, wenn das Modal in diesem Seitenaufruf
        // wirklich offen war — der Vorwaermer meldete sonst open/close ohne jeden
        // Kundenklick. Der Listen-Warmup-iframe zaehlt nie. Sichtbare Einbettungen
        // (Demo-Seite) nutzen eigene iframes und laufen unveraendert durch. Die
        // verworfene Payload wird gemerkt: pvSendKfgOpen zieht daraus beim echten
        // (warmen) Oeffnen die praezisen cat/ban.
        let vomGlobalenModal = false;

        try {
          const srcWin = e.source || null;
          let phantom = false;

          if (__listWarmupIframe && srcWin && srcWin === __listWarmupIframe.contentWindow) {
            phantom = true;
          }

          try {
            const gm = document.getElementById(GLOBAL_MODAL_ID);
            const gmFrame = gm ? gm.querySelector('iframe[pcon-ui-iframe], iframe') : null;
            vomGlobalenModal = !!(gmFrame && gmFrame.contentWindow && srcWin && srcWin === gmFrame.contentWindow);
          } catch (gmErr) {}

          // 22.08.: Zustand statt DOM-Zuordnung. Eine iframe-Meldung zaehlt nur, wenn in
          // diesem Seitenaufruf wirklich geoeffnet wurde (Modal-Klick oder Demo-Open) ODER
          // sie aus einem SICHTBAREN iframe kommt. Ein Vorwaermer erfuellt beides nie. Das
          // alte Kriterium (vomGlobalenModal) griff beim Schliessen nicht mehr, weil das
          // Modal-Element zu diesem Zeitpunkt bereits entfernt ist.
          if (!phantom && !__pvKfgZaehlbar && !pvKfgQuelleSichtbar(srcWin)) {
            phantom = true;
          }

          if (phantom) {
            __pvKfgPrewarmLast = {
              metric: String(data.metric || '').replace(/[^a-z_]/g, '').slice(0, 24),
              n: Number(data.n) >= 0 ? Math.min(Number(data.n), 9999) : 0,
              cat: String(data.cat || '').slice(0, 24),
              ban: String(data.ban || '').slice(0, 40)
            };

            clearActiveFlow(flow);
            return;
          }
        } catch (gateErr) {}

        // Funnel first-party (Beda 20.07.): Konfigurator-Meilensteine cookielos an die
        // PMS-Analytics (/collect, Vertrag {t,src,sid,path,dwell,meta}). sessionStorage
        // ist kein Cookie und stirbt mit dem Tab — traegt nur eine Zufalls-Id und den
        // Zaehler «wievieltes Produkt in dieser Sitzung konfiguriert».
        try {
          let kfgSid = sessionStorage.getItem('pv_kfg_sid');

          if (!kfgSid) {
            kfgSid = window.crypto && crypto.randomUUID
              ? crypto.randomUUID()
              : String(Date.now()) + Math.random().toString(16).slice(2);
            sessionStorage.setItem('pv_kfg_sid', kfgSid);
          }

          let kfgNth = parseInt(sessionStorage.getItem('pv_kfg_nth') || '0', 10) || 0;

          const evt = String(data.metric || '').replace(/[^a-z_]/g, '').slice(0, 24);

          // kfg_open kommt seit 20.08. BEIM KLICK vom Theme (pvSendKfgOpen) — nur
          // sichtbare Einbettungen ohne Klick-Sender (Demo-Seite) zaehlen ihr
          // iframe-open weiterhin selbst. Nach einem echten Modal-Open zaehlt hier
          // gar nichts mehr (streunende opens ersetzter iframes, s. unten).
          if (evt === 'open' && !vomGlobalenModal && !__pvKfgEverOpened) {
            kfgNth += 1;
            sessionStorage.setItem('pv_kfg_nth', String(kfgNth));
            // Sichtbare Einbettung hat sich als echt ausgewiesen: ab jetzt zaehlen auch
            // ihre Folgemeldungen, selbst wenn das iframe spaeter nicht mehr messbar ist.
            __pvKfgZaehlbar = true;
          }

          // Letzten iframe-Stand fuer kfg_modal_close vormerken (jede pv_metric
          // traegt die aktuelle Aenderungszahl n mit).
          __pvKfgLast = {
            metric: evt,
            n: Number(data.n) >= 0 ? Math.min(Number(data.n), 9999) : 0,
            cat: String(data.cat || '').slice(0, 24),
            ban: String(data.ban || '').slice(0, 40)
          };

          // Modal-open NUR Standmeldung (kfg_open kam beim Klick; Ladezeit steht in
          // pcon_load_ok derselben Sitzung) — nichts doppelt senden. Die Payload wird
          // gemerkt: ein spaeterer WARMER Reuse zieht daraus die praezisen cat/ban
          // (sonst klebte der veraltete Warmup-Stand eines ANDEREN Produkts daran).
          // Nach einem echten Modal-Open zaehlen auch streunende opens ersetzter
          // iframes (recreateIframe) nicht mehr als Demo-Open.
          if (evt === 'open' && (vomGlobalenModal || __pvKfgEverOpened)) {
            if (vomGlobalenModal) {
              __pvKfgPrewarmLast = {
                metric: 'open',
                n: Number(data.n) >= 0 ? Math.min(Number(data.n), 9999) : 0,
                cat: String(data.cat || '').slice(0, 24),
                ban: String(data.ban || '').slice(0, 40)
              };
            }
            clearActiveFlow(flow);
            return;
          }

          const metaOut = {
            cat: String(data.cat || '').slice(0, 24),
            ban: String(data.ban || '').slice(0, 40),
            nth: kfgNth,
            n: Number(data.n) >= 0 ? Math.min(Number(data.n), 9999) : 0,
            err: String(data.err || '').slice(0, 120)
          };

          // Nur Demo-Einbettungen erreichen dieses open — Vokabular vollstaendig
          // halten (jedes kfg_open traegt warm+src): Demo ist nie vorgewaermt.
          if (evt === 'open') {
            metaOut.warm = 0;
            metaOut.src = 'demo';
          }

          if (evt && navigator.sendBeacon) {
            navigator.sendBeacon('https://pms.primovero.ch/collect', new Blob([JSON.stringify({
              src: 'shop',
              t: 'kfg_' + evt,
              sid: kfgSid,
              path: location.pathname,
              dwell: Number(data.dwell) > 0 ? Math.min(Number(data.dwell), 21600000) : null,
              meta: metaOut
            })], { type: 'text/plain' }));
          }

          try {
            if (evt && pvGa4Allowed()) {
              pvEnsureGa4();

              window.gtag('event', 'kfg_' + evt, {
                send_to: PV_GA4_ID,
                kfg_cat: String(data.cat || '').slice(0, 24),
                kfg_ban: String(data.ban || '').slice(0, 40),
                kfg_nth: kfgNth,
                kfg_changes: Number(data.n) >= 0 ? Math.min(Number(data.n), 9999) : 0,
                kfg_dwell_ms: Number(data.dwell) > 0 ? Math.min(Number(data.dwell), 21600000) : 0,
                kfg_err: String(data.err || '').slice(0, 100)
              });
            }
          } catch (ga4Err) {}
        } catch (metricErr) {}

        clearActiveFlow(flow);
        return;
      }

      // F17: Diese vier Nachrichten beenden die Speicherrunde.
      if (action === 'add_product' || action === 'replace_cart_line' || action === 'cart_flow_failed' || action === 'error') {
        __pvSpeicherRundeSeit = 0;
      }

      if (data.action === 'cart_flow_started') {
        // Fruehstart des Glass-Overlays ab Klick im Konfigurator (0.2.52+). Waehrend
        // eines echten Cart-Flows ignorieren (Doppelklick-Schutz). Sicherheitsnetz:
        // raeumt sich selbst ab, falls weder add_product noch cart_flow_failed folgt
        // (der Konfigurator bricht seinen Request selbst nach 30s ab).
        if (!__cartFlowActive) {
          clearCartPreflightTimer();
          __pvSpeicherRundeSeit = Date.now(); // F17: Speicherrunde laeuft

          __cartPreflightTimer = setTimeout(() => {
            __cartPreflightTimer = null;
            if (!__cartFlowActive) hideLoadingOverlay(true);
          }, 45000);

          showCartFlowStage(data.mode === 'replace' ? 'saving_replace' : 'saving');
        }

        clearActiveFlow(flow);
        return;
      }

      if (data.action === 'cart_flow_failed') {
        // Der Konfigurator meldet den Fehler selbst im iframe (Toast) — hier nur das
        // Overlay abraeumen, damit der Nutzer sofort weiterarbeiten kann.
        clearCartPreflightTimer();
        if (!__cartFlowActive) hideLoadingOverlay(true);
        clearActiveFlow(flow);
        return;
      }

      if (data.action === 'add_product') {
        clearCartPreflightTimer();
        showCartFlowStage('adding');

        requestAnimationFrame(() =>
          setTimeout(() => {
            addToCartAndPoll(data.product_id, data.quantity || 1, flow);
          }, 0)
        );
      } else if (data.action === 'replace_cart_line') {
        const oldLineKey =
          data.old_line_key ||
          (__replaceCartContext && __replaceCartContext.lineKey) ||
          '';

        const quantity =
          parseInt(data.quantity, 10) ||
          (__replaceCartContext && __replaceCartContext.quantity) ||
          1;

        flow.meta.oldLineKeyPresent = !!oldLineKey;
        flow.meta.quantity = quantity;

        clearCartPreflightTimer();
        showCartFlowStage('replacing');

        requestAnimationFrame(() =>
          setTimeout(() => {
            replaceCartLine(data.product_id, quantity, oldLineKey, flow);
          }, 0)
        );
      } else if (data.action === 'error') {
        console.error('[Configurator] Iframe/API error:', data.message || data);

        flowError(flow, 'iframe/api error message received', {
          message: data.message || null
        });

        flowSummary(flow, 'error', {
          message: data.message || null
        });

        __cartFlowActive = false;
        clearCartPreflightTimer();
        hideLoadingOverlay(true);
        destroyConfiguratorLoadUi(true);
        clearReplaceCartContext();
        clearActiveFlow(flow);

        alert('Es gab einen Fehler bei der Produktkonfiguration. Bitte versuchen Sie es erneut.');
      }
    });
  }

  setupMessageListener();

  async function pollCartForProduct(productId, attempt = 0, flow = null) {
    const maxAttempts = 20;
    const pollInterval = 500;

    if (attempt === 0) {
      flowMark(flow, 'pollCartForProduct start', {
        productId,
        maxAttempts,
        pollInterval
      });
    }

    if (attempt >= maxAttempts) {
      flowWarn(flow, 'pollCartForProduct exhausted; offering fallback confirm', {
        productId
      });

      __cartFlowActive = false;
      hideLoadingOverlay(true);
      clearReplaceCartContext();
      clearActiveFlow(flow);
      flowSummary(flow, 'fallback-confirm');

      sendFlowBeacon('poll_exhausted', {
        totalMs: flow ? flowElapsed(flow) : 0
      });

      if (confirm('Ihre Konfiguration wurde übermittelt, die Bestätigung des Warenkorbs dauert gerade länger als üblich. Zum Warenkorb wechseln und nachsehen?')) {
        showCartFlowStage('opening');
        window.location.href = buildShopifyUrl('cart');
      }

      return;
    }

    try {
      const cart = await getCart(flow);

      const found = Array.isArray(cart.items)
        ? cart.items.find(item => Number(item.variant_id) === Number(productId))
        : null;

      if (found) {
        flowMark(flow, 'variant visible in cart.js', {
          productId,
          attempt: attempt + 1,
          quantity: found.quantity,
          lineKey: found.key || ''
        });

        showCartFlowStage('opening');
        clearReplaceCartContext();

        sendFlowBeacon('add_success', {
          pollAttempts: attempt + 1,
          totalMs: flow ? flowElapsed(flow) : 0
        });

        flowMark(flow, 'redirect start', { to: buildShopifyUrl('cart') });
        flowSummary(flow, 'success');

        window.location.href = buildShopifyUrl('cart');

        return;
      }

      await sleep(pollInterval);
      await pollCartForProduct(productId, attempt + 1, flow);
    } catch (err) {
      flowWarn(flow, 'pollCartForProduct poll failed', {
        attempt: attempt + 1,
        error: String(err && err.message ? err.message : err)
      });

      if (attempt < maxAttempts - 1) {
        await sleep(pollInterval);
        await pollCartForProduct(productId, attempt + 1, flow);
      } else {
        __cartFlowActive = false;
        hideLoadingOverlay(true);
        clearReplaceCartContext();
        clearActiveFlow(flow);

        flowSummary(flow, 'poll-error-fallback', {
          error: String(err && err.message ? err.message : err)
        });

        if (confirm('Es gab ein Problem beim Überprüfen des Warenkorbs. Möchten Sie trotzdem zum Warenkorb gehen?')) {
          showCartFlowStage('opening');
          window.location.href = buildShopifyUrl('cart');
        }
      }
    }
  }

  async function addToCartAndPoll(productId, quantity = 1, flow = null) {
    try {
      __cartFlowActive = true;
      showCartFlowStage('adding');

      flowMark(flow, 'addToCart flow start', {
        productId,
        quantity
      });

      // Welle 3a (06.09.2026, FlatUp-Fall 05.09.): Wiederanlauf nach einem Neuladen schickt
      // denselben Idempotenzschluessel und bekommt dieselbe Variante zurueck - liegt sie
      // schon im Warenkorb, darf cart/add.js NICHT nochmals laufen (sonst Menge +1).
      // Dann direkt zum Poll, der die Line findet und den Erfolgsweg geht.
      let schonImKorb = false;
      try {
        const cartRes = await fetch(buildShopifyUrl('cart.js'), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        const cartJson = cartRes && cartRes.ok ? await cartRes.json() : null;
        schonImKorb = !!(cartJson && Array.isArray(cartJson.items) && cartJson.items.some((it) => Number(it.variant_id) === Number(productId)));
      } catch (e) {}
      if (schonImKorb) {
        flowMark(flow, 'variant already in cart - add skipped (reload-fest)', { productId });
        sendFlowBeacon('cart_add_skipped', { mode: 'add', reason: 'already-in-cart' });
        await pollCartForProduct(productId, 0, flow);
        return;
      }

      const addResult = await addVariantWithBackoff(productId, quantity, {
        // Erster Versuch frueh (Beacon-Daten: attempts=1 dominiert). Die
        // 6-stufige Treppe vergroessert das Propagationsfenster auf ~15.7s
        // nach Create (vorher ~12.3s) — Abbruch wegen "Produkt zu neu fuer
        // Shopify" wird damit UNwahrscheinlicher, nur der Happy Path schneller.
        initialDelayMs: 250,
        retryDelaysMs: [400, 800, 1600, 3200, 4500, 4500],
        label: 'addToCart',
        flow
      });

      sendFlowBeacon('cart_add_ok', {
        mode: 'add',
        attempts: addResult && addResult.attempts ? addResult.attempts : 1,
        msToAddOk: flow ? flowElapsed(flow) : 0
      });

      flowMark(flow, 'addToCart request chain successful', {
        productId,
        quantity
      });

      // Kein Vor-Sleep mehr: cart/add.js 200 bedeutet, die Line IST im Cart —
      // der erste Poll trifft sofort; bei Edge-Verzoegerung pollt die Schleife.
      await pollCartForProduct(productId, 0, flow);
    } catch (err) {
      console.error('[Configurator] Fatal error in addToCart flow:', {
        productId,
        quantity,
        error: err
      });

      flowError(flow, 'fatal addToCart flow error', {
        productId,
        quantity,
        error: String(err && err.message ? err.message : err)
      });

      flowSummary(flow, 'error', {
        productId,
        quantity,
        error: String(err && err.message ? err.message : err)
      });

      sendFlowBeacon('cart_add_fail', {
        mode: 'add',
        totalMs: flow ? flowElapsed(flow) : 0,
        error: String(err && err.message ? err.message : err).slice(0, 120)
      });

      __cartFlowActive = false;
      hideLoadingOverlay(true);
      clearReplaceCartContext();
      clearActiveFlow(flow);

      alert('Es gab einen Fehler beim Hinzufügen des Produkts zum Warenkorb. Bitte versuchen Sie es erneut.');
    }
  }

  async function replaceCartLine(updatedVariantId, quantity = 1, oldLineKey = '', flow = null) {
    try {
      __cartFlowActive = true;
      showCartFlowStage('replacing');

      const safeQuantity = Math.max(1, parseInt(quantity, 10) || 1);

      flowMark(flow, 'replaceCartLine flow start', {
        updatedVariantId,
        quantity: safeQuantity,
        oldLineKeyPresent: !!oldLineKey
      });

      const replaceAddResult = await addVariantWithBackoff(updatedVariantId, safeQuantity, {
        // Beacon-Daten (10.06.): attempts=1 bei allen Replace-Flows, der
        // cart/add selbst braucht nur ~460-840ms — der alte 1200ms-Vorlauf
        // war fast vollstaendig totes Warten. Gleiche 6-Stufen-Treppe wie im
        // Add-Flow haelt das Propagationsfenster groesser als vorher.
        initialDelayMs: 500,
        retryDelaysMs: [400, 800, 1600, 3200, 4500, 4500],
        label: 'replaceCartLine add',
        flow,
        properties: {
          _pv_rev: String(Date.now())
        }
      });

      sendFlowBeacon('cart_add_ok', {
        mode: 'replace',
        attempts: replaceAddResult && replaceAddResult.attempts ? replaceAddResult.attempts : 1,
        msToAddOk: flow ? flowElapsed(flow) : 0
      });

      flowMark(flow, 'replaceCartLine add successful', {
        updatedVariantId,
        quantity: safeQuantity
      });

      showCartFlowStage('replacing');

      await waitForVariantInCart(updatedVariantId, {
        maxAttempts: 24,
        pollInterval: 500,
        flow
      });

      if (oldLineKey) {
        flowMark(flow, 'old line removal start', {
          oldLineKey
        });

        const changeResponse = await changeCartLine(oldLineKey, 0);

        if (!changeResponse.ok) {
          const payload = await logHttpFailure('replaceCartLine remove', changeResponse, flow);
          const err = new Error(`replaceCartLine remove failed: HTTP ${changeResponse.status}`);
          err.responsePayload = payload;
          throw err;
        }

        flowMark(flow, 'old line removal ok', {
          oldLineKey,
          status: changeResponse.status
        });
      } else {
        console.warn('[Configurator] replaceCartLine: oldLineKey missing, skipping removal of previous line');

        flowWarn(flow, 'old line removal skipped', {
          reason: 'oldLineKey missing'
        });
      }

      showCartFlowStage('opening');
      clearReplaceCartContext();

      sendFlowBeacon('replace_success', {
        totalMs: flow ? flowElapsed(flow) : 0
      });

      flowMark(flow, 'redirect start', {
        to: buildShopifyUrl('cart')
      });

      flowSummary(flow, 'success');

      window.location.href = buildShopifyUrl('cart');
    } catch (err) {
      console.error('[Configurator] replaceCartLine failed:', {
        updatedVariantId,
        quantity,
        oldLineKey,
        error: err
      });

      flowError(flow, 'replaceCartLine failed', {
        updatedVariantId,
        quantity,
        oldLineKey,
        error: String(err && err.message ? err.message : err)
      });

      flowSummary(flow, 'error', {
        updatedVariantId,
        quantity,
        oldLineKey,
        error: String(err && err.message ? err.message : err)
      });

      sendFlowBeacon('replace_fail', {
        totalMs: flow ? flowElapsed(flow) : 0,
        error: String(err && err.message ? err.message : err).slice(0, 120)
      });

      __cartFlowActive = false;
      hideLoadingOverlay(true);

      const keepGoing = confirm(
        'Die Konfiguration wurde gespeichert, aber der Warenkorb konnte nicht vollständig aktualisiert werden. Möchten Sie trotzdem zum Warenkorb gehen?'
      );

      clearReplaceCartContext();
      clearActiveFlow(flow);

      if (keepGoing) {
        showCartFlowStage('opening');
        window.location.href = buildShopifyUrl('cart');
      }
    }
  }

  // 16.09.2026 (Beda): zweite Seitenlasche «Beratung anfragen» (#pv-sticky-consult) folgt der Konfigurator-Lasche.
  function pvStickyConsult(op) {
    // 17.09.2026: Dock (#pv-sticky-dock) statt Seitenlaschen — an, sobald die Konfigurator-Lasche gezeigt wird.
    const d = document.getElementById('pv-sticky-dock');
    if (d) d.classList.toggle('pv-dock--on', op === 'add');
    const c = document.getElementById('pv-sticky-consult');
    if (!c) return;
    if (op === 'hide') { c.style.display = 'none'; return; }
    c.style.removeProperty('display');
    c.classList[op]('show-sticky-button');
  }

  function initializeStickyButton() {
    const sticky = document.getElementById('sticky-button');
    if (!sticky) return null;

    if (sticky.hasAttribute('onclick')) {
      sticky.removeAttribute('onclick');
    }

    let currentTargetId = null;

    function isModalOpen() {
      // `data-pv-warming` = das Modal traegt zwar display:block, ist aber nur der
      // unsichtbare Vorwaerm-Zustand (s. GRAUE-BUEHNE-FIX) und gilt NICHT als offen.
      return $$(PCON_MODAL_SELECTOR).some(
        modal => modal.style.display === 'block' && !modal.hasAttribute('data-pv-warming')
      );
    }

    function getActiveButton() {
      if (currentTargetId) {
        const current = document.getElementById(currentTargetId);
        if (current) return current;
      }

      const btns = $$('.open-configuration');

      return btns.find(button => button.offsetParent !== null) || btns[0];
    }

    function checkVisibility() {
      const isProd = isProductPageContext();

      if (!isProd) {
        sticky.style.display = 'none'; pvStickyConsult('hide');
        sticky.classList.remove('show-sticky-button'); pvStickyConsult('remove');
        return;
      }

      sticky.style.removeProperty('display');

      const btn = getActiveButton();

      if (!btn) {
        sticky.classList.remove('show-sticky-button'); pvStickyConsult('remove');
        return;
      }

      const rect = btn.getBoundingClientRect();
      const headerH = $('header')?.offsetHeight || 0;
      const isAbove = rect.bottom < headerH + 20;

      if (isAbove && !isModalOpen()) {
        sticky.style.top = `${headerH + 15}px`;
        sticky.classList.add('show-sticky-button'); pvStickyConsult('add');
      } else {
        sticky.classList.remove('show-sticky-button'); pvStickyConsult('remove');
      }
    }

    sticky.addEventListener('click', event => {
      event.preventDefault();

      const btn = getActiveButton();

      // Klickquelle fuer kfg_open (Beda 20.08.): der Sticky proxied nur den
      // Hauptbutton — ohne Marker waere die Quelle nicht unterscheidbar.
      __pvKfgClickSrc = 'sticky';

      if (btn) btn.click();

      __pvKfgClickSrc = null;
    });

    // 16.09.2026: Beratungslasche -> Projektformular der Seite; sonst Anker #anfrage, sonst Kontaktseite.
    const consultTab = document.getElementById('pv-sticky-consult');
    if (consultTab && !consultTab.dataset.pvBound) {
      consultTab.dataset.pvBound = '1';
      consultTab.addEventListener('click', event => {
        event.preventDefault();
        const b = document.querySelector('.pv-project-inquiry-btn');
        if (b) { b.click(); return; }
        const a = document.getElementById('anfrage');
        if (a) { a.scrollIntoView({ behavior: 'smooth' }); return; }
        window.open('/pages/kontakt', '_blank', 'noopener');
      });
    }

    document.addEventListener('click', event => {
      const el = event.target.closest?.('.open-configuration');

      if (el && el.id) {
        currentTargetId = el.id;
      }
    });

    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          checkVisibility();
          ticking = false;
        });

        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('DOMContentLoaded', checkVisibility);
    window.addEventListener('load', checkVisibility);

    if (isProductPageContext()) {
      const mo = new MutationObserver(records => {
        // Selbst-Mutationen des Sticky-Buttons ignorieren (show/hide-Klassen
        // wuerden den Observer sonst als Echo erneut triggern).
        if (records.every(record => record.target === sticky || sticky.contains(record.target))) {
          return;
        }

        onScroll();
      });

      mo.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
    }

    checkVisibility();
    setTimeout(checkVisibility, 500);

    return {
      update: checkVisibility,
      setTargetId: id => {
        currentTargetId = id;
      }
    };
  }

  function recreateIframe(oldIframe) {
    if (!oldIframe || !oldIframe.parentNode) return oldIframe;

    const newIframe = document.createElement('iframe');

    Array.from(oldIframe.attributes).forEach(attr => {
      const name = attr.name.toLowerCase();

      if (name === 'src') return;
      if (name === 'data-pv-loaded-src') return;
      if (name === 'data-pv-requested-src') return;
      if (name === 'data-pv-warmup-src') return;

      newIframe.setAttribute(attr.name, attr.value);
    });

    newIframe.removeAttribute('src');
    oldIframe.parentNode.replaceChild(newIframe, oldIframe);

    return newIframe;
  }

  function resetGlobalIframe() {
    const modal = document.getElementById(GLOBAL_MODAL_ID);
    if (!modal) return;

    const iframe = modal.querySelector(`#${GLOBAL_IFRAME_ID}`);
    if (!iframe) return;

    recreateIframe(iframe);
  }

  function adjustModalContent(modal, iframeEl) {
    if (!modal || !iframeEl) return;

    const modalContent = modal.querySelector('.modal-content');
    if (!modalContent) return;

    const narrow = window.innerWidth <= 1024;
    // Phone = randlose Overlay-Karte (Beda 02.08., 2. Runde): erkennbar schwebend,
    // aber ohne den hellen 4px-Saum — ~10px Seitenluft, Innenleben fuellt die
    // Karte randlos (CSS-Query zieht Padding/Border/Lichtsaum auf 0).
    const phone = window.innerWidth <= 768;

    // iOS Safari: vh = GROSSER Viewport - 90vh ragt mit sichtbarer Toolbar unter
    // den Falz, und der Parent-Scroll ist ueber dem iframe per Touch unerreichbar.
    // dvh folgt der Toolbar live; aeltere Browser behalten 90vh. (iOS-Runde 2)
    const dvhOk = window.CSS && CSS.supports && CSS.supports('height', '90dvh');
    const modalH = dvhOk ? '90dvh' : '90vh';

    modalContent.style.width = phone ? 'calc(100% - 20px)' : (narrow ? '98%' : '90%');
    modalContent.style.maxHeight = modalH;
    modalContent.style.height = '';
    modalContent.style.overflowY = 'auto';
    iframeEl.style.height = modalH;
  }

  // ---------------------------------------------------------------------------
  // Lade-UI im Modal (gefuehlte Wartezeit):
  // Produktbild als Platzhalter + gestufte, an echte Meilensteine gebundene
  // Statustexte statt generischem Spinner. Liegt per z-index UNTER dem
  // Schliessen-X — Abbrechen bleibt waehrend des Ladens jederzeit moeglich.
  // Ende-Signale (fruehestes gewinnt): pCon-postMessage (App lebt), sonst
  // adaptiver Halt nach iframe-onload (kalte Loads brauchen danach Boot-Zeit,
  // warme sollen nicht kuenstlich warten). Harte Grenze bleibt der 30s-Timeout.
  // ---------------------------------------------------------------------------

  const PV_LOAD_STAGE_MIN_MS = 700;
  const PV_LOAD_ESCALATION_MS = 8000;

  let __pconLoadUi = null;

  function findProductImageForButton(btn) {
    try {
      const scopes = [];

      if (btn && btn.closest) {
        scopes.push(btn.closest('.product-card'));
        scopes.push(btn.closest('.cart-item'));
      }

      scopes.push(document.querySelector('[id^="MediaGallery-"]'));
      scopes.push(document.querySelector('.product__media-gallery, .product__media-wrapper'));

      for (let i = 0; i < scopes.length; i++) {
        const scope = scopes[i];
        if (!scope) continue;

        const img = scope.querySelector('img');
        const src = img ? img.currentSrc || img.src || '' : '';

        if (src) return src;
      }
    } catch (e) {}

    return '';
  }

  function setConfiguratorLoadStage(text, pct) {
    const ui = __pconLoadUi;
    if (!ui || !ui.statusEl) return;

    const apply = () => {
      if (__pconLoadUi !== ui) return;
      ui.statusEl.textContent = text;

      // Definierte Stufen statt Endlos-Welle (01.3): geht nie rueckwaerts.
      if (typeof pct === 'number' && ui.barSpan) {
        const cur = parseFloat(ui.barSpan.style.width) || 0;
        ui.barSpan.style.width = Math.max(cur, pct) + '%';
      }

      ui.lastStageAt = performance.now();
    };

    // Mindestanzeigedauer pro Stufe, damit Texte nicht flackern; nie rueckwaerts.
    const wait = ui.lastStageAt
      ? PV_LOAD_STAGE_MIN_MS - (performance.now() - ui.lastStageAt)
      : 0;

    if (ui.stageTimer) {
      clearTimeout(ui.stageTimer);
      ui.stageTimer = null;
    }

    if (wait > 0) {
      ui.stageTimer = setTimeout(apply, wait);
    } else {
      apply();
    }
  }

  function destroyConfiguratorLoadUi(immediate = false) {
    const ui = __pconLoadUi;
    if (!ui) return;

    __pconLoadUi = null;

    if (ui.stageTimer) clearTimeout(ui.stageTimer);
    if (ui.escalationTimer) clearTimeout(ui.escalationTimer);
    if (ui.fadeTimer) clearTimeout(ui.fadeTimer);
    if (ui.holdTimer) clearTimeout(ui.holdTimer);
    if (ui.maxHoldTimer) clearTimeout(ui.maxHoldTimer);

    if (ui.msgHandler) {
      window.removeEventListener('message', ui.msgHandler);
    }

    const el = ui.el;
    if (!el || !el.parentNode) return;

    if (immediate) {
      el.remove();
      return;
    }

    el.classList.add('is-hide');

    setTimeout(() => {
      if (el.parentNode) el.remove();
    }, 420);
  }

  // --- Verfuegbarkeits-Messung, ENTKOPPELT von der Lade-Optik (Befund 29.07.2026).
  // Vorher hing das Gesundheitssignal am Anzeige-Timer holdMs: lief der ab, bevor
  // das erste Lebenszeichen kam, wurde pcon_load_fail gemeldet, obwohl der
  // Konfigurator einwandfrei startete (gemessen: iframe 305 ms, hold-elapsed
  // 1043 ms -> fail, pv_ready erst 1175 ms). Jetzt zaehlt allein: kam innerhalb
  // PV_READY_TIMEOUT_MS ein Lebenszeichen aus dem iframe dieses Modals?
  //   ja   -> pcon_load_ok, sofort, egal ob die Ladeanimation noch laeuft
  //   nein -> pcon_load_fail, erst nach Ablauf des Zeitlimits
  // Bewusster Abbruch (Modal zu, keine URL, iframe-Reuse) beendet die Messung
  // STILL - wer wegklickt, ist keine Stoerung. beaconSent garantiert GENAU EIN
  // Beacon je Ladevorgang.
  // 22 s statt 9 s (iOS-Runde 2, 31.07.): pv_ready kommt am kalten iPhone erst
  // nach 5-20 s - bei 9 s zaehlte jeder langsame, aber gesunde Kaltstart als
  // Ausfall. 22 s liegt unter dem 25-s-UI-Sicherheitsnetz und dem 30-s-Doku-Timeout.
  const PV_READY_TIMEOUT_MS = 22000;

  let __pconLoadWatch = null;

  function sendPconLoadBeacon(watch, ok, grund) {
    if (!watch || watch.beaconSent) return;

    watch.beaconSent = true;

    try {
      if (!navigator.sendBeacon) return;

      // Gleiche Sitzungs-Id wie pjKfgBeacon und der pv_metric-Pfad, damit sich ein
      // Ausfall spaeter mit kfg_open/kfg_interact derselben Sitzung verbinden laesst.
      let sid = sessionStorage.getItem('pv_kfg_sid');
      if (!sid) {
        sid = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
        sessionStorage.setItem('pv_kfg_sid', sid);
      }

      navigator.sendBeacon('https://pms.primovero.ch/collect', new Blob([JSON.stringify({
        src: 'shop',
        t: ok ? 'pcon_load_ok' : 'pcon_load_fail',
        sid: sid,
        path: location.pathname,
        dwell: Math.round(performance.now() - watch.startedAt),
        meta: { reason: String(grund || '').slice(0, 40) }
      })], { type: 'text/plain' }));
    } catch (e) {}
  }

  function stopPconLoadWatch(watch) {
    const w = watch || __pconLoadWatch;
    if (!w) return;

    if (__pconLoadWatch === w) __pconLoadWatch = null;

    if (w.timer) {
      clearTimeout(w.timer);
      w.timer = null;
    }

    if (w.msgHandler) {
      window.removeEventListener('message', w.msgHandler);
      w.msgHandler = null;
    }
  }

  function failPconLoadWatch(grund) {
    const w = __pconLoadWatch;
    if (!w) return;

    sendPconLoadBeacon(w, false, grund);

    // iOS-Runde 2 (31.07.): NICHT stoppen. Der Listener bleibt bis Modalschluss
    // aktiv und meldet ein verspaetetes Lebenszeichen als Korrektur nach - sonst
    // bliebe jeder langsame, aber gesunde Kaltstart fuer immer ein Ausfall.
    if (w.timer) { clearTimeout(w.timer); w.timer = null; }
    w.failed = true;
  }

  // Abbruch WAEHREND des Ladens (20.08.): kein Ausfall, aber genau die Absprung-
  // Kohorte, um die es in der Mobile-Analyse geht — als eigenes Event gezaehlt
  // (dwell = gewartete ms, meta.reason = modal-close|pagehide). Ein bereits
  // gemeldeter Ausgang (ok/fail) wird nicht doppelt gemeldet. Der /collect-Endpoint
  // muss 'pcon_load_abort' in der SHOP_EVENTS-Allowlist fuehren, sonst verwirft er still.
  function abortPconLoadWatch(grund) {
    const w = __pconLoadWatch;
    if (!w) return;

    if (!w.beaconSent && !w.failed) {
      w.beaconSent = true;

      try {
        if (navigator.sendBeacon) {
          let sid = sessionStorage.getItem('pv_kfg_sid');

          if (!sid) {
            sid = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2);
            sessionStorage.setItem('pv_kfg_sid', sid);
          }

          navigator.sendBeacon('https://pms.primovero.ch/collect', new Blob([JSON.stringify({
            src: 'shop',
            t: 'pcon_load_abort',
            sid: sid,
            path: location.pathname,
            dwell: Math.round(performance.now() - w.startedAt),
            meta: { reason: String(grund || '').slice(0, 40) }
          })], { type: 'text/plain' }));
        }
      } catch (e) {}
    }

    stopPconLoadWatch(w);
  }

  // Gegenstueck zu failPconLoadWatch: Erfolg melden und die Uhr beenden. Wird beim
  // Wiederverwenden eines vorgewaermten iframes gebraucht — dort gibt es kein
  // pv_ready mehr (das kam schon waehrend des Vorwaermens), der Ladevorgang war
  // aber erfolgreich.
  function okPconLoadWatch(grund) {
    const w = __pconLoadWatch;
    if (!w) return;

    sendPconLoadBeacon(w, true, grund);
    stopPconLoadWatch(w);
  }

  function startPconLoadWatch(modal) {
    // Zweites Oeffnen: alte Runde still beenden, damit nie zwei Uhren laufen.
    stopPconLoadWatch(__pconLoadWatch);

    const watch = {
      modal: modal,
      startedAt: performance.now(),
      beaconSent: false,
      timer: null,
      msgHandler: null
    };

    __pconLoadWatch = watch;

    watch.msgHandler = function (event) {
      if (__pconLoadWatch !== watch) return;
      if (event.origin !== PCON_UI_ORIGIN && event.origin !== PV_KFG_ORIGIN) return;

      // Der versteckte Listen-Warmup laeuft auf derselben Origin und darf die
      // Messung des echten Ladevorgangs nicht faelschlich gruen faerben.
      if (__listWarmupIframe && event.source === __listWarmupIframe.contentWindow) return;

      // Nur Messages aus DEM iframe dieses Modals zaehlen - zur Laufzeit aufloesen,
      // weil recreateIframe das Element ersetzen kann.
      const frame = watch.modal
        ? watch.modal.querySelector('iframe[pcon-ui-iframe], iframe')
        : null;

      if (frame && event.source && event.source !== frame.contentWindow) return;

      // Erstes Lebenszeichen: der PV-Eigenkonfigurator meldet pv_ready, pCon.ui hat
      // kein Ready-Protokoll - dort gilt die erste Message ueberhaupt.
      const aktion = (event.data && event.data.action) || 'message';

      // Welle 2 (06.09.2026, Fremdaudit F03): der eigene Konfigurator meldet sich schon beim
      // Boot (pv_visq) und spaeter mit Kontroll-/Metrik-Nachrichten - keine davon heisst
      // «bereit». Bereit ist er erst mit pv_ready (erste Geometrie); pv_fail ist ein Fehler
      // mit Grund (WebGL, Startfehler). Vorher zaehlte JEDE Nachricht als pcon_load_ok.
      // pCon.ui (alter Weg) hat kein Ready-Protokoll - dort gilt weiter die erste Nachricht.
      if (event.origin === PV_KFG_ORIGIN) {
        if (aktion === 'pv_fail') {
          failPconLoadWatch('pv_fail:' + String((event.data && event.data.reason) || '').slice(0, 28));
          stopPconLoadWatch(watch);
          return;
        }
        if (aktion !== 'pv_ready') { watch.booted = true; return; }
      }

      if (watch.failed) {
        // Lebenszeichen NACH dem Fail-Beacon (Timer war zu frueh dran): genau EINE
        // Korrektur nachreichen - /collect kann fail+ok je sid paaren.
        watch.beaconSent = false;
        sendPconLoadBeacon(watch, true, 'late:' + aktion);
      } else {
        sendPconLoadBeacon(watch, true, aktion);
      }

      stopPconLoadWatch(watch);
    };

    window.addEventListener('message', watch.msgHandler);

    watch.timer = setTimeout(function () {
      if (__pconLoadWatch !== watch) return;
      // Welle 2: «gebootet, aber nach 22 s kein Modell» getrennt von «nie gemeldet».
      failPconLoadWatch(watch.booted ? 'ready-timeout-booted' : 'ready-timeout');
    }, PV_READY_TIMEOUT_MS);
  }

  function finishConfiguratorLoadUi(reason) {
    const ui = __pconLoadUi;
    if (!ui || ui.finishing) return;

    ui.finishing = true;

    sendFlowBeacon('open_cover_done', {
      ms: Math.round(performance.now() - ui.startedAt),
      reason: String(reason || '').slice(0, 40),
      loadMs: ui.onloadAt ? Math.round(ui.onloadAt - ui.startedAt) : -1
    });

    // KEIN Verfuegbarkeits-Beacon mehr an dieser Stelle (Befund 29.07.2026):
    // der Ausloeser 'hold-elapsed' ist ein reiner Anzeige-Timer und sagt nichts
    // ueber die Gesundheit der App. Gemessen wird getrennt in startPconLoadWatch().

    // Bei 'hold-max' ist die App NICHT bereit - kein falsches Versprechen.
    setConfiguratorLoadStage(reason === 'hold-max' ? 'Der Konfigurator uebernimmt …' : 'Gleich bereit …', 100);

    // kurzer "Gleich bereit"-Moment, dann Crossfade zum Konfigurator
    ui.fadeTimer = setTimeout(() => destroyConfiguratorLoadUi(false), 450);
  }

  function startConfiguratorLoadUi(modal, btn) {
    destroyConfiguratorLoadUi(true);

    // Gesundheitsmessung beginnt mit dem Ladevorgang und laeuft unabhaengig von
    // der Lade-Optik weiter - auch wenn die Animation laengst verschwunden ist.
    startPconLoadWatch(modal);

    const modalContent = modal ? modal.querySelector('.modal-content') : null;
    if (!modalContent) return;

    const imgSrc = findProductImageForButton(btn);

    const el = document.createElement('div');
    el.className = 'pv-pcon-load';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    el.innerHTML =
      (imgSrc
        ? '<img class="pv-pcon-load__img" alt="" src="' + imgSrc.replace(/"/g, '&quot;') + '">'
        : '') +
      '<div class="pv-pcon-load__panel">' +
      '<div class="pv-pcon-load__status"><span class="pv-pcon-load__status-text"></span></div>' +
      '<div class="pv-pcon-load__bar"><span></span></div>' +
      '<div class="pv-pcon-load__note" hidden></div>' +
      '</div>';

    modalContent.appendChild(el);

    el.classList.add('pv-pcon-load--staged');

    const ui = {
      el,
      modal,
      statusEl: el.querySelector('.pv-pcon-load__status-text'),
      barSpan: el.querySelector('.pv-pcon-load__bar span'),
      noteEl: el.querySelector('.pv-pcon-load__note'),
      startedAt: performance.now(),
      lastStageAt: 0,
      onloadAt: 0,
      finishing: false,
      stageTimer: null,
      escalationTimer: null,
      fadeTimer: null,
      holdTimer: null,
      maxHoldTimer: null,
      msgHandler: null
    };

    __pconLoadUi = ui;

    // Produktbezogener Einstieg («Moon wird vorbereitet …») wirkt persoenlicher und
    // gefuehlt schneller als der generische Katalog-Text (Beda 20.07., Psychologie-Pass).
    const loadTitle = (btn && btn.getAttribute('data-pv-title')) || '';

    setConfiguratorLoadStage(
      loadTitle ? loadTitle + ' wird vorbereitet …' : 'Kataloge werden geladen …',
      30
    );

    // Ehrliche Eskalation statt eingefrorenem Loader (lange Waits erklaeren)
    ui.escalationTimer = setTimeout(() => {
      if (__pconLoadUi !== ui || ui.finishing || !ui.noteEl) return;

      ui.noteEl.textContent =
        'Grosse 3D-Daten werden geladen — auf langsamer Verbindung dauert das einen Moment.';
      ui.noteEl.hidden = false;
    }, PV_LOAD_ESCALATION_MS);

    // Jede pCon-postMessage gilt als "App lebt" — fruehestes echtes Ready-Signal.
    // Der PV-Eigenkonfigurator sendet dafuer explizit pv_ready. Hier wird davon
    // NUR die Lade-Optik beendet; das Verfuegbarkeits-Signal haengt seit dem
    // 29.07.2026 an startPconLoadWatch() und ist von dieser Anzeige entkoppelt.
    ui.msgHandler = event => {
      if (__pconLoadUi !== ui) return;
      if (event.origin !== PCON_UI_ORIGIN && event.origin !== PV_KFG_ORIGIN) return;

      // Nur Messages aus DEM iframe dieses Modals zaehlen — zur Laufzeit
      // aufloesen, weil recreateIframe das Element ersetzen kann.
      const frame = ui.modal
        ? ui.modal.querySelector('iframe[pcon-ui-iframe], iframe')
        : null;

      if (frame && event.source && event.source !== frame.contentWindow) return;

      finishConfiguratorLoadUi('pcon-message');
    };

    window.addEventListener('message', ui.msgHandler);
  }

  function configuratorLoadUiOnIframeLoad() {
    const ui = __pconLoadUi;
    if (!ui || ui.finishing) return;

    ui.onloadAt = performance.now();
    setConfiguratorLoadStage('3D-Modell wird vorbereitet …', 70);

    // PV-Eigenkonfigurator: es gibt ein ECHTES Fertig-Signal (pv_ready bei erster
    // Geometrie; kalter iPhone-Start 5-20 s). Die Karte bleibt bis dahin stehen -
    // der alte Halte-Timer baute sie nach max. 2,6 s ab, der Kunde sah ZWEI
    // Ladebildschirme nacheinander (iOS-Runde 2, 31.07.). pCon.ui hat kein
    // Ready-Protokoll: dort bleibt der adaptive Halt unveraendert.
    const frame = ui.modal
      ? ui.modal.querySelector('iframe[pcon-ui-iframe], iframe')
      : null;
    const isPvKfg = !!(frame && String(frame.src || '').indexOf(PV_KFG_ORIGIN) === 0);

    if (ui.holdTimer) clearTimeout(ui.holdTimer);

    if (isPvKfg) {
      // Ehrliche Zwischenstufe statt eingefrorenem 70%-Balken bei langen Kaltstarts;
      // die Textnote nach 8 s (escalationTimer) laeuft unabhaengig weiter.
      ui.holdTimer = setTimeout(() => {
        if (__pconLoadUi !== ui || ui.finishing) return;
        setConfiguratorLoadStage('Fast fertig - 3D-Modell wird aufgebaut …', 88);
      }, 7000);

      // Sicherheitsnetz: kommt NIE ein Signal (pv_ready/pv_fail verschluckt), Karte
      // nach 25 s abbauen - darunter zeigt der Konfigurator seine eigene
      // Fehlerkarte mit Retry (geoFail).
      ui.maxHoldTimer = setTimeout(() => {
        if (__pconLoadUi !== ui) return;
        finishConfiguratorLoadUi('hold-max');
      }, 25000);

      return;
    }

    // Adaptiver Halt (nur noch pCon.ui): lange Dokument-Ladezeit = kalter Load =
    // die App braucht nach onload noch Boot-Zeit; warme Loads nicht kuenstlich warten.
    const docMs = ui.onloadAt - ui.startedAt;
    const holdMs = Math.max(500, Math.min(2600, Math.round(docMs * 0.6)));

    ui.holdTimer = setTimeout(() => {
      if (__pconLoadUi !== ui) return;
      finishConfiguratorLoadUi('hold-elapsed');
    }, holdMs);
  }

  let __modalInertedEls = [];
  let __modalReturnFocusEl = null;

  function openConfigurator(btn) {
    if (!btn) return;

    const data = getButtonConfiguratorData(btn);
    const productId = data.productId;

    if (!productId) return;

    // Klickquelle fuer kfg_open festhalten (Sticky/Reopen setzen den Marker).
    const openSrc = pvKfgOpenSrcFuer(btn);

    // Listen-Warmup-iframe sofort raeumen und kuenftige Warmups dieser Seite
    // stilllegen: Der echte Konfigurator-Load waermt den Cache selbst —
    // ein spaeter feuernder Warmup waere reine Verschwendung (plus eine
    // unnoetige EAIWS-Session).
    removeListWarmupIframe('configurator-open');
    __listWarmupStarted = true;
    markListWarmupMemo();

    const flow = DEBUG_TIMING
      ? newFlow('open_configurator', {
          productId,
          variantId: data.variantId || '',
          buttonId: btn.id || '',
          sku: data.sku || '',
          moc: data.moc || '',
          sid: data.sid || '',
          ovc: data.ovc || '',
          warmupStarted: __iframeWarmupStarted,
          warmupCompleted: __iframeWarmupCompleted
        })
      : null;

    flowMark(flow, 'openConfigurator start', {
      productId,
      buttonId: btn.id || null,
      warmupStarted: __iframeWarmupStarted,
      warmupCompleted: __iframeWarmupCompleted,
      warmupUrl: __iframeWarmupUrl
    });

    const cartContextFromButton = getCartContextFromButton(btn);

    if (cartContextFromButton && cartContextFromButton.lineKey) {
      __replaceCartContext = cartContextFromButton;
    } else {
      // Stale-Context-Schutz: Ohne Cart-Kontext am Button darf kein alter
      // Replace-Kontext (z.B. von einer zuvor geoeffneten Cart-Linie) weiterleben,
      // sonst wuerde eine fremde Konfiguration die alte Linie ersetzen.
      clearReplaceCartContext();
      hydrateReplaceCartContext();
    }

    const runtime = ensureGlobalModal();

    if (!runtime || !runtime.modal || !runtime.iframe) {
      console.warn('[Configurator] Globales pCon-Modal konnte nicht erzeugt werden', {
        productId,
        buttonId: btn.id || null
      });

      flowError(flow, 'global modal missing');
      flowSummary(flow, 'error-modal-missing');

      return;
    }

    const modal = runtime.modal;
    const iframe = runtime.iframe;

    closePredictiveSearch();

    // KEIN requestAnimationFrame hier: rAF friert in Hintergrund-Tabs ein — ein Klick
    // kurz vor einem Tab-Wechsel wuerde das Modal dann NIE oeffnen (Befund 17.07.,
    // erklaert auch sporadische «erster Klick tut nichts»-Beobachtungen).
    setTimeout(() => {
        stickyButtonController?.setTargetId(btn.id);

        lockBody(productId);
        warmPconConnections(flow);
        adjustModalContent(modal, iframe);

        const freshBaseUrl = buildFreshIframeUrl(btn, iframe);

        if (freshBaseUrl) {
          iframe.setAttribute('data-src', freshBaseUrl);
        }

        // Vorwaerm-Tarnung abstreifen (s. GRAUE-BUEHNE-FIX im Warmup): das Modal
        // hatte waehrend des Vorwaermens bereits Layout, war aber unsichtbar.
        modal.removeAttribute('data-pv-warming');
        modal.style.visibility = '';
        modal.style.pointerEvents = '';
        modal.style.display = 'block';
        modal.setAttribute('aria-hidden', 'false');

        // Sichtbarkeits-Handschlag (30.08.): dem Overlay sagen, dass der Kunde die
        // Buehne JETZT sieht — es haelt seine Einstiegsdrehung bis hierhin zurueck.
        // Im unsichtbaren Warmup lief sie sonst komplett ins Leere (Beda-Befund).
        try { if (iframe && iframe.contentWindow) iframe.contentWindow.postMessage({ action: 'pv_shown' }, PV_KFG_ORIGIN); } catch (pvVisErr) {}

        // Ausfahranimation (Beda 01.08.): display none->block poppte hart auf und
        // riss am Smartphone sichtbar (weisser Blitz im ersten Frame). Jetzt faehrt
        // die Karte in 320 ms aus (nur opacity/transform = Compositor, kein Layout);
        // «Bewegung reduzieren» schaltet sie CSS-seitig ab. Klasse wird nach der
        // Animation entfernt, damit ein Wieder-Oeffnen sie erneut abspielt.
        pvEnsureModalAnimCss();
        modal.classList.remove('pv-anim-in');
        void modal.offsetWidth;
        modal.classList.add('pv-anim-in');
        if (modal.__pvAnimT) clearTimeout(modal.__pvAnimT);
        modal.__pvAnimT = setTimeout(() => modal.classList.remove('pv-anim-in'), 480);

        ensureConfiguratorHelpButton(modal);
        maybeShowConfiguratorGuide(modal);

        // Modal reagiert sofort (<100ms); das Lade-UI im Modal ersetzt das
        // fruehere Vollbild-Overlay und blockiert das Schliessen-X nicht mehr.
        startConfiguratorLoadUi(modal, btn);

        __activeModalState = {
          modal,
          iframe,
          productId,
          productTitle: data.pvTitle || '',
          isGlobal: true,
          isProductPage: isProductPageContext()
        };

        // Start der Modal-Sitzung fuer kfg_modal_close (Verweildauer ab Sichtbarkeit).
        __pvKfgModalOpenedAt = Date.now();
        __pvKfgEverOpened = true; // ab jetzt zaehlen iframe-Metriken (Phantom-Gate)
        // 22.08.: Der Zaehlbar-Merker MUSS hier gesetzt werden. Sonst haengt jede
        // iframe-Meldung allein an der Sichtbarkeitspruefung — und beim Schliessen ist
        // das iframe bereits weg, wodurch auch ECHTE Meldungen verworfen wuerden.
        __pvKfgZaehlbar = true;
        __pvKfgLast = null;

        // Politur 20.07.: Hintergrund fuer Tastatur & Screenreader stilllegen (inert)
        // — das Cart-Overlay (#loadingDiv) bleibt aussen vor. Fokus wandert ins Modal
        // und kehrt beim Schliessen zum Ausloeser zurueck.
        __modalReturnFocusEl =
          document.activeElement && document.activeElement !== document.body
            ? document.activeElement
            : btn;
        __modalInertedEls = [];

        Array.from(document.body.children).forEach(el => {
          if (el === modal || el.contains(modal) || el.id === 'loadingDiv') return;
          if (el.inert) return;

          try {
            el.inert = true;
            __modalInertedEls.push(el);
          } catch (inertErr) {}
        });

        // Fokus auf den Dialog-Container statt aufs X (WAI-ARIA-Dialogmuster):
        // Tastatur/Screenreader landen im Modal, ohne Fokusring beim Maus-Oeffnen.
        try {
          modal.setAttribute('tabindex', '-1');
          modal.style.outline = 'none';
          modal.focus({ preventScroll: true });
        } catch (focusErr) {}

        if (!freshBaseUrl) {
          // Theme-/Datenproblem am Button, kein pCon-Ausfall: nicht als
          // Verfuegbarkeitsstoerung zaehlen (bleibt console.warn + flowError).
          // Der Klick war aber real — als kfg_open mit err zaehlen.
          pvSendKfgOpen(data, 0, openSrc, 'no-url');
          stopPconLoadWatch();
          hideLoadingOverlay(true);
          destroyConfiguratorLoadUi(true);

          console.warn('[Configurator] Keine aufbaubare Konfigurator-URL gefunden', {
            productId,
            buttonId: btn.id || null,
            data
          });

          flowError(flow, 'no configurator url');
          flowSummary(flow, 'error-no-url');

          stickyButtonController?.update();
          return;
        }

        const requestedUrl = normalizeConfiguratorUrlForCompare(freshBaseUrl);
        const loadedUrl = normalizeConfiguratorUrlForCompare(iframe.getAttribute('data-pv-loaded-src'));
        const currentSrc = normalizeConfiguratorUrlForCompare(iframe.getAttribute('src'));
        const requestedSrc = normalizeConfiguratorUrlForCompare(iframe.getAttribute('data-pv-requested-src'));
        const warmupSrc = normalizeConfiguratorUrlForCompare(iframe.getAttribute('data-pv-warmup-src'));

        // KEINE Groessen-Bedingung an der Wiederverwendung (Lehre 04.08., zweite
        // Runde): Eine «warmSize == openSize»-Sicherung schien vorsichtig, war aber
        // auf echten Geraeten fast IMMER falsch — die Browser-Toolbar aendert die
        // 90dvh-Hoehe des iframes zwischen Vorwaermen und Oeffnen um ~60px. Der
        // Mismatch fiel dann in den «gleiche URL laedt schon»-Zweig, der auf ein
        // load-Event wartet, das beim fertig geladenen Warm-iframe nie mehr kommt
        // -> 22s ready-timeout, 30s pCon.ui-Fallback (Beda-Befund 04.08. 02:43).
        // Groessenwechsel heilt der Konfigurator seit 0.4.22 selbst (viewer.resize
        // im ResizeObserver + NaN-Wache), eine Theme-Sicherung braucht es nicht.
        const canReuseIframe =
          iframe.contentWindow &&
          loadedUrl &&
          loadedUrl === requestedUrl &&
          !!currentSrc;

        const isSameUrlAlreadyLoading =
          iframe.contentWindow &&
          currentSrc &&
          currentSrc === requestedUrl &&
          requestedSrc === requestedUrl;

        const isDifferentWarmupRunning =
          warmupSrc &&
          warmupSrc !== requestedUrl;

        flowMark(flow, 'iframe state before open', {
          canReuseIframe: !!canReuseIframe,
          isSameUrlAlreadyLoading: !!isSameUrlAlreadyLoading,
          isDifferentWarmupRunning: !!isDifferentWarmupRunning,
          hasLoadedUrl: !!loadedUrl,
          hasCurrentSrc: !!currentSrc,
          warmupStarted: __iframeWarmupStarted,
          warmupCompleted: __iframeWarmupCompleted
        });

        if (canReuseIframe) {
          // Kein neuer Ladevorgang: das iframe ist bereits geladen (vorgewaermt).
          // Frueher wurde die Uhr hier nur STILL gestoppt — dadurch fehlte in der
          // Telemetrie zu jedem vorgewaermten Oeffnen sowohl pcon_load_ok als auch
          // pcon_load_fail. Genau diese Luecke liess die Ditch-Stoerung vom 03.08.
          // wie «nie bereit geworden» aussehen und verfaelscht die Ampel-Statistik.
          // Jetzt wird der Erfolg ehrlich gemeldet (Grund: reuse-warm).
          okPconLoadWatch('reuse-warm');
          // Warmes Oeffnen: kfg_open beim Klick, warm=1 (das iframe-open fiel
          // schon beim Vorwaermen ins Phantom-Gate).
          pvSendKfgOpen(data, 1, openSrc);
          hideLoadingOverlay(true);
          destroyConfiguratorLoadUi(true);

          flowMark(flow, 'iframe reused');
          flowSummary(flow, 'reuse-iframe', {
            resources: getPconResourceSnapshot(0).slice(-60)
          });

          stickyButtonController?.update();
          return;
        }

        // Kalter Ladevorgang beginnt: kfg_open beim Klick (warm=0). Ob er durchkommt,
        // melden pcon_load_ok/-abort/-fail getrennt.
        pvSendKfgOpen(data, 0, openSrc);

        // Fragment-Navigations-Schutz: pCon-URLs unterscheiden sich nur im
        // Hash. iframe.src mit gleichem Dokument-Teil waere eine reine
        // Fragment-Navigation OHNE Reload und OHNE load-Event — das Lade-UI
        // hinge bis zum Timeout und pCon bootet nicht mit den neuen Parametern
        // (im Warenkorb wuerde "Ersetzen" zu "Hinzufuegen").
        let targetIframe = iframe;

        if (
          currentSrc &&
          currentSrc !== requestedUrl &&
          currentSrc.split('#')[0] === requestedUrl.split('#')[0]
        ) {
          targetIframe = recreateIframe(iframe);

          if (__activeModalState && __activeModalState.modal === modal) {
            __activeModalState.iframe = targetIframe;
          }

          flowMark(flow, 'iframe recreated (fragment-only src change)');
        }

        const t0 = performance.now();
        const quietTracker = startPconNetworkQuietTracker(flow, 'open-pcon-network', {
          quietMs: 1400,
          maxMs: 30000,
          minMs: 1800
        });

        if (modal.__loaderTimeout) {
          clearTimeout(modal.__loaderTimeout);
          modal.__loaderTimeout = null;
        }

        modal.__loaderTimeout = setTimeout(() => {
          modal.__loaderTimeout = null;
          hideLoadingOverlay(true);
          destroyConfiguratorLoadUi(true);

          if (DEBUG_TIMING) {
            console.warn('[Configurator] Iframe loader timeout', {
              productId,
              buttonId: btn.id || null,
              warmupStarted: __iframeWarmupStarted,
              warmupCompleted: __iframeWarmupCompleted,
              warmupUrl: __iframeWarmupUrl
            });
          }

          flowWarn(flow, 'iframe loader timeout', {
            warmupStarted: __iframeWarmupStarted,
            warmupCompleted: __iframeWarmupCompleted
          });

          flowSummary(flow, 'iframe-timeout', {
            resources: getPconResourceSnapshot(flow ? flow.startedAt : 0).slice(-60)
          });

          // Review 20.07.: nicht stumm in einem leeren Modal enden — wie beim pv_fail-Pfad
          // auf den klassischen Konfigurator umschwenken (fail closed). Laedt bereits
          // pCon.ui oder gibt es keinen Fallback: Modal schliessen + ehrliche Meldung.
          try {
            const fallbackUrl = buildPconUiUrlFromButton(btn);
            if (targetIframe && fallbackUrl && String(targetIframe.src).indexOf(PCON_UI_ORIGIN) !== 0) {
              flowMark(flow, 'loader-timeout -> pCon.ui fallback');
              targetIframe.src = fallbackUrl;
              return;
            }
          } catch (fbErr) {}
          try { closeConfiguratorModal(modal); } catch (closeErr) {}
          alert('Der Konfigurator ist zurzeit nicht erreichbar. Bitte versuchen Sie es in einem Moment erneut.');
        }, 30000);

        targetIframe.onload = function () {
          if (modal.__loaderTimeout) {
            clearTimeout(modal.__loaderTimeout);
            modal.__loaderTimeout = null;
          }

          targetIframe.setAttribute('data-pv-loaded-src', requestedUrl);
          targetIframe.removeAttribute('data-pv-warmup-src');
          configuratorLoadUiOnIframeLoad();

          const elapsed = Math.round(performance.now() - t0);

          if (DEBUG_TIMING) {
            console.log('[Configurator] iframe onload in', elapsed, 'ms', {
              warmupStarted: __iframeWarmupStarted,
              warmupCompleted: __iframeWarmupCompleted,
              isSameUrlAlreadyLoading,
              quietTracker: !!quietTracker
            });
          }

          flowMark(flow, 'iframe onload', {
            elapsedMs: elapsed,
            warmupStarted: __iframeWarmupStarted,
            warmupCompleted: __iframeWarmupCompleted,
            isSameUrlAlreadyLoading: !!isSameUrlAlreadyLoading
          });

          flowSummary(flow, 'iframe-loaded', {
            iframeOnloadMs: elapsed,
            resources: getPconResourceSnapshot(flow ? flow.startedAt : 0).slice(-60)
          });
        };

        targetIframe.onerror = function () {
          // Harter Ladefehler des iframes = echter Ausfall: sofort melden, statt
          // PV_READY_TIMEOUT_MS abzuwarten. (Greift selten - Browser feuern bei
          // cross-origin-iframes meist 'load', auch bei HTTP-Fehlern.)
          failPconLoadWatch('iframe-error');
          destroyConfiguratorLoadUi(true);

          const elapsed = Math.round(performance.now() - t0);

          flowError(flow, 'iframe onerror', {
            elapsedMs: elapsed
          });

          flowSummary(flow, 'iframe-error', {
            iframeErrorMs: elapsed
          });
        };

        targetIframe.setAttribute('data-pv-requested-src', requestedUrl);

        if (isDifferentWarmupRunning) {
          targetIframe.removeAttribute('data-pv-warmup-src');
        }

        if (!isSameUrlAlreadyLoading) {
          flowMark(flow, 'iframe src set', {
            reusedLoadingRequest: false
          });

          targetIframe.src = requestedUrl;
        } else {
          flowMark(flow, 'iframe already loading requested url; src not reset', {
            reusedLoadingRequest: true
          });

          if (DEBUG_TIMING) {
            console.log('[Configurator] iframe already loading requested URL, not resetting src', {
              requestedUrl
            });
          }
        }

        stickyButtonController?.update();
      }, 0);
  }

  // Einmalige CSS-Injektion fuer die Modal-Ausfahranimation. Nur opacity/transform
  // (Compositor); Endzustand via `both` = neutral, die Klasse ist danach weg.
  function pvEnsureModalAnimCss() {
    if (document.getElementById('pv-modal-anim-css')) return;
    const st = document.createElement('style');
    st.id = 'pv-modal-anim-css';
    st.textContent = [
      '.modal.pv-anim-in{animation:pvModalFade .28s ease-out both}',
      '.modal.pv-anim-in .modal-content{animation:pvModalUp .32s cubic-bezier(.22,.9,.24,1) both;will-change:transform,opacity}',
      '@keyframes pvModalFade{from{opacity:0}to{opacity:1}}',
      '@keyframes pvModalUp{from{opacity:0;transform:translateY(26px) scale(.985)}to{opacity:1;transform:none}}',
      '@media (prefers-reduced-motion: reduce){.modal.pv-anim-in,.modal.pv-anim-in .modal-content{animation:none}}'
    ].join('\n');
    document.head.appendChild(st);
  }

  function closeConfiguratorModal(modal) {
    if (!modal) return;

    __pvOverlayOpen = false; // neue Modal-Sitzung startet ohne Alt-Zustand

    const state =
      __activeModalState && __activeModalState.modal === modal
        ? __activeModalState
        : {
            modal,
            iframe: modal.querySelector('iframe[pcon-ui-iframe], iframe'),
            productId: null,
            isGlobal: modal.id === GLOBAL_MODAL_ID,
            isProductPage: isProductPageContext()
          };

    // Modal-Sitzungsende messen, BEVOR aufgeraeumt wird (feuert nur, wenn ein
    // openConfigurator-Aufruf die Sitzung gestartet hat; Warmup zaehlt nicht).
    pvSendKfgModalClose('close');

    if (!__cartFlowActive) {
      hideLoadingOverlay(true);

      // Politur 20.07.: Beim Schliessen ohne laufenden Cart-Flow darf kein Replace-
      // Kontext einer Cart-Linie weiterleben (das naechste Produkt wuerde sonst die
      // alte Linie ersetzen). Reopen-Seiten hydrieren ihn beim naechsten Oeffnen neu.
      // F17: Waehrend der Speicherrunde (hoechstens 45 s) bleibt der Bearbeitungskontext stehen.
      if (!(__pvSpeicherRundeSeit && Date.now() - __pvSpeicherRundeSeit < 45000)) {
        clearReplaceCartContext();
      }
      clearCartPreflightTimer();

      if (__cartCreepTimer) {
        clearTimeout(__cartCreepTimer);
        __cartCreepTimer = null;
      }
    }

    // Abbruch durch den Kunden ist KEIN Ausfall — aber er wird seit 20.08. GEZAEHLT
    // (pcon_load_abort mit gewarteter Zeit): wer waehrend des Ladens schliesst, ist
    // exakt die Absprung-Kohorte der Mobile-Analyse. Die Ampel bleibt unberuehrt.
    abortPconLoadWatch('modal-close');

    if (__pconLoadUi) {
      if (!__pconLoadUi.finishing) {
        sendFlowBeacon('open_cover_abort', {
          ms: Math.round(performance.now() - __pconLoadUi.startedAt)
        });
      }

      destroyConfiguratorLoadUi(true);
    }

    if (modal.__loaderTimeout) {
      clearTimeout(modal.__loaderTimeout);
      modal.__loaderTimeout = null;
    }

    modal.style.display = 'none';
    // Reste des Vorwaerm-Zustands sicher abraeumen (s. GRAUE-BUEHNE-FIX): sonst
    // koennte ein geschlossenes Modal unsichtbar-markiert zurueckbleiben.
    modal.style.visibility = '';
    modal.style.pointerEvents = '';
    modal.removeAttribute('data-pv-warming');
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('pv-anim-in');
    if (modal.__pvAnimT) { clearTimeout(modal.__pvAnimT); modal.__pvAnimT = null; }

    unlockBody(state.productId);
    closePredictiveSearch();

    if (!state.isProductPage && state.isGlobal) {
      resetGlobalIframe();
    }

    if (__activeModalState && __activeModalState.modal === modal) {
      __activeModalState = null;
    }

    if (__modalInertedEls.length) {
      __modalInertedEls.forEach(el => {
        try { el.inert = false; } catch (inertErr) {}
      });

      __modalInertedEls = [];
    }

    if (__modalReturnFocusEl && document.contains(__modalReturnFocusEl)) {
      try { __modalReturnFocusEl.focus({ preventScroll: true }); } catch (focusErr) {}
    }

    __modalReturnFocusEl = null;

    stickyButtonController?.update();
  }

  let __initRunning = false;

  function initializeProductConfigurator() {
    if (__initRunning) return;

    __initRunning = true;

    try {
      dedupeBodyPconModals();
      ensureGlobalModal();

      if (!stickyButtonController) {
        stickyButtonController = initializeStickyButton();
      }

      $$('.open-configuration').forEach(btn => {
        if (btn.hasAttribute('data-initialized')) return;

        const productId = btn.getAttribute('data-product-id');
        if (!productId) return;

        btn.setAttribute('data-initialized', 'true');

        btn.addEventListener('click', event => {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }

          pvOeffnenMitLiefertagen(btn); // PV 17.09.2026: Liefertage abwarten (max. 1000 ms), dann oeffnen
        });
      });

      // PV 17.09.2026: das Skript laedt erst beim ersten Hover/Touch (theme.liquid) — der Knopf unter
      // der Maus bekommt seinen Liefertage-Vorgriff hier, nicht erst beim naechsten pointerover.
      try { $$('.open-configuration:hover').forEach(pvLiefertageVorholen); } catch (hoverErr) {}

      checkAndOpenReopenUrl();

      // Auch hier armen: Recently-Viewed & Co. rendern ihre Buttons erst NACH
      // window.load — boot/load-Handler sehen dann noch keine Buttons und
      // wuerden den Listen-Warmup sonst dauerhaft ueberspringen.
      if (!isProductPageContext()) {
        armListWarmup();
      }
    } finally {
      __initRunning = false;
    }
  }

  function checkAndOpenReopenUrl() {
    if (__reopenAutoTriggered) return;
    if (!isProductPageContext()) return;

    const hasUrlContext = hasExplicitReopenContext();
    const isHiddenReopenPage = isHiddenReopenProductPage();

    const shouldAutoOpen = hasUrlContext || isHiddenReopenPage;

    if (!shouldAutoOpen) return;

    let targetButton = null;
    const mainButtons = getMainProductButtons();

    if (hasUrlContext) {
      targetButton =
        mainButtons.find(btn => btn.hasAttribute('data-reopenurl')) ||
        mainButtons.find(btn => btn.hasAttribute('data-obx')) ||
        mainButtons[0] ||
        null;
    } else if (isHiddenReopenPage) {
      targetButton =
        mainButtons.find(btn => btn.hasAttribute('data-reopenurl')) ||
        mainButtons.find(btn => btn.hasAttribute('data-obx')) ||
        null;
    }

    if (!targetButton) return;

    __reopenAutoTriggered = true;

    setTimeout(() => {
      hydrateReplaceCartContext();
      // Auto-Reopen ist kein Knopf-Klick des Kunden: als Quelle markieren.
      __pvKfgClickSrc = 'reopen';
      targetButton.click();
      __pvKfgClickSrc = null;
    }, 180);
  }

  if (!window.configuratorResizeHandlerAdded) {
    window.configuratorResizeHandlerAdded = true;

    window.addEventListener(
      'resize',
      () => {
        const modal = document.getElementById(GLOBAL_MODAL_ID);
        if (!modal) return;

        const iframe = modal.querySelector('iframe[pcon-ui-iframe], iframe');

        if (iframe) {
          adjustModalContent(modal, iframe);
        }
      },
      { passive: true }
    );
  }

  function boot() {
    hydrateReplaceCartContext();
    initializeProductConfigurator();

    if (isProductPageContext()) {
      armProductIframeWarmup();
    } else {
      armListWarmup();
    }

    if (DEBUG_TIMING) {
      console.info('[ConfiguratorTiming] Debug aktiv. Auswertung mit pvConfiguratorTimingDump().');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {
      once: true
    });
  } else {
    boot();
  }

  window.addEventListener('load', () => {
    initializeProductConfigurator();

    if (isProductPageContext()) {
      armProductIframeWarmup();
    } else {
      armListWarmup();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    initializeProductConfigurator();

    if (isProductPageContext()) {
      armProductIframeWarmup();
    } else {
      armListWarmup();
    }
  });

  setTimeout(initializeProductConfigurator, 1000);

  document.addEventListener(
    'click',
    event => {
      const target = event.target.closest?.('.open-configuration');

      if (target && !target.hasAttribute('data-initialized')) {
        initializeProductConfigurator();

        if (target.hasAttribute('data-initialized')) {
          event.preventDefault();
          event.stopPropagation();
          target.click();
        }
      }
    },
    true
  );

  window.pvOpenConfigurator = openConfigurator;
  window.pvConfiguratorRefresh = initializeProductConfigurator;
})();

